import React from 'react';

export const LoginIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 22 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-32.000000, -1799.000000)"
                stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group">
                        <g transform="translate(25.000000, 1710.000000)">
                            <g id="logout" transform="translate(6.000000, 89.000000)">
                                <g transform="translate(2.000000, 1.000000)" id="Group">
                                    <g>
                                        <g id="ui-interface-user-user-interface-exit-logout">
                                            <path
                                                d="M12.9166667,4.58333333 L12.9166667,1.66666667 C12.9166667,0.976308167 12.3570252,0.416666667 11.6666667,0.416666667 L1.66666667,0.416666667 C0.976308167,0.416666667 0.416666667,0.976308167 0.416666667,1.66666667 L0.416666667,18.3333333 C0.416666667,19.0236918 0.976308167,19.5833333 1.66666667,19.5833333 L11.6666667,19.5833333 C12.3570252,19.5833333 12.9166667,19.0236918 12.9166667,18.3333333 L12.9166667,15.4166667"
                                                id="Path"></path>
                                            <path d="M5.41666667,10 L19.5833333,10" id="Path"></path>
                                            <polyline
                                                id="Path"
                                                points="14.5833333 5.41666667 19.5833333 10 14.5833333 14.5833333"></polyline>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const SyncIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        fill={props.color || 'white'}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <path
            d="M16.13,22A6.89,6.89,0,0,1,9.7,17.52a6.84,6.84,0,0,1,2.94-8.27l-.38,1.05a.61.61,0,0,0,.36.78.78.78,0,0,0,.21,0,.63.63,0,0,0,.58-.41l.88-2.42a.64.64,0,0,0,0-.47.57.57,0,0,0-.35-.31l-2.43-.85a.61.61,0,0,0-.4,1.16l1,.34a8.08,8.08,0,0,0,4,15.07.61.61,0,0,0,.61-.61A.61.61,0,0,0,16.13,22Z"
            transform="translate(-8.05 -6.63)"
        />
        <path
            d="M23.7,12.35a8.1,8.1,0,0,0-7.57-5.28.61.61,0,0,0,0,1.22A6.85,6.85,0,0,1,19.62,21L20,20a.6.6,0,0,0-.36-.78.62.62,0,0,0-.79.36L18,22a.59.59,0,0,0,0,.47.61.61,0,0,0,.35.32l2.44.84a.71.71,0,0,0,.2,0,.62.62,0,0,0,.58-.42.61.61,0,0,0-.38-.77l-1-.35A8.07,8.07,0,0,0,23.7,12.35Z"
            transform="translate(-8.05 -6.63)"
        />
    </svg>
);

export const HelpIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 23 23"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_LOTO_Web_Home" transform="translate(-29.000000, -415.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="support/off" transform="translate(2.200001, 302.000000)">
                                <g id="Group">
                                    <g id="wayfinding-sign-find-information">
                                        <circle id="Oval" cx="10.5" cy="5.25" r="1.3125"></circle>
                                        <polygon
                                            id="Path"
                                            points="8.3125 8.3125 11.8125 8.3125 11.8125 17.0625 9.1875 17.0625 9.1875 10.0625 8.3125 10.0625"></polygon>
                                        <circle id="Oval" cx="10.5" cy="10.5" r="10.0625"></circle>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const TwentyFourSevenIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        fill={props.color || 'white'}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M2315 5109 c-605 -62 -1147 -321 -1574 -750 -397 -399 -639 -897
        -723 -1484 -17 -118 -17 -512 0 -630 70 -493 249 -916 544 -1284 92 -115 271
        -295 387 -388 308 -249 714 -443 1081 -517 214 -43 295 -51 530 -51 236 0 333
        10 532 51 880 184 1614 842 1898 1702 92 278 125 491 125 802 0 301 -32 513
        -116 775 -124 390 -330 728 -622 1024 -399 404 -893 653 -1462 737 -123 18
        -478 26 -600 13z m635 -614 c262 -55 518 -163 718 -301 35 -24 66 -44 69 -44
        3 0 3 40 1 90 l-5 89 147 3 148 3 6 -35 c3 -19 6 -168 6 -332 l0 -296 -47 -6
        c-93 -12 -606 -56 -609 -53 -2 2 -9 53 -14 113 -6 60 -12 125 -15 146 l-5 36
        85 7 c47 4 85 10 85 14 0 10 -125 85 -225 134 -115 58 -231 98 -381 133 -112
        27 -132 28 -349 29 -201 0 -243 -3 -332 -23 -327 -72 -603 -217 -836 -441
        l-113 -109 -111 95 -112 96 37 45 c48 60 211 204 310 275 216 155 476 271 737
        326 164 36 220 40 455 36 197 -3 241 -7 350 -30z m520 -1252 c0 -5 -107 -314
        -239 -688 l-238 -680 -125 -3 -125 -3 241 691 241 690 123 0 c67 0 122 -3 122
        -7z m-2099 -199 c75 -23 118 -46 163 -90 59 -57 81 -114 81 -209 0 -120 -33
        -180 -172 -317 -59 -58 -126 -121 -147 -139 l-39 -34 194 -5 194 -5 0 -115 0
        -115 -397 -3 -398 -2 1 97 0 98 206 190 c225 208 263 254 263 323 0 56 -14 80
        -55 98 -71 29 -157 11 -219 -46 l-42 -39 -102 57 c-56 31 -102 63 -102 70 0
        23 104 119 158 146 29 15 76 33 105 41 73 19 240 19 308 -1z m1113 -31 c-9
        -16 -99 -145 -199 -288 -99 -143 -184 -266 -188 -272 -6 -10 16 -13 97 -13
        l106 0 0 90 0 90 135 0 135 0 0 -90 0 -90 80 0 81 0 -3 -112 -3 -113 -77 -3
        -78 -3 0 -99 0 -100 -140 0 -140 0 0 100 0 100 -275 0 -275 0 0 93 0 92 232
        323 232 322 149 0 149 0 -18 -27z m1846 -60 l-1 -88 -182 -425 -183 -425 -157
        -3 c-86 -1 -157 0 -157 4 0 3 75 178 166 388 91 209 168 387 171 394 4 9 -26
        12 -131 12 l-136 0 0 -80 0 -81 -122 3 -123 3 -3 193 -2 192 430 0 430 0 0
        -87z m-2587 -1485 c4 -24 9 -79 12 -123 3 -44 8 -92 11 -107 l5 -26 -85 -7
        c-47 -4 -86 -10 -86 -14 0 -10 123 -83 225 -134 116 -58 232 -98 381 -133 112
        -27 132 -28 349 -29 203 0 242 3 334 23 327 72 604 219 836 444 l111 107 112
        -96 112 -95 -46 -53 c-51 -60 -156 -156 -254 -232 -260 -202 -586 -338 -931
        -389 -156 -23 -488 -15 -633 15 -269 56 -510 153 -716 290 -47 31 -89 58 -94
        60 -5 2 -7 -35 -4 -87 l5 -91 -147 -3 -148 -3 -6 35 c-3 19 -6 169 -6 333 0
        231 3 297 13 298 6 0 143 13 302 28 160 16 302 29 316 30 24 1 27 -3 32 -41z"
            />
        </g>
    </svg>
);

export const ProgressIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 30}
        height={props.height || 30}
        viewBox="0 0 200.000000 200.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M1597 1562 c-10 -10 -17 -30 -17 -44 0 -40 28 -57 102 -60 l67 -3
        -194 -250 -195 -250 -43 3 c-24 2 -61 -4 -85 -13 l-42 -17 -102 70 -103 70 -6
        55 c-7 66 -33 114 -78 144 -91 61 -209 31 -259 -67 -19 -37 -22 -55 -18 -101
        l5 -56 -151 -139 c-86 -80 -158 -138 -167 -136 -72 12 -93 13 -124 3 -51 -17
        -87 -48 -108 -95 -25 -55 -24 -102 4 -156 66 -132 247 -132 315 0 19 37 22 55
        18 101 l-5 56 151 139 c86 80 158 138 167 136 80 -14 94 -13 137 3 l45 17 102
        -70 102 -70 6 -55 c7 -66 33 -114 78 -144 91 -61 209 -31 259 67 25 51 28 96
        8 144 l-14 33 182 234 181 234 5 -47 c7 -56 24 -78 61 -78 50 0 59 27 59 182
        0 185 7 178 -183 178 -127 0 -146 -2 -160 -18z m-757 -402 c11 -11 20 -29 20
        -40 0 -11 -9 -29 -20 -40 -11 -11 -29 -20 -40 -20 -11 0 -29 9 -40 20 -11 11
        -20 29 -20 40 0 11 9 29 20 40 11 11 29 20 40 20 11 0 29 -9 40 -20z m500
        -340 c11 -11 20 -29 20 -40 0 -11 -9 -29 -20 -40 -11 -11 -29 -20 -40 -20 -11
        0 -29 9 -40 20 -11 11 -20 29 -20 40 0 11 9 29 20 40 11 11 29 20 40 20 11 0
        29 -9 40 -20z m-1060 -180 c11 -11 20 -29 20 -40 0 -26 -34 -60 -60 -60 -26 0
        -60 34 -60 60 0 11 9 29 20 40 11 11 29 20 40 20 11 0 29 -9 40 -20z"
            />
        </g>
    </svg>
);

export const FirmwareUpdateIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 30}
        height={props.height || 30}
        viewBox="0 0 200.000000 200.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M611 1954 c-149 -40 -265 -153 -311 -302 -17 -54 -20 -57 -56 -64
        -59 -10 -88 -23 -128 -59 -58 -50 -80 -102 -80 -184 0 -80 20 -129 76 -182 68
        -66 79 -68 436 -71 l322 -3 0 -60 0 -59 -130 0 c-135 0 -180 -10 -193 -45 -5
        -11 -22 -15 -72 -15 l-65 0 0 -35 0 -35 60 0 60 0 0 -30 0 -30 -60 0 -60 0 0
        -30 0 -30 60 0 60 0 0 -30 0 -30 -60 0 -60 0 0 -35 0 -35 60 0 60 0 0 -30 0
        -30 -60 0 -60 0 0 -30 0 -30 60 0 60 0 0 -30 0 -30 -60 0 -60 0 0 -35 0 -35
        60 0 60 0 0 -30 0 -30 -60 0 -60 0 0 -30 0 -30 60 0 60 0 0 -30 0 -30 -60 0
        -60 0 0 -35 0 -35 65 0 c50 0 67 -4 72 -15 16 -42 44 -45 453 -45 409 0 437 3
        453 45 5 11 22 15 72 15 l65 0 0 35 0 35 -60 0 -60 0 0 30 0 30 60 0 60 0 0
        30 0 30 -60 0 -60 0 0 30 0 30 60 0 60 0 0 35 0 35 -60 0 -60 0 0 30 0 30 60
        0 60 0 0 30 0 30 -60 0 -60 0 0 30 0 30 60 0 60 0 0 35 0 35 -60 0 -60 0 0 30
        0 30 60 0 60 0 0 30 0 30 -60 0 -60 0 0 30 0 30 60 0 60 0 0 35 0 35 -65 0
        c-50 0 -67 4 -72 15 -13 35 -58 45 -193 45 l-130 0 0 59 0 59 298 4 c296 3
        297 3 353 29 118 55 184 160 184 289 -1 90 -27 152 -90 215 -65 65 -125 90
        -220 90 -44 0 -89 -5 -99 -12 -16 -9 -28 -4 -72 32 -28 24 -75 50 -104 60 -70
        23 -169 17 -233 -14 l-48 -23 -55 60 c-115 128 -276 178 -433 136z m247 -76
        c66 -25 162 -112 195 -177 l23 -48 38 33 c124 107 303 73 392 -74 1 -2 22 7
        46 19 59 31 147 31 211 0 128 -62 179 -216 112 -340 -16 -29 -43 -64 -60 -77
        -69 -52 -83 -54 -394 -54 l-290 0 -3 108 -3 107 -30 0 -30 0 -3 -357 -2 -358
        35 0 c19 0 35 -4 35 -10 0 -5 -26 -62 -57 -125 -36 -72 -63 -115 -73 -115 -10
        0 -37 43 -73 115 -31 63 -57 120 -57 125 0 6 16 10 35 10 l35 0 0 325 0 325
        -35 0 -35 0 0 -75 0 -75 -315 0 c-350 0 -358 1 -412 63 -109 124 -21 307 146
        307 l50 0 6 38 c25 147 99 250 219 303 97 43 192 45 294 7z m12 -1003 l0 -35
        -105 0 -105 0 0 -340 0 -340 340 0 340 0 0 340 0 340 -105 0 -105 0 0 35 0 35
        124 0 c100 0 128 -3 140 -16 14 -13 16 -63 16 -394 0 -331 -2 -381 -16 -394
        -13 -14 -63 -16 -394 -16 -331 0 -381 2 -394 16 -14 13 -16 63 -16 394 0 331
        2 381 16 394 12 13 40 16 140 16 l124 0 0 -35z m0 -125 c0 -30 -1 -30 -55 -30
        l-55 0 84 -167 c46 -93 93 -177 105 -187 27 -25 75 -25 102 0 12 10 59 94 105
        187 l84 167 -55 0 c-54 0 -55 0 -55 30 l0 30 75 0 75 0 0 -280 0 -280 -280 0
        -280 0 0 280 0 280 75 0 75 0 0 -30z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M619 1826 c-114 -40 -193 -135 -206 -247 l-6 -49 32 0 c27 0 31 3 31
        28 0 38 42 122 76 154 36 33 110 67 147 68 23 0 27 4 27 30 0 27 -3 30 -32 30
        -18 -1 -49 -7 -69 -14z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M1780 1395 c0 -29 -31 -76 -63 -95 -20 -13 -50 -20 -79 -20 -47 0
        -48 -1 -48 -30 0 -30 1 -30 53 -30 100 1 183 64 194 150 6 39 5 40 -26 40 -21
        0 -31 -5 -31 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M1470 1250 c0 -27 3 -30 30 -30 27 0 30 3 30 30 0 27 -3 30 -30 30
        -27 0 -30 -3 -30 -30z"
            />
        </g>
    </svg>
);

export const OutageIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        fill={props.color || 'white'}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200.000000 200.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M1130 1954 c-100 -27 -186 -89 -240 -174 l-32 -50 -72 0 c-89 0 -159
        -20 -224 -64 -45 -30 -58 -34 -141 -38 -75 -5 -103 -11 -154 -36 -80 -40 -150
        -110 -190 -192 -29 -59 -32 -73 -32 -160 0 -86 3 -101 31 -161 39 -81 85 -134
        153 -174 l51 -30 0 -411 c0 -305 3 -413 12 -422 17 -17 1399 -17 1416 0 9 9
        12 117 12 422 l0 411 51 30 c96 57 158 149 180 269 32 170 -60 349 -216 422
        -27 13 -55 24 -61 24 -7 0 -19 24 -29 53 -24 75 -56 126 -113 179 -110 103
        -258 141 -402 102z m211 -60 c122 -36 224 -142 250 -260 13 -60 10 -57 103
        -90 70 -25 148 -105 176 -181 50 -132 17 -279 -83 -369 -27 -24 -53 -44 -58
        -44 -5 0 -9 69 -9 154 0 85 -4 166 -10 180 l-10 26 -707 -2 -708 -3 -3 -177
        c-1 -113 -6 -178 -13 -178 -21 0 -112 96 -137 145 -18 36 -26 71 -30 125 -6
        105 22 175 97 251 75 74 145 102 251 98 68 -3 79 -1 110 23 83 62 118 73 229
        74 l105 0 22 40 c90 161 260 237 425 188z m-231 -724 l0 -80 -382 2 -383 3 -3
        78 -3 77 386 0 385 0 0 -80z m548 3 l-3 -78 -242 -3 -243 -2 0 80 0 80 245 0
        246 0 -3 -77z m2 -613 l0 -470 -660 0 -660 0 0 470 0 470 660 0 660 0 0 -470z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M1175 1841 c-84 -21 -177 -94 -205 -160 -25 -62 26 -88 56 -28 37 73
        93 114 184 132 48 10 55 14 55 36 0 20 -5 24 -30 26 -16 1 -43 -2 -60 -6z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M700 1601 c-42 -13 -84 -38 -109 -65 -20 -21 -22 -28 -11 -41 18 -21
        26 -19 77 18 41 29 53 32 122 34 42 1 79 2 84 3 4 0 7 11 7 24 0 16 -7 26 -22
        30 -31 8 -117 6 -148 -3z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M1584 1495 c-10 -26 2 -40 54 -58 87 -30 155 -136 139 -217 -8 -39 0
        -60 24 -60 64 0 46 173 -27 258 -59 70 -175 116 -190 77z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M247 1435 c-50 -50 -90 -138 -85 -189 2 -25 7 -31 28 -31 21 0 25 6
        32 45 12 69 27 97 75 140 48 42 54 73 17 78 -14 2 -36 -12 -67 -43z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M450 1170 l0 -30 280 0 280 0 0 30 0 30 -280 0 -280 0 0 -30z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M1250 1170 c0 -27 3 -30 30 -30 27 0 30 3 30 30 0 27 -3 30 -30 30
        -27 0 -30 -3 -30 -30z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M1380 1170 c0 -28 3 -30 35 -30 32 0 35 2 35 30 0 28 -3 30 -35 30
        -32 0 -35 -2 -35 -30z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M1520 1170 c0 -27 3 -30 30 -30 27 0 30 3 30 30 0 27 -3 30 -30 30
        -27 0 -30 -3 -30 -30z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M978 863 c-30 -33 -297 -583 -292 -598 9 -23 619 -23 628 0 3 8 -56
        139 -135 298 -132 264 -162 317 -179 317 -4 0 -14 -8 -22 -17z m140 -318 c61
        -124 112 -227 112 -230 0 -3 -103 -5 -230 -5 -126 0 -230 2 -230 5 0 10 225
        455 230 455 3 0 56 -101 118 -225z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M970 603 c0 -21 3 -68 7 -105 5 -55 9 -68 23 -68 19 0 30 58 30 158
        0 51 0 52 -30 52 -28 0 -30 -2 -30 -37z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M970 380 c0 -27 3 -30 30 -30 27 0 30 3 30 30 0 27 -3 30 -30 30 -27
        0 -30 -3 -30 -30z"
            />
        </g>
    </svg>
);

export const OldHomeIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 25 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill={props.fill || 'none'} fillRule="evenodd">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-27.000000, -114.000000)"
                fill={props.color || '#3D5F7B'}
                fillRule="nonzero">
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="home/off">
                                <g id="Group" transform="translate(0.000000, -5.000000)">
                                    <g id="home-icon">
                                        <g id="home-smart-lock-home" transform="translate(0.000000, 5.000000)">
                                            <path
                                                d="M12,8.9998779 C11.1728516,8.9998779 10.5,9.6727295 10.5,10.4998779 L10.5,10.9998779 L13.5,10.9998779 L13.5,10.4998779 C13.5,9.6727295 12.8271484,8.9998779 12,8.9998779 Z"
                                                id="Shape"></path>
                                            <path
                                                d="M23.828125,10.1224365 L12.328125,0.1224365 C12.140625,-0.0406494 11.859375,-0.0406494 11.671875,0.1224365 L0.171875,10.1224365 C0.0146484,10.2596435 -0.0410156,10.4798584 0.03125,10.6751709 C0.1044922,10.8704834 0.2910156,10.9998779 0.5,10.9998779 L3,10.9998779 L3,21.4998779 C3,21.7762451 3.2236328,21.9998779 3.5,21.9998779 L20.5,21.9998779 C20.7763672,21.9998779 21,21.7762451 21,21.4998779 L21,10.9998779 L23.5,10.9998779 C23.7089844,10.9998779 23.8955078,10.8704834 23.96875,10.6751709 C24.0410156,10.4798584 23.9853516,10.2596436 23.828125,10.1224365 Z M16.5,16.9998779 C16.5,17.5511474 16.0517578,17.9998779 15.5,17.9998779 L8.5,17.9998779 C7.9482422,17.9998779 7.5,17.5511474 7.5,16.9998779 L7.5,11.9998779 C7.5,11.4486084 7.9482422,10.9998779 8.5,10.9998779 L8.5,10.4998779 C8.5,8.5701904 10.0703125,6.9998779 12,6.9998779 C13.9296875,6.9998779 15.5,8.5701904 15.5,10.4998779 L15.5,10.9998779 C16.0517578,10.9998779 16.5,11.4486084 16.5,11.9998779 L16.5,16.9998779 Z"
                                                id="Shape"></path>
                                            <path
                                                d="M12,12.9998779 C11.4482422,12.9998779 11,13.4486084 11,13.9998779 C11,14.3652343 11.206604,14.6716919 11.5,14.8462524 L11.5,15.4998779 C11.5,15.7762451 11.7236328,15.9998779 12,15.9998779 C12.2763672,15.9998779 12.5,15.7762451 12.5,15.4998779 L12.5,14.8462524 C12.793396,14.6716919 13,14.3652343 13,13.9998779 C13,13.4486084 12.5517578,12.9998779 12,12.9998779 Z"
                                                id="Shape"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const HomeIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 24 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_Web_UI_Users" transform="translate(-28.000000, -114.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="home/off">
                                <g id="Group">
                                    <g id="home-smart-lock-home">
                                        <polygon
                                            id="Shape"
                                            points="12 0.5 0.5 10.5 3.5 10.5 3.5 21.5 20.5 21.5 20.5 10.5 23.5 10.5"></polygon>
                                        <g id="XMLID_1653_" transform="translate(8.000000, 7.000000)">
                                            <g id="XMLID_1642_" transform="translate(1.000000, 0.000000)">
                                                <path
                                                    d="M0,4.5 L0,3.5 C0,1.8431597 1.3431568,0.5 3,0.5 C4.6568365,0.5 6,1.8431597 6,3.5 L6,4.5"
                                                    id="XMLID_1643_"></path>
                                            </g>
                                            <path
                                                d="M0.5,4.5 L7.5,4.5 C7.7761421,4.5 8,4.7238579 8,5 L8,10 C8,10.2761421 7.7761421,10.5 7.5,10.5 L0.5,10.5 C0.2238579,10.5 0,10.2761421 0,10 L0,5 C0,4.7238579 0.2238579,4.5 0.5,4.5 Z"
                                                id="XMLID_1641_"></path>
                                            <circle id="XMLID_1639_" cx="4" cy="7" r="1"></circle>
                                            <path d="M4,7 L4,8.5" id="XMLID_1505_"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const LockIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 106.000000 172.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,172.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M440 1710 c0 -5 -9 -10 -20 -10 -80 0 -240 -160 -240 -240 0 -11 -4
        -20 -10 -20 -6 0 -10 -72 -10 -195 l0 -195 -68 0 c-40 0 -73 -5 -80 -12 -17
        -17 -17 -1009 0 -1026 17 -17 1019 -17 1036 0 17 17 17 1009 0 1026 -7 7 -42
        12 -85 12 l-73 0 0 189 c0 116 -4 192 -10 196 -5 3 -10 15 -10 25 0 48 -124
        209 -162 210 -7 0 -22 7 -32 15 -11 8 -30 15 -42 15 -13 0 -26 5 -29 10 -3 6
        -42 10 -86 10 -46 0 -79 -4 -79 -10z m139 -166 c120 -39 151 -108 151 -336 l0
        -158 -205 0 -205 0 0 169 c0 103 4 172 10 176 6 3 10 16 10 29 0 30 74 105
        111 113 16 3 32 10 35 14 8 13 39 11 93 -7z"
            />
        </g>
    </svg>
);

export const LockIconOld = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 17 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill={props.fill || 'none'} fillRule="evenodd">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-33.000000, -271.000000)"
                fill={props.color || '#3D5F7B'}
                fillRule="nonzero">
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="gateways/off" transform="translate(3.200001, 157.000000)">
                                <g id="Group" transform="translate(2.000000, 0.000000)">
                                    <g id="Tab-2">
                                        <g id="security-protection-protect-securel-lock-closed">
                                            <path
                                                d="M7.3840061,15.2243652 L7.08610027,17.8244222 C7.07134333,17.953776 7.11423074,18.0835774 7.20369466,18.1807048 C7.29315857,18.2778321 7.42135963,18.3333333 7.55555556,18.3333333 L9.44444444,18.3333333 C9.57864037,18.3333333 9.70684133,18.277832 9.79630534,18.1807048 C9.88576936,18.0835775 9.92865667,17.953776 9.91389973,17.8244222 L9.6159939,15.2243652 C10.0997451,14.8828532 10.3888889,14.3426107 10.3888889,13.75 C10.3888889,12.7388916 9.54174801,11.9166667 8.5,11.9166667 C7.45825199,11.9166667 6.61111111,12.7388916 6.61111111,13.75 C6.61111111,14.3426107 6.90025495,14.8828532 7.3840061,15.2243652 Z M8.5,12.8333333 C9.02064342,12.8333333 9.44444444,13.2446696 9.44444444,13.75 C9.44444444,14.1013591 9.23876957,14.4160156 8.90766057,14.5717774 C8.72734912,14.6568197 8.62174474,14.8421224 8.64388016,15.0350342 L8.91688363,17.4166667 L8.08311627,17.4166667 L8.35611974,15.0350342 C8.37825516,14.8421224 8.27265078,14.6568197 8.09233934,14.5717774 C7.76123043,14.4160156 7.55555556,14.1013591 7.55555556,13.75 C7.55555556,13.2446696 7.97935658,12.8333333 8.5,12.8333333 Z"
                                                id="Shape"></path>
                                            <path
                                                d="M16.5277778,8.25 L15.1111111,8.25 L15.1111111,6.41666667 C15.1111111,2.87845864 12.1454265,0 8.5,0 C4.85457355,0 1.88888889,2.87845864 1.88888889,6.41666667 L1.88888889,8.25 L0.472222222,8.25 C0.211208756,8.25 0,8.45499673 0,8.70833333 L0,20.1666667 C0,21.177775 0.847140883,22 1.88888889,22 L15.1111111,22 C16.1528591,22 17,21.177775 17,20.1666667 L17,8.70833333 C17,8.45499673 16.7887912,8.25 16.5277778,8.25 Z M2.83333333,6.41666667 C2.83333333,3.38378902 5.37521697,0.916666667 8.5,0.916666667 C11.624783,0.916666667 14.1666667,3.38378902 14.1666667,6.41666667 L14.1666667,8.25 L13.2222222,8.25 L13.2222222,6.41666667 C13.2222222,3.88956709 11.1036783,1.83333333 8.5,1.83333333 C5.89632165,1.83333333 3.77777778,3.88956709 3.77777778,6.41666667 L3.77777778,8.25 L2.83333333,8.25 L2.83333333,6.41666667 Z M12.2777778,8.25 L4.72222222,8.25 L4.72222222,6.41666667 C4.72222222,4.39489747 6.41696507,2.75 8.5,2.75 C10.5830349,2.75 12.2777778,4.39489747 12.2777778,6.41666667 L12.2777778,8.25 Z M16.0555556,20.1666667 C16.0555556,20.671997 15.6317545,21.0833333 15.1111111,21.0833333 L1.88888889,21.0833333 C1.36824547,21.0833333 0.944444444,20.671997 0.944444444,20.1666667 L0.944444444,9.16666667 L16.0555556,9.16666667 L16.0555556,20.1666667 Z"
                                                id="Shape"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const UnlockIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 106.000000 196.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,196.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M440 1950 c0 -5 -9 -10 -20 -10 -37 0 -95 -35 -152 -92 -32 -31 -58
        -62 -58 -70 0 -7 -7 -22 -15 -32 -8 -11 -15 -30 -15 -42 0 -13 -4 -26 -10 -29
        -6 -4 -10 -118 -10 -311 l0 -304 -66 0 c-43 0 -70 -5 -80 -14 -12 -12 -14 -95
        -14 -519 0 -451 2 -506 16 -511 20 -8 1008 -8 1028 0 14 5 16 60 16 511 0 424
        -2 507 -14 519 -12 12 -75 14 -370 14 l-356 0 0 284 c0 157 4 287 9 290 4 3
        11 18 14 33 11 50 60 92 144 123 51 19 117 -4 173 -60 62 -62 70 -96 70 -305
        l0 -175 80 0 80 0 0 209 c0 129 -4 212 -10 216 -5 3 -10 14 -10 24 0 48 -125
        210 -162 211 -7 0 -22 7 -32 15 -11 8 -30 15 -42 15 -13 0 -26 5 -29 10 -3 6
        -42 10 -86 10 -46 0 -79 -4 -79 -10z"
            />
        </g>
    </svg>
);

export const MicroChipIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 22 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_LOTO_Web_Home" transform="translate(-31.000000, -219.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="entries/off" transform="translate(3.200001, 105.000000)">
                                <g id="Group">
                                    <g id="microchip-processor-chip-cpu">
                                        <path
                                            d="M18,19.5 L4,19.5 C3.1715727,19.5 2.5,18.8284264 2.5,18 L2.5,4 C2.5,3.1715727 3.1715727,2.5 4,2.5 L18,2.5 C18.8284264,2.5 19.5,3.1715727 19.5,4 L19.5,18 C19.5,18.8284264 18.8284264,19.5 18,19.5 Z"
                                            id="XMLID_1392_"></path>
                                        <path d="M5,2.5 L5,0.5" id="XMLID_1399_"></path>
                                        <path d="M8,2.5 L8,0.5" id="XMLID_1400_"></path>
                                        <path d="M11,2.5 L11,0.5" id="XMLID_1401_"></path>
                                        <path d="M14,2.5 L14,0.5" id="XMLID_1402_"></path>
                                        <path d="M17,2.5 L17,0.5" id="XMLID_1404_"></path>
                                        <path d="M5,21.5 L5,19.5" id="XMLID_1422_"></path>
                                        <path d="M8,21.5 L8,19.5" id="XMLID_1410_"></path>
                                        <path d="M11,21.5 L11,19.5" id="XMLID_1407_"></path>
                                        <path d="M14,21.5 L14,19.5" id="XMLID_1406_"></path>
                                        <path d="M17,21.5 L17,19.5" id="XMLID_1405_"></path>
                                        <path d="M19.5,5 L21.5,5" id="XMLID_1438_"></path>
                                        <path d="M19.5,8 L21.5,8" id="XMLID_1437_"></path>
                                        <path d="M19.5,11 L21.5,11" id="XMLID_1436_"></path>
                                        <path d="M19.5,14 L21.5,14" id="XMLID_1435_"></path>
                                        <path d="M19.5,17 L21.5,17" id="XMLID_1434_"></path>
                                        <path d="M0.5,5 L2.5,5" id="XMLID_1433_"></path>
                                        <path d="M0.5,8 L2.5,8" id="XMLID_1432_"></path>
                                        <path d="M0.5,11 L2.5,11" id="XMLID_1431_"></path>
                                        <path d="M0.5,14 L2.5,14" id="XMLID_1430_"></path>
                                        <path d="M0.5,17 L2.5,17" id="XMLID_1398_"></path>
                                        <rect id="XMLID_1439_" x="4.5" y="4.5" width="13" height="13"></rect>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const SettingsIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 23 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-30.000000, -470.000000)"
                stroke={props.color || '#3D5F7B'}
                strokeWidth="0.916666667">
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="settings/off" transform="translate(2.800001, 356.000000)">
                                <g id="Group">
                                    <g id="settings-setup-set-gear-mechanic-2">
                                        <path
                                            d="M18.7916667,11 C18.7916667,10.5421143 18.7442779,10.0960897 18.6685231,9.65985616 L21.1835377,7.55500286 L19.0752156,3.90327456 L15.9997609,5.02711999 C15.3152262,4.45347595 14.5283609,4.00196839 13.6737416,3.6892141 L13.1083221,0.458333333 L8.89167785,0.458333333 L8.32625832,3.6892141 C7.47163899,4.00196839 6.68477379,4.45347595 6.00023902,5.02711999 L2.92478432,3.90327456 L0.816462167,7.55500286 L3.33147678,9.65985616 C3.25572207,10.0960897 3.20833333,10.5421143 3.20833333,11 C3.20833333,11.4578857 3.25572207,11.9039103 3.33147687,12.3401438 L0.816462167,14.4449412 L2.92478432,18.0966695 L6.00023902,16.9728801 C6.6847737,17.5464681 7.47163899,17.9980317 8.32625832,18.310786 L8.89167785,21.5416667 L13.1083221,21.5416667 L13.6737417,18.3107859 C14.528361,17.9980316 15.3152262,17.546468 15.999761,16.97288 L19.0752157,18.0966694 L21.1835378,14.4449411 L18.6685232,12.3401437 C18.7442779,11.9039103 18.7916667,11.4578857 18.7916667,11 Z"
                                            id="Shape"></path>
                                        <circle id="Oval" cx="11" cy="11" r="4.125"></circle>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const FileIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 21 19"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth={props.strokeWidth || 1}
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-30.000000, -168.000000)"
                stroke={props.color || '#3D5F7B'}
                strokeWidth={props.strokeWidth || 1}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="sites/on" transform="translate(1.200001, 51.000000)">
                                <g id="Group" transform="translate(2.000000, 3.000000)">
                                    <g id="office-note-notebook-paper-piece">
                                        <g id="XMLID_1344_">
                                            <path
                                                d="M18.5682065,14.25 L18.5681571,1.72727273 C18.5681571,1.01181296 17.9881617,0.431818182 17.2727026,0.431818182 L1.72724803,0.431818182 C1.01178826,0.431818182 0.431793482,1.01181296 0.431793482,1.72727273 L0.431793482,17.2727273 C0.431793482,17.9881864 1.01178826,18.5681818 1.72724803,18.5681818 L14.2499753,18.5681818 L18.5682065,14.25 Z"
                                                id="XMLID_1359_"></path>
                                            <path
                                                d="M14.2499753,18.5681818 L14.2499753,15.5454545 C14.2499753,14.8299954 14.829969,14.25 15.5454298,14.25 L18.5682065,14.25"
                                                id="XMLID_1354_"></path>
                                        </g>
                                        <path d="M4.75002513,2.15909091 L4.75002513,16.8409091" id="Path"></path>
                                        <path d="M2.15911604,4.75 L16.8409338,4.75" id="Path"></path>
                                        <path d="M2.15911604,9.5 L16.8409338,9.5" id="Path"></path>
                                        <path d="M2.15911604,14.25 L12.5227528,14.25" id="Path"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);


export const LockoutIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 23 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill={props.fill || 'none'} fillRule="evenodd">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-30.000000, -323.000000)"
                fill={props.color || '#3D5F7B'}
                fillRule="nonzero">
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="users/off" transform="translate(2.400001, 209.000000)">
                                <g id="Group">
                                    <g id="Tab-3">
                                        <g id="action-people-user-access-key">
                                            <path
                                                d="M19.25,14.6483155 C18.7446696,14.6483155 18.3333333,15.0596517 18.3333333,15.5649821 C18.3333333,16.0703125 18.7446696,16.4816488 19.25,16.4816488 C19.7553304,16.4816488 20.1666667,16.0703125 20.1666667,15.5649821 C20.1666667,15.0596517 19.7553304,14.6483155 19.25,14.6483155 Z"
                                                id="Shape"></path>
                                            <path
                                                d="M18.7916667,12.8333333 C18.0679678,12.8333333 17.4068756,13.0832011 16.8694865,13.4891103 C15.2070771,12.7468363 12.7579701,11.9166667 10.0833333,11.9166667 C6.94213868,11.9166667 4.09277339,13.040568 2.25585938,13.9836426 C0.864298508,14.6979981 0,16.1079101 0,17.6623942 L0,18.3333333 C0,19.3444417 0.822224975,20.1666667 1.83333333,20.1666667 L12.8333333,20.1666667 L12.8333333,21.5416667 C12.8333333,21.7950033 13.0383301,22 13.2916667,22 L14.6666667,22 C14.7884115,22 14.9047851,21.9516601 14.9907226,21.8657226 L17.7756347,19.0808106 C18.105957,19.1931559 18.4465739,19.25 18.7916667,19.25 C20.5605469,19.25 22,17.8105469 22,16.0416667 C22,14.2727865 20.5605469,12.8333333 18.7916667,12.8333333 Z M1.83333333,19.25 C1.32800296,19.25 0.916666667,18.8386637 0.916666667,18.3333333 L0.916666667,17.6623942 C0.916666667,16.453003 1.59029136,15.355957 2.67480473,14.7991536 C4.42175296,13.902181 7.12520343,12.8333333 10.0833333,12.8333333 C12.4344177,12.8333333 14.6182709,13.5225678 16.1823781,14.1882477 C15.8085276,14.7128245 15.5833333,15.3499705 15.5833333,16.0416667 C15.5833333,16.3867594 15.6401774,16.7273763 15.7525228,17.0576985 L13.5602214,19.25 L1.83333333,19.25 Z M18.7916667,18.3333333 C18.4720866,18.3333333 18.1556396,18.2639567 17.8521729,18.1269938 C17.6802979,18.049113 17.4748535,18.0858154 17.3396811,18.2205403 L14.4768881,21.0833333 L13.75,21.0833333 L13.75,20.3564453 L16.612793,17.4936523 C16.747518,17.3589273 16.7851156,17.1548258 16.7063396,16.9811604 C16.5693766,16.6776937 16.5,16.3612467 16.5,16.0416667 C16.5,14.7781168 17.5281168,13.75 18.7916667,13.75 C20.0552165,13.75 21.0833333,14.7781168 21.0833333,16.0416667 C21.0833333,17.3052165 20.0552165,18.3333333 18.7916667,18.3333333 Z"
                                                id="Shape"></path>
                                            <path
                                                d="M10.0833333,11 C13.116211,11 15.5833333,8.53287756 15.5833333,5.5 C15.5833333,2.46712244 13.1162109,0 10.0833333,0 C7.05045578,0 4.58333333,2.46712244 4.58333333,5.5 C4.58333333,8.53287756 7.05045578,11 10.0833333,11 Z M10.0833333,0.916666667 C12.6104329,0.916666667 14.6666667,2.97290043 14.6666667,5.5 C14.6666667,8.02709958 12.6104329,10.0833333 10.0833333,10.0833333 C7.55623376,10.0833333 5.5,8.02709958 5.5,5.5 C5.5,2.97290043 7.55623376,0.916666667 10.0833333,0.916666667 Z"
                                                id="Shape"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const UserIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 20 19"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-33.000000, -374.000000)"
                stroke={props.color || '#3D5F7B'}
                strokeWidth="0.863636364">
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="users/off" transform="translate(2.400001, 259.000000)">
                                <g id="Group" transform="translate(3.000000, 1.000000)">
                                    <g id="user-symbol-person-4">
                                        <circle id="XMLID_1366_" cx="9.5" cy="5.18181818" r="4.75"></circle>
                                        <path
                                            d="M9.5,11.6590909 C6.61892844,11.6590909 3.9978388,12.6990166 2.32294017,13.55894 C1.16410383,14.1539073 0.431818182,15.3381458 0.431818182,16.6407906 L0.431818182,17.2727273 C0.431818182,17.9881864 1.01181296,18.5681818 1.72727273,18.5681818 L17.2727273,18.5681818 C17.9881864,18.5681818 18.5681818,17.9881864 18.5681818,17.2727273 L18.5681818,16.6407906 C18.5681818,15.3381457 17.835896,14.1539073 16.6770598,13.5589399 C15.0021616,12.6990166 12.3810716,11.6590909 9.5,11.6590909 Z"
                                            id="XMLID_1368_"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const AddUserPlus = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: props.width || 24, height: props.height || 17 }}
        viewBox="0 0 23.31 15.86">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g id="_" data-name=" " style={{ isolation: 'isolate' }}>
                    <g style={{ isolation: 'isolate' }}>
                        <path
                            style={{ fill: props.fill || '#0070CE' }}
                            d="M20.5,7.17h2.81v.71H20.5v3.06h-.77V7.88H17V7.17h2.75v-3h.77Z"
                        />
                    </g>
                </g>
                <path
                    style={{ fill: props.fill || '#0070CE', fillRule: 'evenodd' }}
                    d="M7.93,8.31A4.16,4.16,0,1,0,3.78,4.15,4.16,4.16,0,0,0,7.93,8.31Z"
                />
                <path
                    style={{ fill: props.fill || '#0070CE', fillRule: 'evenodd' }}
                    d="M14.22,11.48A14.24,14.24,0,0,0,7.93,9.82a14.23,14.23,0,0,0-6.28,1.66A3,3,0,0,0,0,14.18v.55a1.13,1.13,0,0,0,1.13,1.13h13.6a1.13,1.13,0,0,0,1.14-1.13v-.55A3,3,0,0,0,14.22,11.48Z"
                />
            </g>
        </g>
    </svg>
);

export const NewsIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 26 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth={props.strokeWidth || 1}
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-287.000000, -1357.000000)"
                stroke={props.color || '#3D5F7B'}>
                <g
                    id="newspaper-news-subscribe-publication-content-copywriting"
                    transform="translate(288.000000, 1357.000000)">
                    <g id="XMLID_1379_">
                        <path
                            d="M3.4999709,3.5 L0.4999709,3.5 L0.4999709,16 C0.4999709,16.8284264 1.1715438,17.5 1.9999709,17.5 L22.0000281,17.5 C22.8284564,17.5 23.5000281,16.8284264 23.5000281,16 L23.5000281,0.5 L3.4999714,0.5 L3.4999714,16 C3.4999714,16.8284264 2.8283985,17.5 1.9999713,17.5"
                            id="XMLID_1385_"></path>
                    </g>
                    <rect id="XMLID_1380_" x="5.4999709" y="7.5" width="7" height="8"></rect>
                    <path d="M14.4999704,8.5 L21.4999714,8.5" id="XMLID_1400_"></path>
                    <path d="M14.4999704,11.5 L21.4999714,11.5" id="XMLID_1401_"></path>
                    <path d="M14.4999704,14.5 L21.4999714,14.5" id="XMLID_1402_"></path>
                    <rect id="Rectangle" x="5.4999709" y="2.5" width="16" height="3"></rect>
                </g>
            </g>
        </g>
    </svg>
);

export const MachineIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 24 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g
                id="Noke_LOTO_Web_Home"
                transform="translate(-985.000000, -869.000000)"
                stroke={props.color || '#3D5F7B'}>
                <g
                    id="farm-tractor-farm-vehicle-tractor-agriculture-farming"
                    transform="translate(986.000000, 870.000000)">
                    <path
                        d="M16.9583333,6.75 L16.9583333,2.2499991 C16.9583333,1.75294332 17.3687377,1.35 17.8750017,1.35 L17.8750017,1.35"
                        id="Path"></path>
                    <path d="M11.4583333,6.75 L0.916666667,6.75000261" id="Path"></path>
                    <g id="Group">
                        <path
                            d="M20.5787862,14.85 L21.5416667,14.85 L21.5416667,8.1 C21.5416667,7.35441543 20.9260575,6.75 20.1666667,6.75 L11.4583333,6.75 L9.90993107,1.42912647 C9.74127669,0.84956931 9.20174576,0.45 8.58783512,0.45 L2.65528881,0.45 C1.93391064,0.45 1.33517927,0.99735408 1.28378323,1.70381637 L0.458333333,13.05"
                            id="Path"></path>
                        <path d="M9.23805749,14.85 L14.2545471,14.85" id="Path"></path>
                        <path
                            d="M0.505274458,13.5072509 C0.489384958,13.3547607 0.458333333,13.2066101 0.458333333,13.05 L0.458333333,13.5 L0.505274458,13.5072509 Z"
                            id="Path"></path>
                    </g>
                    <ellipse id="Oval" cx="5.04166667" cy="13.05" rx="1.83333333" ry="1.8"></ellipse>
                    <ellipse id="Oval" cx="17.4166667" cy="14.4" rx="1" ry="1"></ellipse>
                    <ellipse id="Oval" cx="5.04166667" cy="13.05" rx="4.58333333" ry="4.5"></ellipse>
                    <ellipse id="Oval" cx="17.4166667" cy="14.4" rx="3.20833333" ry="3.15"></ellipse>
                </g>
            </g>
        </g>
    </svg>
);

export const ClientIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 19 21"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_LOTO_Web_Home" transform="translate(-34.000000, -373.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="users/off" transform="translate(2.400001, 259.000000)">
                                <g id="Group" transform="translate(4.000000, 1.000000)">
                                    <g id="people-user-location-pin">
                                        <ellipse
                                            id="XMLID_1425_"
                                            cx="9"
                                            cy="5.41666667"
                                            rx="2.45454545"
                                            ry="2.5"></ellipse>
                                        <path
                                            d="M9,9.58333333 C7.31034957,9.58333333 5.77316872,10.2104815 4.79089702,10.7290761 C4.11127904,11.0878833 3.68181818,11.8020614 3.68181818,12.5876483 L3.68181818,12.96875 C3.68181818,13.4002225 4.02196557,13.75 4.44155825,13.75 L13.5584409,13.75 C13.9780348,13.75 14.3181818,13.4002225 14.3181818,12.96875 L14.3181818,12.5876483 C14.3181818,11.8020614 13.888721,11.0878833 13.2091027,10.7290761 C12.2268313,10.2104815 10.6896504,9.58333333 9,9.58333333 Z"
                                            id="XMLID_1424_"></path>
                                        <path
                                            d="M16.3636364,0.416666667 L1.63636364,0.416666667 C0.958557109,0.416666667 0.409090909,0.976308167 0.409090909,1.66666667 L0.409090909,15 C0.409090909,15.6903585 0.958557109,16.25 1.63636364,16.25 L5.72727273,16.25 L9,19.5833333 L12.2727273,16.25 L16.3636364,16.25 C17.0414429,16.25 17.5909091,15.6903585 17.5909091,15 L17.5909091,1.66666667 C17.5909091,0.976308167 17.0414429,0.416666667 16.3636364,0.416666667 Z"
                                            id="XMLID_1428_"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const NotifyIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20.82 25.36">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g id="Page-1">
                    <g id="Noke_LOTO_Web_Home" data-name="Noke LOTO Web Home">
                        <g id="time-allert-sound-bell-set">
                            <path
                                style={{
                                    stroke: props.color || '#000',
                                    fill: props.fill || 'none',
                                    strokeMiterlimit: 4.55,
                                    strokeWidth: props.strokeWidth || '1px'
                                }}
                                d="M7.62,22.24a2.83,2.83,0,0,0,5.58,0"
                            />
                            <path
                                style={{
                                    stroke: props.color || '#000',
                                    fill: props.fill || 'none',
                                    strokeMiterlimit: 4.55,
                                    strokeWidth: props.strokeWidth || '1px'
                                }}
                                d="M3,10.41a7.39,7.39,0,0,1,14.78,0v1.7c0,6.08,2.27,6.22,2.27,8S14,22.34,10.41,22.34.75,21.81.75,20.07,3,18.19,3,12.11Z"
                            />
                            <path
                                style={{
                                    stroke: props.color || '#000',
                                    fill: props.fill || 'none',
                                    strokeMiterlimit: 4.55,
                                    strokeWidth: props.strokeWidth || '1px'
                                }}
                                d="M12.11,3.23V2.45a1.71,1.71,0,0,0-3.41,0v.78"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const OldSharedUserIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 60.000000 60.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,60.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M224 585 c-128 -56 -117 -231 17 -274 82 -26 179 49 179 139 0 51
        -37 106 -87 130 -49 23 -66 24 -109 5z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M138 245 c-107 -35 -159 -101 -128 -161 13 -24 15 -24 160 -24 l146
        0 37 38 c20 21 37 47 37 57 0 11 7 33 15 49 9 16 14 30 13 31 -22 17 -65 28
        -127 31 -62 4 -90 0 -153 -21z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M461 223 c-12 -10 -24 -35 -28 -58 -4 -26 -18 -51 -40 -73 -22 -23
        -33 -43 -33 -63 0 -42 28 -38 75 11 30 31 47 40 73 40 25 0 42 8 63 31 16 17
        29 39 29 48 0 17 -26 61 -44 73 -20 14 -74 8 -95 -9z m89 -49 c0 -19 -5 -24
        -25 -24 -20 0 -25 5 -25 24 0 13 6 26 13 29 22 7 37 -4 37 -29z"
            />
        </g>
    </svg>
);

export const UnitIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23.97 24.26">
        <line
            stroke={props.color || 'none'}
            fill={'none'}
            strokeWidth="1.5"
            x1="3.87"
            y1="21.54"
            x2="16.96"
            y2="21.54"
        />
        <line
            stroke={props.color || 'none'}
            fill={'none'}
            strokeWidth="1.5"
            x1="3.87"
            y1="17.34"
            x2="16.96"
            y2="17.34"
        />
        <line
            stroke={props.color || 'none'}
            fill={'none'}
            strokeWidth="1.5"
            x1="3.87"
            y1="13.13"
            x2="16.96"
            y2="13.13"
        />
        <line stroke={props.color || 'none'} fill={'none'} strokeWidth="1.5" x1="3.87" y1="8.93" x2="16.96" y2="8.93" />
        <polyline
            stroke={props.color || 'none'}
            fill={'none'}
            strokeWidth="1"
            points="19.88 24.25 19.88 5.24 4.11 5.24 4.11 24.25"
        />
        <path
            stroke={props.color || 'none'}
            fill={'none'}
            strokeWidth="0.93"
            d="M3.67,27.42V4.84A1.24,1.24,0,0,1,4.94,3.63h20.5a1.24,1.24,0,0,1,1.27,1.21V27.39"
            transform="translate(-3.21 -3.17)"
        />
    </svg>
);

export const UnitIconOpen = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23.97 24.26">
        <line
            stroke={props.color || 'none'}
            fill={'none'}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            x1="3.87"
            y1="8.47"
            x2="16.96"
            y2="8.47"
        />
        <polyline
            stroke={props.color || 'none'}
            fill={'none'}
            strokeWidth="1"
            points="19.88 24.25 19.88 5.24 4.11 5.24 4.11 24.25"
        />
        <path
            stroke={props.color || 'none'}
            fill={'none'}
            strokeWidth="0.93"
            d="M3.67,27.42V4.84A1.24,1.24,0,0,1,4.94,3.63h20.5a1.24,1.24,0,0,1,1.27,1.21V27.39"
            transform="translate(-3.21 -3.17)"
        />
    </svg>
);

export const OldUnitIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="37 30 130.000000 85.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            stroke={props.color || 'none'}
            transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)"
            fill="#000000">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M539 1211 l-29 -29 0 -467 0 -466 33 3 32 3 3 439 c2 392 4 442 19
        458 15 17 42 18 405 18 375 0 389 -1 408 -20 19 -19 20 -33 20 -461 l0 -440
        33 3 32 3 3 439 c1 282 -2 452 -8 477 -19 70 -14 69 -495 69 l-427 0 -29 -29z
        m939 -572 c2 -9 -5 -15 -18 -15 -11 0 -20 5 -20 11 0 28 33 31 38 4z m0 -56
        c-2 -10 -10 -18 -18 -18 -8 0 -16 8 -18 18 -2 12 3 17 18 17 15 0 20 -5 18
        -17z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M613 1104 c-3 -8 -1 -20 4 -25 5 -5 160 -8 389 -7 371 3 379 3 379
        23 0 20 -8 20 -383 23 -341 2 -383 1 -389 -14z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M620 1025 c-6 -8 -9 -19 -5 -25 4 -7 134 -10 391 -10 370 0 384 1
        384 19 0 10 -7 22 -16 25 -9 3 -179 6 -379 6 -305 0 -364 -2 -375 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M613 934 c-3 -8 -1 -20 4 -25 5 -5 160 -8 389 -7 371 3 379 3 379 23
        0 20 -8 20 -383 23 -341 2 -383 1 -389 -14z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M620 855 c-6 -8 -9 -19 -5 -25 4 -7 134 -10 391 -10 370 0 384 1 384
        19 0 10 -7 22 -16 25 -9 3 -179 6 -379 6 -305 0 -364 -2 -375 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M613 764 c-3 -8 -1 -20 4 -25 5 -5 160 -8 389 -7 371 3 379 3 379 23
        0 20 -8 20 -383 23 -341 2 -383 1 -389 -14z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M620 685 c-6 -8 -9 -19 -5 -25 4 -7 134 -10 391 -10 370 0 384 1 384
        19 0 10 -7 22 -16 25 -9 3 -179 6 -379 6 -305 0 -364 -2 -375 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M613 594 c-3 -8 -1 -20 4 -25 5 -5 160 -8 389 -7 371 3 379 3 379 23
        0 20 -8 20 -383 23 -341 2 -383 1 -389 -14z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M620 515 c-6 -8 -9 -19 -5 -25 4 -7 134 -10 391 -10 370 0 384 1 384
        19 0 10 -7 22 -16 25 -9 3 -179 6 -379 6 -305 0 -364 -2 -375 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M616 431 c-4 -5 -3 -16 0 -25 6 -15 46 -16 388 -14 373 3 381 3 381
        23 0 20 -8 20 -382 23 -225 1 -384 -2 -387 -7z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.2"
                fill={props.color || '#0070CE'}
                d="M620 346 c-6 -9 -9 -20 -5 -26 4 -7 135 -10 391 -10 l385 0 -3 23 -3
        22 -376 3 c-321 2 -378 0 -389 -12z"
            />
        </g>
    </svg>
);

export const OldUnitIconOpen = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="37 30 130.000000 85.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            stroke={props.color || 'none'}
            transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)"
            fill="#000000">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.color || '#0070CE'}
                d="M539 1211 l-29 -29 0 -467 0 -466 33 3 32 3 3 439 c2 392 4 442 19
        458 15 17 42 18 405 18 375 0 389 -1 408 -20 19 -19 20 -33 20 -461 l0 -440
        33 3 32 3 3 439 c1 282 -2 452 -8 477 -19 70 -14 69 -495 69 l-427 0 -29 -29z
        m939 -572 c2 -9 -5 -15 -18 -15 -11 0 -20 5 -20 11 0 28 33 31 38 4z m0 -56
        c-2 -10 -10 -18 -18 -18 -8 0 -16 8 -18 18 -2 12 3 17 18 17 15 0 20 -5 18
        -17z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M613 1104 c-3 -8 -1 -20 4 -25 5 -5 160 -8 389 -7 371 3 379 3 379
        23 0 20 -8 20 -383 23 -341 2 -383 1 -389 -14z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1.5"
                fill={props.color || '#0070CE'}
                d="M620 1025 c-6 -8 -9 -19 -5 -25 4 -7 134 -10 391 -10 370 0 384 1
        384 19 0 10 -7 22 -16 25 -9 3 -179 6 -379 6 -305 0 -364 -2 -375 -15z"
            />
        </g>
    </svg>
);

export const UnitIconOld = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 40 33"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="V1"
            stroke="none"
            strokeWidth={props.stroke || 1}
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_Main_UI" transform="translate(-273.000000, -441.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Unit-1" transform="translate(10.000000, 105.000000)">
                    <g id="locks-icon" transform="translate(263.000000, 336.000000)">
                        <path
                            d="M20,0.916666667 L0.909090909,8.25 L2.72727273,8.25 L2.72727273,29.3333333 C2.72727273,30.8521151 3.94831436,32.0833333 5.45454545,32.0833333 L34.5454545,32.0833333 C36.0516844,32.0833333 37.2727273,30.8521151 37.2727273,29.3333333 L37.2727273,8.25 L39.0909091,8.25 L20,0.916666667 Z"
                            id="Path"></path>
                        <polyline
                            id="Path"
                            points="8.18181818 32.0833333 8.18181818 13.75 31.8181818 13.75 31.8181818 32.0833333"></polyline>
                        <path d="M8.18181818,17.4166667 L31.8181818,17.4166667" id="Path"></path>
                        <path d="M8.18181818,21.0833333 L31.8181818,21.0833333" id="Path"></path>
                        <path d="M8.18181818,24.75 L31.8181818,24.75" id="Path"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const SiteIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 22 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth={props.strokeWidth || "1"}
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_Web_UI_Home" transform="translate(-29.000000, -165.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="sites/on" transform="translate(1.200001, 51.000000)">
                                <g id="Group">
                                    <g id="sites-icon">
                                        <polyline
                                            id="Path"
                                            points="7.3300171 16.5 3.5 16.5 0.5 23.5 21.5 23.5 18.5 16.5 14.6699829 16.5"></polyline>
                                        <path
                                            d="M18.5,8 C18.5,13.7352943 11,20.5 11,20.5 C11,20.5 3.5,13.7352943 3.5,8 C3.5,3.8578644 6.8578644,0.5 11,0.5 C15.1421356,0.5 18.5,3.8578644 18.5,8 Z"
                                            id="Path"></path>
                                        <circle id="Oval" cx="11" cy="8" r="3.5"></circle>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const ActivityIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 24 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_Web_UI_Home" transform="translate(-30.000000, -377.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="activity/off" transform="translate(2.200001, 263.000000)">
                                <g id="Group">
                                    <g id="activity-icon">
                                        <g id="fitness-app-training-workout">
                                            <polyline
                                                id="Shape"
                                                points="0 10.2857143 2.66666667 10.2857143 5.331248 15.4305823 9.33333333 0 13.3333333 18 17.3333333 2.57142857 18.6666667 10.2857143 24 10.2857143"></polyline>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const EntryIcon = (props) => (
    <svg
        width={props.width || 35}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 16 100.000000 40.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,75.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M66 574 c-3 -9 -6 -105 -6 -215 0 -192 1 -199 20 -199 16 0 20 7 20
        35 0 19 5 35 10 35 6 0 10 -11 10 -25 l0 -25 380 0 380 0 0 25 c0 14 5 25 10
        25 6 0 10 -16 10 -35 0 -28 4 -35 20 -35 19 0 20 7 20 199 0 207 -3 231 -26
        231 -10 0 -14 -13 -14 -45 0 -25 -4 -45 -10 -45 -5 0 -10 9 -10 20 0 20 -7 20
        -380 20 -373 0 -380 0 -380 -20 0 -11 -4 -20 -10 -20 -5 0 -10 20 -10 45 0 32
        -4 45 -14 45 -8 0 -17 -7 -20 -16z m144 -214 l0 -150 -30 0 -30 0 0 150 0 150
        30 0 30 0 0 -150z m90 0 l0 -150 -30 0 -30 0 0 150 0 150 30 0 30 0 0 -150z
        m90 0 l0 -150 -35 0 -35 0 0 150 0 150 35 0 35 0 0 -150z m90 0 l0 -150 -35 0
        -35 0 0 150 0 150 35 0 35 0 0 -150z m110 0 l0 -150 -35 0 -35 0 0 150 0 150
        35 0 35 0 0 -150z m90 0 l0 -150 -35 0 -35 0 0 150 0 150 35 0 35 0 0 -150z
        m80 0 l0 -150 -30 0 -30 0 0 150 0 150 30 0 30 0 0 -150z m90 0 l0 -150 -30 0
        -30 0 0 150 0 150 30 0 30 0 0 -150z m-730 4 c0 -67 -4 -103 -10 -99 -6 3 -10
        50 -10 106 0 59 4 99 10 99 6 0 10 -42 10 -106z m780 7 c0 -56 -4 -103 -10
        -106 -6 -4 -10 32 -10 99 0 64 4 106 10 106 6 0 10 -40 10 -99z"
            />
        </g>
    </svg>
);

export const EntryIconOld = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 22 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_Web_UI_Home" transform="translate(-31.000000, -272.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="entries/off" transform="translate(3.200001, 158.000000)">
                                <g id="Group">
                                    <g id="entires-icon">
                                        <path
                                            d="M0.5,2 L0.5,21.5 L5.5,21.5 L5.5,5.5 L16.5,5.5 L16.5,21.5 L21.5,21.5 L21.5,2 C21.5,1.1715729 20.8284264,0.5 20,0.5 L2,0.5 C1.1715729,0.5 0.5,1.1715729 0.5,2 Z"
                                            id="Path"></path>
                                        <path d="M5.5,20.5 L16.5,20.5" id="Path"></path>
                                        <path d="M11,5.5 L11,20.5" id="Path"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const GatewayIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 25 25"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_Web_UI_Home" transform="translate(-31.000000, -324.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Side-Menu">
                    <g id="Group-4">
                        <g transform="translate(27.799999, 114.000000)">
                            <g id="gateways/off" transform="translate(3.200001, 210.000000)">
                                <g id="Group">
                                    <g id="gateways-icon">
                                        <path
                                            d="M15.5,5.97826087 L15.5,1.86956522 C15.5,1.11317243 14.584223,0.5 13.4545455,0.5 L2.54545455,0.5 C1.415777,0.5 0.5,1.11317243 0.5,1.86956522 L0.5,20.1304348 C0.5,20.8868276 1.415777,21.5 2.54545455,21.5 L13.4545455,21.5 C14.584223,21.5 15.5,20.8868276 15.5,20.1304348 L15.5,8.7173913 L15.5,5.97826087 Z"
                                            id="Path"></path>
                                        <path d="M3.5,6.5 L12.5,6.5" id="Path"></path>
                                        <path d="M3.5,10.5 L12.5,10.5" id="Path"></path>
                                        <path d="M3.5,14.5 L12.5,14.5" id="Path"></path>
                                        <path
                                            d="M18.5015011,12.4208507 C19.1077004,11.9646644 19.4997025,11.2391204 19.4997025,10.4220199 C19.4997025,9.6042442 19.1070538,8.8781776 18.5,8.42206"
                                            id="Path"></path>
                                        <path
                                            d="M19.922123,7 C20.8876591,7.8253574 21.4997025,9.0522137 21.4997025,10.42202 C21.4997025,11.7920418 20.8874665,13.0190678 19.9216671,13.8444291"
                                            id="Path"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const GatewayRebootIcon = (props) => (
    <svg
        width={props.width || 23}
        height={props.height || 23}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 533.34668 572.88"
        xmlSpace="preserve"
        id="svg2"
        version="1.1">
        <defs id="defs6" />
        <g transform="matrix(1.3333333,0,0,-1.3333333,0,572.88)" id="g10">
            <g transform="scale(0.1)" id="g12">
                <path
                    id="path14"
                    stroke={props.color || 'none'}
                    strokeWidth=".5"
                    fill={props.color || '#0070CE'}
                    strokeMiterlimit="2"
                    fillOpacity="1"
                    fillRule="nonzero"
                    d="m 3504.55,3317.72 c -308.43,351.73 -729.36,583.74 -1188.42,656.69 0,54.68 0,322.17 0,322.17 L 1263.74,3688.96 2316.13,3081.37 c 0,0 0,253.46 0,324.72 180.64,-40.34 352.95,-115.76 505.04,-221.25 148.51,-103.02 277.17,-234.12 377.57,-384.4 101.32,-151.67 173.47,-322.43 211.31,-500.87 41.58,-196.11 41.73,-400.88 0.74,-597.11 -43.4,-207.77 -133.57,-404.71 -262.18,-573.55 -129.9,-170.519 -297.49,-312.199 -488,-410.629 -189.19,-97.742 -399.65,-151.75 -612.42,-158.691 -14.09,-0.461 -28.19,-0.719 -42.29,-0.77 l -5.83,-0.031 c -193.69,0 -386.8,39.172 -564.92,115.359 -171.99,73.582 -329.07,180.981 -460.439,314.122 -131.449,133.22 -236.777,291.83 -308.027,464.92 -88.371,214.67 -123.289,450.25 -101.496,681.36 18.417,195.31 77.347,386.27 171.718,558.24 94.215,171.68 223.344,323.76 377.714,444.28 55,42.94 113.13,81.87 173.77,116.39 l 63.75,36.26 -545.847,315.12 -22.266,-17.1 C 606.656,3451.66 452.387,3285.52 329.184,3099 200.578,2904.3 106.301,2686.9 52.8633,2459.72 -1.57813,2228.28 -13.7734,1986.83 15.3711,1750.93 43.6289,1522.22 111.691,1298.82 216.352,1093.48 323.191,883.871 467.5,693.98 639.785,533.852 795.961,388.68 975.004,268.391 1168.96,179.711 1362.03,91.4297 1569.17,34.8008 1780.21,11.8711 1853.21,3.94141 1926.64,0 2000.07,0 l 8.81,0.0898438 C 2222.5,1.01953 2435.8,35.6523 2638.38,103.609 c 200.8,67.383 390.34,167.27 559.69,294.45 172.17,129.3 323.74,286.281 446.7,463.043 121.13,174.148 214.04,367.578 273.98,571.078 60.81,206.46 87.64,422.72 80.13,637.79 -7.67,219.74 -51.8,437.97 -130.22,643.39 -78.4,205.39 -190.89,397.5 -331.64,566.38 -10.67,12.8 -21.49,25.46 -32.47,37.98 -308.43,351.73 319.53,-364.49 0,0"
                />
                <path
                    id="path16"
                    stroke={props.color || 'none'}
                    strokeWidth=".5"
                    fill={props.color || '#0070CE'}
                    strokeMiterlimit="2"
                    fillOpacity="1"
                    fillRule="nonzero"
                    d="m 2360.81,2368.45 v 0 c -31.77,-31.64 -50.52,-74.15 -38.97,-119.03 6.35,-24.69 20.43,-49.5 39.02,-67.17 89.92,-89.98 139.38,-209.42 139.38,-336.55 l -2.78,-51.47 c -19.74,-180.95 -144.47,-338.45 -316.6,-398.14 -173.33,-60.1 -370.16,-13.03 -497.84,118.48 -134.73,138.78 -172.1,350.91 -92.33,527.44 21.78,48.2 51.72,92.59 88.09,130.99 23.5,24.82 43.44,51.53 49.38,86.34 9.51,55.63 -26.56,105.02 -70.96,134.61 -35.34,23.54 -77.95,30.36 -118.23,16.33 -8.85,-3.08 -17.28,-7.07 -25.48,-11.59 -8.01,-4.42 -18.44,-9.57 -23.8,-17.41 -165.87,-164.26 -245.9,-401.06 -216.59,-632.37 27.32,-215.64 149.95,-412.28 330.51,-533.12 202.86,-135.77 466.16,-164.65 693.82,-76.65 205.52,79.45 370.57,249.78 442.68,458.04 75.36,217.65 46.1,463.83 -78.43,657.58 -29.32,45.61 -63.48,88.13 -101.85,126.46 -17.41,21.15 -44.67,36.08 -71.46,40.54 -49.26,8.21 -94.08,-19.82 -127.56,-53.31"
                />
                <path
                    id="path18"
                    stroke={props.color || 'none'}
                    strokeWidth=".5"
                    fill={props.color || '#0070CE'}
                    strokeMiterlimit="2"
                    fillOpacity="1"
                    fillRule="nonzero"
                    d="m 1922.52,2728.29 c -27.2,-27.14 -42.15,-63.34 -42.15,-101.79 v -609.86 c 0,-78.43 65.54,-143.94 143.98,-143.94 78.37,0 143.99,65.53 143.99,143.94 v 609.86 c 0,57.53 -35.64,111.07 -88.85,133.12 -53.28,22.08 -116.27,9.46 -156.97,-31.33 -27.2,-27.14 27.2,27.26 0,0"
                />
            </g>
        </g>
    </svg>
);

export const IntegrationIcon = (props) => (
    <svg
        width={props.width || 27}
        height={props.height || 27}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200.000000 200.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M861 1974 c-17 -22 -21 -41 -21 -99 l0 -73 -72 -22 c-40 -12 -106
        -39 -147 -61 l-75 -38 -57 54 c-81 77 -92 75 -196 -28 -103 -104 -105 -115
        -28 -196 l54 -57 -38 -75 c-22 -41 -49 -107 -61 -146 l-22 -73 -73 0 c-58 0
        -77 -4 -99 -21 -25 -20 -26 -23 -26 -139 0 -116 1 -119 26 -139 22 -17 41 -21
        99 -21 l73 0 22 -72 c12 -40 39 -106 61 -147 l38 -75 -54 -57 c-77 -81 -75
        -92 28 -196 104 -103 115 -105 196 -28 l57 54 75 -38 c41 -22 107 -49 147 -61
        l72 -22 0 -73 c0 -58 4 -77 21 -99 20 -25 23 -26 139 -26 116 0 119 1 139 26
        17 22 21 41 21 99 l0 73 73 22 c39 12 105 39 146 61 l75 38 57 -54 c81 -77 92
        -75 196 28 103 104 105 115 28 196 l-54 57 38 75 c22 41 49 107 61 147 l22 72
        73 0 c58 0 77 4 99 21 25 20 26 23 26 139 0 116 -1 119 -26 139 -22 17 -41 21
        -99 21 l-73 0 -22 73 c-12 39 -39 105 -61 146 l-38 75 54 57 c77 81 75 92 -28
        196 -104 103 -115 105 -196 28 l-57 -54 -75 38 c-41 22 -107 49 -146 61 l-73
        22 0 73 c0 58 -4 77 -21 99 -20 25 -23 26 -139 26 -116 0 -119 -1 -139 -26z
        m319 -350 c167 -49 325 -182 398 -335 93 -194 93 -385 0 -578 -82 -172 -258
        -306 -450 -345 -97 -20 -159 -20 -256 0 -233 47 -429 227 -498 459 -25 83 -25
        267 0 350 70 234 277 423 507 464 73 13 232 5 299 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M730 1401 l0 -91 -130 0 -130 0 -18 -37 c-21 -41 -47 -119 -57 -170
        l-7 -33 171 0 171 0 0 -90 0 -91 220 148 c120 81 218 151 217 155 -2 6 -299
        211 -409 282 l-28 18 0 -91z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M1060 955 c-118 -80 -216 -149 -217 -153 -2 -4 95 -73 215 -155 l217
        -147 3 90 3 90 123 0 123 0 26 58 c25 56 39 101 51 155 l6 27 -164 0 -165 0
        -3 90 -3 91 -215 -146z"
            />
        </g>
    </svg>
);

export const EcobeeIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 27}
        height={props.height || 27}
        viewBox="0 0 241.000000 231.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,231.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M1505 2221 c-109 -28 -205 -151 -205 -261 0 -40 -30 -63 -65 -50
        -106 40 -401 54 -562 26 -144 -25 -313 -91 -423 -165 -69 -47 -148 -147 -167
        -210 -22 -75 -13 -167 21 -224 78 -135 246 -215 516 -248 l98 -12 11 -37 c42
        -141 270 -364 450 -442 79 -34 223 -68 287 -68 l61 0 18 -45 c56 -148 214
        -333 337 -394 62 -31 72 -33 147 -30 75 4 83 7 138 45 69 49 133 147 160 245
        24 88 24 339 -1 462 -30 155 -131 382 -216 489 -43 53 -36 99 15 112 41 10
        111 82 135 138 47 109 19 231 -70 311 -29 26 -52 57 -60 82 -31 96 -80 164
        -139 195 -49 25 -137 40 -186 31 -33 -5 -50 -1 -95 21 -59 30 -152 43 -205 29z
        m167 -180 c39 -43 40 -115 2 -160 -83 -99 -248 -19 -219 107 14 63 61 94 134
        89 46 -3 59 -9 83 -36z m-597 -266 c103 -18 194 -62 232 -112 27 -35 40 -96
        29 -138 -17 -68 -151 -164 -291 -208 -170 -54 -423 -69 -555 -34 -184 49 -271
        184 -191 294 44 60 89 91 198 133 180 69 406 95 578 65z m990 1 c66 -28 94
        -115 58 -177 -19 -32 -68 -59 -107 -59 -136 0 -176 182 -52 236 40 17 59 17
        101 0z m-209 -485 c107 -49 191 -172 254 -371 46 -148 60 -224 60 -342 0 -107
        -15 -179 -47 -236 -81 -139 -260 -74 -386 139 -106 180 -161 506 -116 684 31
        122 129 174 235 126z m-484 -138 l56 -37 4 -136 c2 -74 3 -137 1 -139 -6 -9
        -95 32 -178 82 -50 29 -121 84 -164 126 l-76 73 75 22 c41 12 100 34 130 48
        48 23 57 24 75 12 11 -7 45 -30 77 -51z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M648 903 c-62 -72 -69 -203 -18 -321 42 -96 180 -217 305 -268 61
        -25 83 -29 165 -29 116 1 182 26 236 89 32 37 34 42 18 53 -10 7 -27 13 -39
        13 -32 0 -173 37 -220 57 -170 75 -337 227 -401 368 -14 30 -27 55 -28 55 -2
        0 -10 -8 -18 -17z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M579 393 c-6 -16 -11 -60 -11 -99 0 -75 24 -145 63 -180 29 -27 113
        -29 180 -6 66 23 142 69 135 81 -3 5 -32 13 -64 20 -100 20 -212 100 -258 184
        -18 34 -32 34 -45 0z"
            />
        </g>
    </svg>
);

export const GlobalSearchIcon = (props) => (
    <svg
        width={props.width || 23}
        height={props.height || 23}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M2315 5093 c-615 -49 -1161 -299 -1585 -723 -383 -383 -621 -859
        -707 -1410 -24 -160 -24 -519 0 -680 141 -916 738 -1658 1594 -1980 446 -168
        997 -200 1447 -84 66 17 276 83 289 91 5 3 -27 25 -71 48 -77 41 -150 91 -221
        152 -34 29 -35 30 -90 16 -76 -18 -277 -53 -307 -53 l-24 0 0 465 0 465 24 0
        c21 0 23 5 30 73 3 39 15 106 26 147 27 103 28 100 -30 100 l-50 0 0 365 0
        365 996 0 995 0 -6 -57 c-4 -32 -15 -103 -26 -157 l-18 -99 50 -55 c59 -65
        115 -145 154 -222 l29 -55 23 75 c134 427 151 881 48 1325 -53 227 -194 555
        -325 755 -393 597 -985 987 -1675 1104 -175 30 -412 42 -570 29z m5 -789 l0
        -466 -122 7 c-237 13 -583 50 -608 65 -12 8 25 166 91 387 43 146 118 364 128
        375 20 23 366 95 464 97 l47 1 0 -466z m485 451 c118 -18 309 -64 331 -79 17
        -13 78 -177 134 -361 45 -150 104 -384 99 -389 -16 -15 -562 -76 -676 -76
        l-53 0 0 460 0 460 33 0 c17 0 77 -7 132 -15z m-1448 -431 c-25 -82 -55 -193
        -68 -246 -18 -78 -27 -98 -41 -98 -19 0 -325 87 -345 99 -19 10 153 176 278
        269 115 85 213 145 217 133 2 -5 -17 -75 -41 -157z m2275 120 c126 -81 214
        -151 324 -256 l106 -102 -29 -8 c-163 -47 -337 -88 -343 -81 -4 4 -22 67 -40
        138 -27 108 -51 193 -96 338 -3 9 -3 17 0 17 3 0 38 -21 78 -46z m-2827 -664
        c66 -22 179 -57 250 -76 72 -20 133 -39 137 -43 3 -3 0 -42 -8 -85 -32 -183
        -59 -427 -80 -728 l-6 -88 -388 0 -389 0 5 53 c27 260 108 553 211 762 38 75
        140 245 147 245 1 0 56 -18 121 -40z m3512 -28 c166 -268 280 -606 308 -915
        l7 -77 -388 2 -389 3 -7 115 c-11 183 -28 352 -54 535 -14 94 -27 191 -30 216
        l-6 45 158 42 c88 23 200 55 249 71 50 16 95 29 100 30 6 1 29 -30 52 -67z
        m-874 -164 c26 -104 87 -646 87 -775 l0 -53 -445 0 -445 0 0 385 0 385 58 0
        c115 0 523 43 652 69 75 15 87 13 93 -11z m-1631 -32 c73 -8 189 -18 258 -21
        69 -3 153 -8 188 -11 l62 -6 0 -379 0 -379 -450 0 -450 0 5 73 c25 330 67 687
        89 753 3 8 27 7 84 -2 44 -7 140 -19 214 -28z m-712 -1173 c0 -149 27 -447 61
        -676 11 -76 19 -140 17 -143 -2 -2 -80 -24 -174 -48 -93 -25 -202 -57 -243
        -71 -41 -14 -76 -25 -77 -25 -7 0 -92 146 -138 238 -67 133 -119 273 -157 416
        -31 122 -59 280 -59 339 l0 37 385 0 385 0 0 -67z m1220 -297 c0 -413 9 -376
        -93 -376 -85 0 -353 -26 -517 -50 -74 -11 -153 -23 -176 -26 l-41 -6 -21 158
        c-27 199 -39 330 -48 517 l-7 147 451 0 452 0 0 -364z m0 -1152 l0 -466 -67 6
        c-108 11 -179 24 -315 58 l-127 31 -36 86 c-92 217 -225 658 -202 666 47 17
        448 63 677 79 25 1 51 3 58 4 9 2 12 -97 12 -464z m-1060 274 c36 -137 65
        -235 96 -331 20 -60 34 -110 32 -112 -21 -21 -488 348 -488 385 0 5 19 15 43
        21 142 40 284 78 294 78 7 1 17 -18 23 -41z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M3665 2293 c-206 -29 -406 -133 -558 -292 -278 -291 -344 -715 -167
        -1076 199 -407 647 -618 1085 -512 70 17 140 44 226 88 l62 31 236 -236 c245
        -245 286 -275 362 -276 52 0 139 48 172 95 33 49 45 125 27 181 -10 30 -68 95
        -257 285 l-245 246 35 69 c80 154 111 282 111 444 -1 179 -33 307 -114 457
        -168 312 -495 506 -845 501 -55 0 -113 -3 -130 -5z m289 -313 c204 -52 360
        -182 445 -372 42 -93 56 -161 55 -273 0 -182 -62 -325 -198 -460 -129 -128
        -274 -188 -456 -188 -258 0 -475 135 -591 368 -142 286 -54 635 207 821 159
        114 354 151 538 104z"
            />
        </g>
    </svg>
);

export const CursorIcon = (props) => (
    <svg
        width={props.width || 18}
        height={props.height || 22}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128.000000 128.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth=".5"
                fill={props.color || '#0070CE'}
                d="M16 1264 c-9 -8 -16 -21 -16 -27 0 -15 440 -1119 453 -1134 17 -22
        54 -15 75 15 10 15 47 78 82 140 l64 112 186 -185 c110 -109 194 -185 205
        -185 25 0 215 190 215 215 0 11 -76 95 -185 205 l-185 186 112 64 c62 35 125
        72 141 82 29 21 36 58 15 76 -15 12 -1120 452 -1136 452 -6 0 -18 -7 -26 -16z
        m582 -299 l444 -178 -84 -48 c-162 -93 -168 -97 -168 -121 0 -16 55 -78 190
        -213 l190 -190 -53 -53 -52 -52 -190 190 c-136 136 -196 190 -213 190 -24 0
        -28 -6 -121 -169 l-49 -84 -160 404 c-88 222 -170 428 -182 458 -14 36 -17 52
        -8 48 7 -2 213 -85 456 -182z"
            />
        </g>
    </svg>
);

export const DirectionsIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 38 39"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g id="V1" stroke="none" strokeWidth="1" fill={props.fill || 'none'} fillRule="evenodd">
            <g id="Noke_Main_UI" transform="translate(-71.000000, -438.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Unit-1" transform="translate(10.000000, 105.000000)">
                    <g id="directions-icon" transform="translate(61.000000, 333.000000)">
                        <polygon
                            id="Rectangle"
                            transform="translate(19.342154, 19.501930) rotate(-45.000000) translate(-19.342154, -19.501930) "
                            points="6.20398174 6.36375856 32.4126804 6.43140361 32.4803255 32.6401023 6.27162679 32.5724573"></polygon>
                        <g id="Reply" transform="translate(14.553191, 13.065217)">
                            <path
                                d="M11.3191489,4.02173913 L8.08510638,4.02173913 C3.63829787,4.02173913 0,7.64130435 0,12.0652174 L0,12.0652174"
                                id="Path"></path>
                            <polyline
                                id="Path"
                                points="7.27659574 0 11.3191489 4.02173913 7.27659574 8.04347826"></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const ReportsIcon = (props) => (
    <svg
        width={props.width || 19}
        height={props.height || 21}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 29.01 39.47">
        <path
            stroke={props.color || 'none'}
            strokeWidth="1.8"
            fill={props.fill || 'none'}
            strokeMiterlimit="10"
            d="M33.65,8.89h5.17a1.6,1.6,0,0,1,1.6,1.6V42.15a1.6,1.6,0,0,1-1.6,1.6H13.41a1.6,1.6,0,0,1-1.6-1.6V10.49a1.6,1.6,0,0,1,1.6-1.6h5"
            transform="translate(-11.61 -4.48)"
        />
        <line
            stroke={props.color || 'none'}
            strokeWidth="1.8"
            fill={props.fill || 'none'}
            strokeMiterlimit="10"
            x1="13.45"
            y1="13.52"
            x2="24"
            y2="13.52"
        />
        <line
            stroke={props.color || 'none'}
            strokeWidth="1.8"
            fill={props.fill || 'none'}
            strokeMiterlimit="10"
            x1="13.45"
            y1="23.27"
            x2="24"
            y2="23.27"
        />
        <line
            stroke={props.color || 'none'}
            strokeWidth="1.8"
            fill={props.fill || 'none'}
            strokeMiterlimit="10"
            x1="13.45"
            y1="33.46"
            x2="24"
            y2="33.46"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1.8"
            fill={props.fill || 'none'}
            strokeMiterlimit="10"
            d="M16.3,17.17l2.07,2.26a0,0,0,0,0,.07,0L21.81,15"
            transform="translate(-11.61 -4.48)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1.8"
            fill={props.fill || 'none'}
            strokeMiterlimit="10"
            d="M31.44,6.88v-2a.23.23,0,0,0-.24-.23H20.59a.23.23,0,0,0-.24.23V6.77a.23.23,0,0,1-.24.23H18.7a.24.24,0,0,0-.24.24v4.25a.24.24,0,0,0,.24.24H33.26a.24.24,0,0,0,.24-.24V7.35a.24.24,0,0,0-.24-.24H31.67A.23.23,0,0,1,31.44,6.88Z"
            transform="translate(-11.61 -4.48)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1.8"
            fill={props.fill || 'none'}
            strokeMiterlimit="10"
            d="M16.3,27.66l2.07,2.27a0,0,0,0,0,.07,0l3.37-4.41"
            transform="translate(-11.61 -4.48)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1.8"
            fill={props.fill || 'none'}
            strokeMiterlimit="10"
            d="M16.3,38.63l2.07,2.27a0,0,0,0,0,.07,0l3.37-4.41"
            transform="translate(-11.61 -4.48)"
        />
    </svg>
);

export const SitemapIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 36 30"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="V1"
            stroke="none"
            strokeWidth="1.4"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_Main_UI" transform="translate(-179.000000, -443.000000)" stroke={props.color || '#3D5F7B'}>
                <g id="Unit-1" transform="translate(10.000000, 105.000000)">
                    <g id="sitemap-icon" transform="translate(169.000000, 338.000000)">
                        <polygon
                            id="Path"
                            points="12.2727273 29.1666667 0.818181818 25.8333333 0.818181818 0.833333333 12.2727273 4.16666667"></polygon>
                        <polygon
                            id="Path"
                            points="23.7272727 25.8333333 12.2727273 29.1666667 12.2727273 4.16666667 23.7272727 0.833333333"></polygon>
                        <polygon
                            id="Path"
                            points="35.1818182 29.1666667 23.7272727 25.8333333 23.7272727 0.833333333 35.1818182 4.16666667"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const UnitIconOnboard = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 58 58"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill={props.fill || 'none'} fillRule="evenodd">
            <g id="unit_icon" fill={props.fill || 'd8d8d8'}>
                <rect id="Rectangle-5-Copy-13" x="6" y="52" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5-Copy-12" x="6" y="47" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5-Copy-11" x="6" y="42" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5-Copy-10" x="6" y="37" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5-Copy-9" x="6" y="32" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5-Copy-8" x="6" y="27" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5-Copy-7" x="6" y="22" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5-Copy-6" x="6" y="17" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5-Copy" x="6" y="12" width="46" height="3" rx="1.5"></rect>
                <rect id="Rectangle-5" x="6" y="7" width="46" height="3" rx="1.5"></rect>
                <path
                    d="M4,58 L0.223016424,58 C0.0770614401,57.3567773 8.41807468e-17,56.687388 0,56 L0,9 L0,9 C-6.08718376e-16,4.02943725 4.02943725,9.13077564e-16 9,0 L9,0 L49,0 C53.9705627,-9.13077564e-16 58,4.02943725 58,9 L58,56 C58,56.687388 57.9229386,57.3567773 57.7769836,58 L54,58 L54,10 C54,6.6862915 51.3137085,4 48,4 L10,4 L10,4 C6.6862915,4 4,6.6862915 4,10 L4,10 L4,58 Z M54,58 L54,58 Z M56,34 C55.4477153,34 55,34.4477153 55,35 L55,39 C55,39.5522847 55.4477153,40 56,40 C56.5522847,40 57,39.5522847 57,39 L57,35 C57,34.4477153 56.5522847,34 56,34 Z"
                    id="Combined-Shape"
                    opacity="0.825181159"></path>
                <circle id="Oval" cx="56" cy="37" r="1"></circle>
            </g>
        </g>
    </svg>
);

export const KeypadsIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 17.45 17.45"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink">
        <g
            id="Side-Menu"
            stroke="none"
            strokeWidth="0.8"
            fill={props.fill || 'none'}
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round">
            <g id="Noke_Main_UI" stroke={props.color || '#3D5F7B'}>
                <rect x="6.85" y="6.85" width="3.75" height="3.75" />
                <rect x="6.85" y="13.2" width="3.75" height="3.75" />
                <rect x="6.85" y="0.5" width="3.75" height="3.75" />
                <rect x="14.97" y="7.63" width="3.75" height="3.75" transform="translate(5.57 25.57) rotate(-90)" />
                <rect x="2.28" y="7.63" width="3.75" height="3.75" transform="translate(-7.13 12.87) rotate(-90)" />
                <rect x="14.97" y="1.28" width="3.75" height="3.75" transform="translate(11.92 19.22) rotate(-90)" />
                <rect x="2.28" y="1.28" width="3.75" height="3.75" transform="translate(-0.78 6.53) rotate(-90)" />
                <rect x="14.97" y="13.97" width="3.75" height="3.75" transform="translate(-0.78 31.92) rotate(-90)" />
                <rect x="2.28" y="13.97" width="3.75" height="3.75" transform="translate(-13.47 19.22) rotate(-90)" />
            </g>
        </g>
    </svg>
);

export const FeedbackIcon = (props) => (
    <svg
        width={props.width || 28}
        height={props.height || 28}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40.32 37.88">
        <path
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            d="M26.65,25.1a.74.74,0,0,1-.49-.18.78.78,0,0,1-.26-.73L26.51,21a.91.91,0,0,1,.19-.41l8-9.78a1.61,1.61,0,0,1,2.28-.23l1.12.91a1.62,1.62,0,0,1,.24,2.28l-8,9.78a1,1,0,0,1-.37.27l-3,1.22A.67.67,0,0,1,26.65,25.1Zm1.07-3.79-.42,2.24,2.13-.86L37.33,13a.37.37,0,0,0-.06-.52l-1.12-.92a.36.36,0,0,0-.27-.08.35.35,0,0,0-.25.14Zm1.78,1.35Z"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            x="34.62"
            y="11.86"
            width="1.25"
            height="3.51"
            transform="translate(2.44 32.36) rotate(-50.87)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            d="M29.73,30.84H5.83a2.27,2.27,0,0,1-2.26-2.27V9.85A2.26,2.26,0,0,1,5.83,7.59h23.9A2.27,2.27,0,0,1,32,9.85l.08,1.33a.62.62,0,0,1-1.24.08L30.75,9.9a1,1,0,0,0-1-1.06H5.83a1,1,0,0,0-1,1V28.57a1,1,0,0,0,1,1h23.9a1,1,0,0,0,1-1V25.88a.63.63,0,0,1,1.25,0v2.69A2.27,2.27,0,0,1,29.73,30.84Z"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            d="M25.35,16h-21a.63.63,0,0,1,0-1.25h21a.63.63,0,0,1,0,1.25Z"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            d="M20.46,25.47H7.83a.63.63,0,1,1,0-1.25H20.46a.63.63,0,0,1,0,1.25Z"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            d="M17.94,20.79h-10a.62.62,0,0,1-.63-.62.63.63,0,0,1,.63-.63h10a.63.63,0,0,1,.63.63A.62.62,0,0,1,17.94,20.79Z"
        />
        <circle
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            cx="8.02"
            cy="11.68"
            r="0.77"
        />
        <circle
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            cx="12.11"
            cy="11.68"
            r="0.77"
        />
        <circle
            stroke={props.color || 'none'}
            strokeWidth=".5"
            fill={props.fill || '#0070CE'}
            strokeMiterlimit="2"
            cx="16.21"
            cy="11.68"
            r="0.77"
        />
    </svg>
);

export const LowLockIcon = (props) => (
    <svg
        id="Layer_1"
        width={props.width || 24}
        height={props.height || 24}
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 26.79 32.37">
        <title>Battery {props.title ? props.title : ''}</title>
        <rect
            stroke={props.themeColor || 'none'}
            strokeWidth="1.2"
            fill={'none'}
            strokeMiterlimit="2"
            x="6.96"
            y="5.42"
            width="12.88"
            height="23.23"
            rx="1.17"
        />
        <path
            stroke={props.themeColor || 'none'}
            strokeWidth="1.2"
            fill={'none'}
            strokeMiterlimit="2"
            d="M10.7,5.56v-1a.85.85,0,0,1,.84-.84h3.71a.85.85,0,0,1,.84.84v.89"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1.2"
            fill={props.fill || 'none'}
            strokeMiterlimit="2"
            d="M9.5,23.64h7.86a0,0,0,0,1,0,0v2.15a.35.35,0,0,1-.35.35H9.85a.35.35,0,0,1-.35-.35V23.64A0,0,0,0,1,9.5,23.64Z"
        />
    </svg>
);

export const MedLockIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 26.79 32.37">
        <title>Battery {props.title ? props.title : ''}</title>
        <rect
            stroke={props.themeColor || 'none'}
            strokeWidth="1.2"
            fill={'none'}
            strokeMiterlimit="2"
            x="6.96"
            y="5.42"
            width="12.88"
            height="23.23"
            rx="1.17"
        />
        <path
            stroke={props.themeColor || 'none'}
            strokeWidth="1.2"
            fill={'none'}
            strokeMiterlimit="2"
            d="M10.7,5.56v-1a.85.85,0,0,1,.84-.84h3.71a.85.85,0,0,1,.84.84v.89"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1.2"
            fill={props.fill || 'none'}
            strokeMiterlimit="2"
            d="M9.5,17h7.86a0,0,0,0,1,0,0v8.75a.35.35,0,0,1-.35.35H9.85a.35.35,0,0,1-.35-.35V17A0,0,0,0,1,9.5,17Z"
        />
    </svg>
);

export const HighLockIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 26.79 32.37">
        <title>Battery {props.title ? props.title : ''}</title>
        <rect
            stroke={props.themeColor || 'none'}
            strokeWidth="1.2"
            fill={'none'}
            strokeMiterlimit="2"
            x="6.96"
            y="5.42"
            width="12.88"
            height="23.23"
            rx="1.17"
        />
        <path
            stroke={props.themeColor || 'none'}
            strokeWidth="1.2"
            fill={'none'}
            strokeMiterlimit="2"
            d="M10.7,5.56v-1a.85.85,0,0,1,.84-.84h3.71a.85.85,0,0,1,.84.84v.89"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1.2"
            fill={props.fill || 'none'}
            strokeMiterlimit="2"
            d="M9.9,8H17a.4.4,0,0,1,.4.4V25.79a.35.35,0,0,1-.35.35H9.85a.35.35,0,0,1-.35-.35V8.44A.4.4,0,0,1,9.9,8Z"
        />
    </svg>
);

export const AlarmIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 30 130.000000 85.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M677 1325 c-74 -38 -128 -78 -177 -131 -57 -62 -94 -120 -86 -139 10
        -28 34 -15 66 35 45 71 126 141 214 186 51 26 76 45 76 57 0 24 -35 21 -93 -8z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1156 1341 c-11 -18 1 -29 70 -63 79 -39 170 -119 214 -188 18 -27
        39 -50 46 -50 49 0 -1 95 -96 184 -93 85 -216 147 -234 117z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M712 1230 c-78 -35 -222 -190 -208 -225 9 -25 32 -17 59 23 42 59
        117 128 177 160 93 49 69 86 -28 42z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1125 1240 c-10 -16 1 -26 57 -53 57 -28 135 -99 176 -159 13 -21 31
        -38 39 -38 25 0 26 30 0 68 -75 115 -244 227 -272 182z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M817 1126 c-117 -48 -182 -110 -234 -222 -25 -53 -28 -70 -28 -164 0
        -97 2 -110 32 -172 41 -88 113 -160 201 -201 62 -30 75 -32 172 -32 97 0 110
        2 172 32 40 19 89 53 118 83 143 142 161 378 41 537 -82 108 -196 163 -335
        163 -62 0 -95 -6 -139 -24z m193 -291 c33 -17 60 -61 60 -97 0 -73 -83 -124
        -153 -94 -77 32 -85 143 -14 186 39 24 68 25 107 5z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M910 790 c-11 -11 -20 -33 -20 -50 0 -17 9 -39 20 -50 42 -42 120
        -12 120 48 0 66 -74 98 -120 52z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1451 719 c-33 -13 -50 -38 -51 -75 0 -34 13 -53 51 -76 40 -25 64
        -132 39 -178 -10 -18 -59 -40 -91 -40 -10 0 -25 13 -34 29 -23 46 -49 48 -95
        7 -167 -151 -434 -153 -613 -4 -54 45 -78 44 -102 -2 -19 -37 -19 -133 0 -169
        8 -16 28 -34 46 -40 21 -7 147 -11 366 -11 364 0 378 2 405 57 10 21 25 29 64
        38 75 17 116 44 142 95 28 55 28 118 2 202 -11 34 -20 77 -20 94 0 52 -60 92
        -109 73z"
            />
        </g>
    </svg>
);

export const CameraIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 54.11 48.41">
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M73.6,51.18a3.21,3.21,0,0,1-1.76-.53L39.93,29.3a3.18,3.18,0,0,1-.87-4.39l4.72-7.06A3.18,3.18,0,0,1,48.17,17L87.11,43a1.6,1.6,0,0,1,.7,1.47,1.58,1.58,0,0,1-1,1.31l-12,5.12A3.16,3.16,0,0,1,73.6,51.18ZM46.41,18a1.53,1.53,0,0,0-.3,0,1.57,1.57,0,0,0-1,.67l-4.71,7.05A1.55,1.55,0,0,0,40.15,27a1.53,1.53,0,0,0,.67,1L72.73,49.32a1.55,1.55,0,0,0,1.49.14l12-5.11-38.93-26A1.52,1.52,0,0,0,46.41,18Z"
            transform="translate(-33.78 -16.45)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M74.22,58.44a3.12,3.12,0,0,1-1.76-.54L39.68,36a3.17,3.17,0,0,1-.87-4.39l1.78-2.65a.79.79,0,1,1,1.32.88l-1.77,2.66a1.57,1.57,0,0,0,.43,2.18L73.35,56.58a1.54,1.54,0,0,0,1.18.23,1.6,1.6,0,0,0,1-.66l5-7.49a.81.81,0,0,1,1.11-.22.8.8,0,0,1,.22,1.11l-5,7.48a3.17,3.17,0,0,1-2,1.35A3.34,3.34,0,0,1,74.22,58.44Z"
            transform="translate(-33.78 -16.45)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M80.8,58.74a2.33,2.33,0,0,1-1.32-.4l-3.06-2.05A.8.8,0,0,1,77.31,55l3.06,2a.77.77,0,0,0,1.08-.21l4.71-7a.75.75,0,0,0,.12-.58.79.79,0,0,0-.33-.5l-2.22-1.48a.8.8,0,1,1,.89-1.33l2.22,1.48a2.38,2.38,0,0,1,.65,3.3l-4.71,7a2.33,2.33,0,0,1-1.51,1A1.93,1.93,0,0,1,80.8,58.74Z"
            transform="translate(-33.78 -16.45)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M56,53.48a.79.79,0,0,1-.44-.14.78.78,0,0,1-.22-1.1l3-4.54a.79.79,0,0,1,1.32.88l-3,4.54A.79.79,0,0,1,56,53.48Z"
            transform="translate(-33.78 -16.45)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M50.22,49.6a.79.79,0,0,1-.44-.14.78.78,0,0,1-.22-1.1l3-4.54a.79.79,0,0,1,1.32.88l-3,4.54A.79.79,0,0,1,50.22,49.6Z"
            transform="translate(-33.78 -16.45)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M41.22,58.63a.8.8,0,0,1,0-1.6L46.67,57a.84.84,0,0,1,.81.78.8.8,0,0,1-.79.81l-5.46.09Z"
            transform="translate(-33.78 -16.45)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M41.11,51.65a.8.8,0,0,1,0-1.6L46.56,50a.81.81,0,0,1,.81.78.8.8,0,0,1-.79.81l-5.46.09Z"
            transform="translate(-33.78 -16.45)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M50.82,60.19A6.14,6.14,0,1,1,52,60.07,6.09,6.09,0,0,1,50.82,60.19Zm0-10.64a4.52,4.52,0,1,0,.88,9,4.44,4.44,0,0,0,2.87-1.92,4.51,4.51,0,0,0-3.75-7Z"
            transform="translate(-33.78 -16.45)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1"
            fill={props.color || '#0070CE'}
            strokeMiterlimit="2"
            d="M34.58,64.86h-.8v-21h.8A7.18,7.18,0,0,1,41.75,51v6.68A7.18,7.18,0,0,1,34.58,64.86Zm.8-19.37V63.2a5.57,5.57,0,0,0,4.78-5.51V51A5.59,5.59,0,0,0,35.38,45.49Z"
            transform="translate(-33.78 -16.45)"
        />
    </svg>
);

export const AddUnitIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 30 130.000000 85.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M605 1226 c-41 -18 -83 -69 -90 -109 -3 -18 -4 -219 -3 -447 l3 -415
        30 0 30 0 5 433 5 434 28 24 28 24 359 0 360 0 32 -29 33 -29 3 -285 3 -284
        27 -14 c15 -7 31 -15 35 -17 5 -2 7 135 5 304 -3 288 -4 311 -23 343 -11 19
        -33 43 -48 55 -28 20 -40 21 -410 23 -302 2 -388 0 -412 -11z m873 -587 c2 -9
        -5 -15 -18 -15 -11 0 -20 5 -20 11 0 28 33 31 38 4z m0 -56 c-2 -10 -10 -18
        -18 -18 -8 0 -16 8 -18 18 -2 12 3 17 18 17 15 0 20 -5 18 -17z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 1105 c-3 -8 -3 -19 1 -25 4 -7 133 -10 391 -10 l384 0 0 25 0
        25 -385 0 c-328 0 -386 -2 -391 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 1033 c-4 -3 -7 -15 -7 -25 0 -17 19 -18 391 -18 l390 0 -3 23
        -3 22 -381 3 c-209 1 -383 -1 -387 -5z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 935 c-3 -8 -3 -19 1 -25 4 -7 133 -10 391 -10 l384 0 0 25 0 25
        -385 0 c-328 0 -386 -2 -391 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 863 c-4 -3 -7 -15 -7 -25 0 -17 19 -18 391 -18 l390 0 -3 23 -3
        22 -381 3 c-209 1 -383 -1 -387 -5z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 765 c-3 -8 -3 -19 1 -25 4 -7 133 -10 391 -10 l384 0 0 25 0 25
        -385 0 c-328 0 -386 -2 -391 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 693 c-4 -3 -7 -15 -7 -25 0 -17 19 -18 391 -18 l390 0 -3 23 -3
        22 -381 3 c-209 1 -383 -1 -387 -5z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 595 c-3 -8 -3 -19 1 -25 4 -7 133 -10 391 -10 l384 0 0 25 0 25
        -385 0 c-328 0 -386 -2 -391 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 523 c-4 -3 -7 -15 -7 -25 0 -17 15 -18 273 -18 l272 1 30 24 30
        25 -296 0 c-163 0 -299 -3 -302 -7z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1255 511 c-142 -65 -178 -233 -73 -347 56 -61 124 -82 204 -65 46
        11 66 22 104 61 92 91 90 221 -4 308 -68 62 -154 78 -231 43z m127 -113 c3
        -43 3 -43 46 -46 42 -3 42 -3 42 -42 0 -39 0 -39 -42 -42 -43 -3 -43 -3 -46
        -45 -3 -43 -3 -43 -42 -43 -39 0 -39 0 -42 43 -3 42 -3 42 -45 45 -43 3 -43 3
        -43 42 0 39 0 39 43 42 42 3 42 3 45 46 3 42 3 42 42 42 39 0 39 0 42 -42z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 425 c-13 -32 6 -35 246 -35 226 0 240 1 250 19 5 11 10 22 10
        25 0 3 -113 6 -250 6 -210 0 -252 -2 -256 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 353 c-4 -3 -7 -15 -7 -25 0 -17 14 -18 240 -18 l240 0 0 25 0
        25 -233 0 c-129 0 -237 -3 -240 -7z"
            />
        </g>
    </svg>
);

export const RemoveUnitIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 30 130.000000 85.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M605 1226 c-41 -18 -83 -69 -90 -109 -3 -18 -4 -219 -3 -447 l3 -415
        30 0 30 0 5 433 5 434 28 24 28 24 359 0 360 0 32 -29 33 -29 3 -285 3 -284
        27 -14 c15 -7 31 -15 35 -17 5 -2 7 135 5 304 -3 288 -4 311 -23 343 -11 19
        -33 43 -48 55 -28 20 -40 21 -410 23 -302 2 -388 0 -412 -11z m873 -587 c2 -9
        -5 -15 -18 -15 -11 0 -20 5 -20 11 0 28 33 31 38 4z m0 -56 c-2 -10 -10 -18
        -18 -18 -8 0 -16 8 -18 18 -2 12 3 17 18 17 15 0 20 -5 18 -17z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 1105 c-3 -8 -3 -19 1 -25 4 -7 133 -10 391 -10 l384 0 0 25 0
        25 -385 0 c-328 0 -386 -2 -391 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 1033 c-4 -3 -7 -15 -7 -25 0 -17 19 -18 391 -18 l390 0 -3 23
        -3 22 -381 3 c-209 1 -383 -1 -387 -5z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 935 c-3 -8 -3 -19 1 -25 4 -7 133 -10 391 -10 l384 0 0 25 0 25
        -385 0 c-328 0 -386 -2 -391 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 863 c-4 -3 -7 -15 -7 -25 0 -17 19 -18 391 -18 l390 0 -3 23 -3
        22 -381 3 c-209 1 -383 -1 -387 -5z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 765 c-3 -8 -3 -19 1 -25 4 -7 133 -10 391 -10 l384 0 0 25 0 25
        -385 0 c-328 0 -386 -2 -391 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 693 c-4 -3 -7 -15 -7 -25 0 -17 19 -18 391 -18 l390 0 -3 23 -3
        22 -381 3 c-209 1 -383 -1 -387 -5z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 595 c-3 -8 -3 -19 1 -25 4 -7 133 -10 391 -10 l384 0 0 25 0 25
        -385 0 c-328 0 -386 -2 -391 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 523 c-4 -3 -7 -15 -7 -25 0 -17 15 -18 273 -18 l272 1 30 24 30
        25 -296 0 c-163 0 -299 -3 -302 -7z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1276 518 c-25 -7 -57 -28 -87 -58 -91 -91 -89 -221 5 -308 90 -83
        215 -81 300 4 85 85 87 210 5 299 -61 66 -134 86 -223 63z m194 -208 l0 -40
        -130 0 -130 0 0 40 0 40 130 0 130 0 0 -40z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M614 425 c-13 -32 6 -35 246 -35 226 0 240 1 250 19 5 11 10 22 10
        25 0 3 -113 6 -250 6 -210 0 -252 -2 -256 -15z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M617 353 c-4 -3 -7 -15 -7 -25 0 -17 14 -18 240 -18 l240 0 0 25 0
        25 -233 0 c-129 0 -237 -3 -240 -7z"
            />
        </g>
    </svg>
);

export const AddUserIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 30 130.000000 85.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M930 1221 c-146 -48 -226 -203 -176 -343 51 -143 228 -214 362 -145
        102 52 150 139 142 255 -7 93 -58 171 -143 214 -43 22 -144 33 -185 19z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M882 663 c-160 -34 -213 -56 -279 -116 -90 -83 -118 -173 -69 -222
        43 -43 83 -48 409 -52 l308 -5 -32 45 c-54 78 -52 196 6 281 13 20 21 37 17
        40 -6 3 -153 36 -227 50 -11 2 -71 -7 -133 -21z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1366 658 c-25 -7 -57 -28 -87 -58 -91 -91 -89 -221 5 -308 90 -83
        215 -81 300 4 85 85 87 210 5 299 -61 66 -134 86 -223 63z m106 -120 c3 -43 3
        -43 46 -46 42 -3 42 -3 42 -42 0 -39 0 -39 -42 -42 -43 -3 -43 -3 -46 -45 -3
        -43 -3 -43 -42 -43 -39 0 -39 0 -42 43 -3 42 -3 42 -45 45 -43 3 -43 3 -43 42
        0 39 0 39 43 42 42 3 42 3 45 46 3 42 3 42 42 42 39 0 39 0 42 -42z"
            />
        </g>
    </svg>
);

export const RemoveUserIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 30 130.000000 85.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M930 1221 c-146 -48 -226 -203 -176 -343 51 -143 228 -214 362 -145
        102 52 150 139 142 255 -7 93 -58 171 -143 214 -43 22 -144 33 -185 19z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M882 663 c-160 -34 -213 -56 -279 -116 -90 -83 -118 -173 -69 -222
        43 -43 83 -48 409 -52 l308 -5 -32 45 c-54 78 -52 196 6 281 13 20 21 37 17
        40 -6 3 -153 36 -227 50 -11 2 -71 -7 -133 -21z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1366 658 c-25 -7 -57 -28 -87 -58 -91 -91 -89 -221 5 -308 90 -83
        215 -81 300 4 85 85 87 210 5 299 -61 66 -134 86 -223 63z m194 -208 l0 -40
        -130 0 -130 0 0 40 0 40 130 0 130 0 0 -40z"
            />
        </g>
    </svg>
);

export const FobIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="48 38 105.000000 80.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M930 1185 l0 -64 -42 -12 c-71 -19 -139 -58 -194 -113 -62 -63 -99
        -132 -121 -228 -63 -279 211 -558 498 -508 192 33 335 176 370 370 22 124 -27
        268 -125 366 -55 55 -123 94 -194 113 l-42 12 0 64 0 65 -75 0 -75 0 0 -65z
        m120 -431 l0 -76 55 47 c31 26 59 45 62 41 4 -3 -10 -21 -30 -38 l-37 -33 40
        -52 c42 -54 46 -63 31 -63 -5 0 -26 22 -46 50 -31 43 -39 48 -56 40 -13 -7
        -19 -21 -19 -45 0 -18 -4 -37 -10 -40 -6 -4 -10 38 -10 119 0 77 4 126 10 126
        6 0 10 -32 10 -76z m260 46 c0 -5 -25 -10 -55 -10 -30 0 -55 5 -55 10 0 6 25
        10 55 10 30 0 55 -4 55 -10z m-505 -44 c15 -11 20 -30 23 -86 3 -45 0 -76 -7
        -83 -8 -8 -11 7 -11 57 0 83 -11 106 -50 106 -41 0 -60 -32 -60 -102 0 -32 -4
        -58 -10 -58 -6 0 -10 35 -10 85 0 50 4 85 10 85 6 0 10 -5 10 -12 0 -8 6 -6
        17 5 21 21 62 22 88 3z m180 -12 c34 -37 34 -101 0 -138 -31 -33 -74 -34 -112
        -2 -23 20 -28 32 -28 71 0 39 5 51 28 71 38 32 81 31 112 -2z m314 9 c11 -10
        24 -33 27 -50 l7 -33 -72 0 c-60 0 -71 -3 -71 -17 0 -51 77 -72 106 -28 9 14
        20 25 25 25 16 0 9 -21 -16 -45 -55 -56 -135 -15 -135 70 0 35 6 52 25 70 29
        30 74 33 104 8z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M886 734 c-49 -48 -20 -134 44 -134 35 0 60 31 60 75 0 64 -64 100
        -104 59z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1207 732 c-30 -33 -21 -42 43 -42 33 0 60 3 60 8 0 4 -7 18 -16 30
        -19 27 -64 29 -87 4z"
            />
        </g>
    </svg>
);

export const MotionIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="80 100 150.000000 95.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,304.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1876 2195 c-3 -9 12 -34 38 -64 63 -71 101 -130 146 -223 154 -322
        99 -709 -139 -981 -49 -56 -56 -79 -24 -91 34 -14 180 184 233 316 40 101 59
        176 70 280 27 258 -67 547 -238 731 -45 48 -75 59 -86 32z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1727 2023 c-15 -14 -5 -35 38 -89 59 -72 111 -177 131 -262 24 -100
        15 -264 -19 -360 -27 -77 -90 -182 -132 -222 -28 -27 -33 -58 -9 -67 39 -15
        155 148 199 282 37 108 45 250 21 361 -22 101 -92 244 -151 312 -44 49 -63 60
        -78 45z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1393 1970 c-53 -32 -61 -113 -17 -161 37 -41 127 -32 159 15 20 27
        19 91 -1 121 -15 23 -61 45 -93 45 -9 0 -30 -9 -48 -20z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M1257 1731 c-65 -21 -122 -42 -128 -48 -16 -16 -38 -204 -27 -225 10
        -21 41 -24 56 -5 8 10 32 141 32 177 0 8 90 40 111 40 16 0 -90 -312 -135
        -394 -26 -47 -50 -86 -54 -86 -5 0 -61 18 -126 40 -90 30 -123 37 -137 29 -22
        -11 -25 -42 -6 -56 19 -16 295 -105 305 -99 5 3 37 48 72 101 34 52 66 95 69
        95 4 0 39 -33 80 -74 l73 -74 19 -152 c10 -83 23 -158 30 -166 15 -18 33 -18
        50 2 11 13 10 44 -5 182 l-18 167 -75 76 -75 76 33 117 c18 64 36 116 39 116
        4 0 16 -23 27 -52 29 -77 39 -79 125 -34 107 57 128 74 128 101 0 40 -33 40
        -104 1 -35 -20 -68 -36 -73 -36 -4 0 -26 40 -47 88 -40 89 -74 132 -104 132
        -9 -1 -70 -18 -135 -39z"
            />
        </g>
    </svg>
);

export const ActivityUserIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 30 130.000000 85.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M930 1221 c-50 -16 -87 -40 -122 -79 -124 -137 -69 -356 105 -421 36
        -14 138 -14 174 0 174 65 229 284 105 421 -20 22 -54 49 -76 60 -44 22 -145
        33 -186 19z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M875 665 c-142 -32 -188 -49 -253 -97 -67 -50 -104 -105 -110 -166
        -4 -44 -2 -51 27 -74 54 -46 116 -53 461 -53 343 0 407 7 460 52 23 19 30 33
        30 61 0 78 -77 175 -179 223 -43 20 -202 60 -286 72 -25 4 -82 -3 -150 -18z"
            />
        </g>
    </svg>
);

export const PhoneIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100.000000 100.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M185 921 c-51 -31 -125 -117 -125 -146 0 -49 42 -151 98 -235 73
        -112 270 -309 382 -382 84 -56 186 -98 235 -98 18 0 44 17 82 52 63 60 87 100
        79 132 -6 24 -193 156 -221 156 -9 0 -38 -11 -66 -25 -28 -14 -58 -23 -68 -20
        -22 7 -231 218 -231 234 0 6 11 34 25 61 14 27 25 56 25 65 0 18 -114 193
        -138 213 -22 17 -42 15 -77 -7z m115 -111 c33 -49 60 -93 60 -98 0 -5 -14 -34
        -31 -66 -30 -55 -30 -57 -14 -84 26 -41 239 -249 263 -256 13 -5 37 4 71 24
        29 16 56 30 62 30 14 0 189 -119 189 -129 0 -14 -71 -99 -97 -116 -73 -48
        -261 62 -463 272 -148 153 -240 300 -240 385 0 23 104 128 127 128 7 0 40 -40
        73 -90z"
            />
        </g>
    </svg>
);

export const EmailIcon = (props) => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50.000000 50.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                strokeMiterlimit="2"
                d="M0 250 l0 -180 250 0 250 0 0 180 0 180 -250 0 -250 0 0 -180z m480
        147 c0 -18 -209 -197 -230 -197 -20 0 -224 175 -228 196 -3 12 32 14 227 14
        185 0 231 -3 231 -13z m-371 -115 c97 -88 125 -106 154 -98 12 3 64 41 115 86
        51 44 95 80 97 80 3 0 5 -58 5 -130 l0 -130 -230 0 -230 0 0 130 c0 72 3 130
        6 130 4 0 41 -31 83 -68z"
            />
        </g>
    </svg>
);

export const RepeaterIcon = (props) => (
    <svg 
        version="1.0" 
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 28}
        height={props.height || 28}
        viewBox="0 110 200.000000 1.000000"
        preserveAspectRatio="xMidYMid meet">
        <g 
            transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
            fill="#000000" 
            stroke="none">
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M891 1619 c-41 -5 -109 -18 -150 -30 -82 -22 -193 -68 -189 -78 2 -3
            17 -27 33 -53 21 -33 35 -46 45 -41 257 110 504 110 761 -1 10 -5 20 3 32 26
            9 18 24 43 33 55 15 21 14 22 -33 43 -80 36 -205 68 -306 79 -107 12 -120 12
            -226 0z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M181 1534 c-133 -67 -157 -240 -47 -342 73 -67 164 -78 251 -29 114
            64 140 224 52 324 -66 75 -164 93 -256 47z m140 -125 c29 -15 40 -52 28 -89
            -20 -55 -82 -68 -124 -25 -30 30 -32 64 -4 99 22 28 64 35 100 15z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M1635 1541 c-161 -74 -169 -302 -13 -382 86 -44 173 -33 244 33 110
            102 86 275 -47 342 -63 31 -126 34 -184 7z m144 -147 c28 -35 26 -69 -4 -99
            -24 -24 -57 -31 -90 -19 -24 10 -46 60 -39 89 14 57 97 75 133 29z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M844 1345 c-182 -39 -367 -162 -469 -309 l-38 -55 38 -50 c20 -28 40
            -51 43 -51 4 0 23 25 42 56 43 68 151 173 222 214 29 17 89 42 133 57 68 22
            97 26 195 26 97 0 127 -4 195 -26 146 -48 273 -144 356 -270 20 -32 40 -58 44
            -58 4 0 23 21 42 47 l36 47 -19 36 c-27 52 -180 200 -246 240 -77 45 -165 79
            -246 96 -83 18 -247 18 -328 0z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M876 1094 c-121 -29 -250 -121 -318 -227 -62 -95 -62 -95 -10 -164
            l45 -62 19 55 c65 194 264 316 460 284 159 -25 303 -149 339 -291 7 -27 15
            -49 18 -49 3 0 26 28 50 61 l43 60 -28 57 c-37 76 -151 190 -230 230 -120 61
            -259 77 -388 46z"/>
            <path                 
            stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M917 846 c-154 -55 -234 -223 -181 -379 22 -64 91 -139 156 -168 70
            -31 173 -32 239 -2 60 27 125 92 152 152 30 66 29 169 -2 239 -29 65 -104 134
            -168 156 -56 19 -144 20 -196 2z m145 -116 c41 -12 104 -75 114 -115 27 -109
            -54 -215 -166 -215 -51 0 -88 18 -127 63 -75 85 -36 224 72 262 49 17 60 18
            107 5z"/>
        </g>
    </svg>
)

export const RelayIcon = (props) => (
    <svg 
        version="1.0" 
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 28}
        height={props.height || 28}
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
            <path 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M175 5096 c-59 -28 -114 -83 -147 -146 l-23 -45 -3 -2327 -2 -2327
            21 -57 c29 -77 96 -144 173 -173 l57 -21 2254 2 2253 3 26 24 c34 32 42 80 22
            123 -25 51 -794 815 -830 824 -17 4 -49 2 -75 -6 -126 -35 -151 -40 -216 -40
            -231 1 -430 157 -490 387 -80 307 171 622 495 623 225 0 438 -172 490 -399 17
            -74 8 -211 -19 -281 -25 -65 -26 -91 -7 -128 18 -33 782 -795 813 -811 49 -25
            123 -7 142 36 8 17 11 648 11 2281 l0 2257 -24 50 c-34 73 -69 110 -138 144
            l-61 31 -936 0 -936 0 -558 -558 c-307 -307 -563 -565 -568 -573 -15 -24 -10
            -81 12 -139 65 -169 15 -383 -122 -519 -200 -201 -516 -199 -714 3 -125 128
            -174 309 -130 481 46 175 207 329 382 365 77 16 205 8 278 -19 70 -25 96 -26
            133 -7 15 8 206 194 425 413 l397 399 0 51 c0 41 -5 55 -26 77 l-27 26 -1141
            0 -1141 0 -50 -24z m1752 -454 l-269 -269 -51 15 c-65 18 -275 21 -337 4 -278
            -77 -466 -265 -542 -542 -18 -68 -15 -262 5 -340 56 -208 192 -376 382 -470
            201 -99 442 -97 654 7 60 29 97 58 171 133 108 107 154 187 190 326 26 98 28
            261 5 349 l-16 59 498 498 498 498 868 0 869 0 29 -29 29 -29 0 -2089 0 -2088
            -268 268 -269 269 15 51 c21 76 21 266 -1 347 -56 209 -192 376 -382 470 -201
            99 -442 97 -654 -7 -107 -53 -251 -197 -304 -304 -76 -154 -99 -345 -62 -504
            58 -254 265 -463 525 -532 83 -22 261 -22 347 -1 l61 15 269 -269 268 -268
            -2078 0 c-2284 0 -2119 -5 -2152 60 -13 26 -15 289 -15 2290 0 2462 -3 2311
            53 2338 15 7 325 11 977 11 l955 1 -268 -268z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M3555 4396 c-283 -56 -507 -267 -570 -541 -21 -87 -21 -249 -1 -330
            l15 -60 -672 -672 -672 -672 -60 15 c-81 20 -243 20 -330 -1 -254 -58 -462
            -264 -532 -525 -20 -78 -23 -272 -5 -340 76 -277 265 -466 542 -542 68 -18
            262 -15 340 5 261 70 467 278 525 532 21 87 21 249 1 330 l-15 60 672 672 672
            672 60 -15 c81 -20 243 -20 330 1 254 58 462 264 532 525 20 78 23 272 5 340
            -75 273 -263 464 -527 537 -75 20 -229 25 -310 9z m260 -221 c87 -23 152 -62
            225 -135 104 -104 150 -213 150 -355 -1 -234 -158 -431 -393 -492 -79 -20
            -189 -13 -276 17 -126 44 -48 109 -888 -732 -737 -737 -743 -744 -743 -784 0
            -22 9 -67 21 -99 113 -321 -133 -664 -476 -665 -142 0 -251 46 -355 150 -104
            104 -150 213 -150 355 1 234 158 431 393 492 79 20 189 13 276 -17 126 -44 48
            -109 888 732 737 737 743 744 743 784 0 22 -9 67 -21 99 -95 269 68 573 348
            650 66 18 187 18 258 0z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M3635 3889 c-88 -20 -155 -107 -155 -201 1 -124 85 -208 210 -208
            186 0 274 230 138 361 -46 43 -126 63 -193 48z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M1338 1620 c-109 -58 -145 -204 -76 -306 87 -127 287 -112 358 27 38
            74 18 191 -41 246 -59 54 -171 69 -241 33z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M1385 3889 c-79 -19 -136 -77 -154 -159 -28 -128 69 -250 199 -250
            125 0 209 84 210 208 0 135 -122 232 -255 201z"/>
            <path                 
                stroke={props.color || 'none'}
                strokeWidth="1"
                fill={props.color || '#0070CE'}
                d="M3595 1621 c-74 -34 -115 -102 -115 -191 0 -164 189 -261 326 -168
            127 87 112 287 -27 358 -49 25 -130 26 -184 1z"/>
        </g>
    </svg>
)

export const ScheduleIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 9.41 10.14">
        <path
            stroke={props.color || 'none'}
            strokeWidth=".25"
            fill={props.fill || 'none'}
            d="M9.42,10.46H3.21A1.48,1.48,0,0,1,1.74,9V2.77A1.47,1.47,0,0,1,3.21,1.3H9.42A1.48,1.48,0,0,1,10.9,2.77V9A1.49,1.49,0,0,1,9.42,10.46Zm-6.21-9a1.3,1.3,0,0,0-1.3,1.3V9a1.3,1.3,0,0,0,1.3,1.3H9.42A1.3,1.3,0,0,0,10.72,9V2.77a1.3,1.3,0,0,0-1.3-1.3Z"
            transform="translate(-1.61 -0.44)"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".25"
            fill={props.fill || 'none'}
            x="0.21"
            y="3.37"
            width="8.98"
            height="0.17"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth=".25"
            fill={props.fill || 'none'}
            d="M4.47,2.94a.09.09,0,0,1-.08-.09V.66A.09.09,0,0,1,4.47.57a.09.09,0,0,1,.09.09V2.85A.09.09,0,0,1,4.47,2.94Z"
            transform="translate(-1.61 -0.44)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth=".25"
            fill={props.fill || 'none'}
            d="M8.16,2.94a.09.09,0,0,1-.09-.09V.66A.09.09,0,0,1,8.16.57a.08.08,0,0,1,.08.09V2.85A.08.08,0,0,1,8.16,2.94Z"
            transform="translate(-1.61 -0.44)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth=".25"
            fill={props.fill || 'none'}
            d="M5.71,8.45a.23.23,0,0,1-.33,0L4,6.94a.11.11,0,0,1,0-.13.09.09,0,0,1,.13,0L5.54,8.37l3-3a.08.08,0,0,1,.12.12Z"
            transform="translate(-1.61 -0.44)"
        />
    </svg>
);

export const AccessCodesSendIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 62.16 85.47">
        <path
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            d="M60.28,27.51A1.48,1.48,0,0,0,58.8,29V72.43a5,5,0,0,1-5,5H8l6.32-6.73a1.48,1.48,0,0,0-2.15-2l-8,8.52a2.23,2.23,0,0,0,0,3.08l7.44,7.44a1.47,1.47,0,0,0,2.08-2.09L8.47,80.35H53.83a7.93,7.93,0,0,0,7.92-7.92V29A1.47,1.47,0,0,0,60.28,27.51Z"
            transform="translate(-3.56 -2.64)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            d="M65.06,10.51,57.62,3.08a1.47,1.47,0,1,0-2.08,2.08l5.25,5.25H15.43a7.93,7.93,0,0,0-7.92,7.93V62.59a1.48,1.48,0,1,0,3,0V18.34a5,5,0,0,1,5-5H61.27L55,20.09A1.46,1.46,0,0,0,55,22.17a1.44,1.44,0,0,0,1,.4,1.45,1.45,0,0,0,1.07-.46l8-8.52A2.21,2.21,0,0,0,65.06,10.51Z"
            transform="translate(-3.56 -2.64)"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            x="27.8"
            y="24.92"
            width="6.99"
            height="7.27"
            rx="0.31"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            x="41.4"
            y="24.92"
            width="6.99"
            height="7.27"
            rx="0.31"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            x="13.76"
            y="39.38"
            width="6.99"
            height="7.27"
            rx="0.31"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            x="27.8"
            y="39.38"
            width="6.99"
            height="7.27"
            rx="0.31"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            x="41.4"
            y="39.38"
            width="6.99"
            height="7.27"
            rx="0.31"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            x="13.42"
            y="53.93"
            width="6.99"
            height="7.27"
            rx="0.31"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            x="27.46"
            y="53.93"
            width="6.99"
            height="7.27"
            rx="0.31"
        />
    </svg>
);

export const ErrorIcon = (props) => (
    <svg width={props.width || 25} height={props.height || 25} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            stroke={props.color || 'none'}
            strokeWidth=".75"
            fill={props.fill || 'none'}
            d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
        />
    </svg>
);

export const SharedUserIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="10 13 80 70">
        <circle
            stroke={props.color || 'none'}
            strokeWidth="2.5"
            fill={props.fill || 'none'}
            cx="50.45"
            cy="41.28"
            r="11.31"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2.5"
            fill={props.fill || 'none'}
            d="M56.6,56.82H44.3c-7.35,0-17.12,6.63-17.12,14.82h0a2.77,2.77,0,0,0,2.61,2.9H71.12a2.77,2.77,0,0,0,2.61-2.9h0C73.73,63.45,64,56.82,56.6,56.82Z"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2.5"
            fill={props.fill || 'none'}
            d="M36.54,44.5c-.32,0-.65,0-1,0A9.11,9.11,0,1,1,42,29"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2.5"
            fill={props.fill || 'none'}
            d="M37.74,48H30.6c-5.92,0-13.79,5.35-13.79,11.94h0a2.23,2.23,0,0,0,2.1,2.34h8.6"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2.5"
            fill={props.fill || 'none'}
            d="M64.36,44.5c.33,0,.66,0,1,0A9.11,9.11,0,1,0,58.92,29"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2.5"
            fill={props.fill || 'none'}
            d="M63.17,48h7.14C76.23,48,84.1,53.3,84.1,59.89h0A2.23,2.23,0,0,1,82,62.23H73.39"
        />
    </svg>
);

export const ServiceUserIcon = (props) => (
    <svg width={props.width || 30} height={props.height || 30} viewBox="0 0 25.32 24.55">
        <polyline
            stroke={props.color || 'none'}
            strokeWidth="1px"
            fill={props.fill || 'none'}
            points="10.9 3.94 10.9 0.19 12.9 0.19 12.9 3.94"
        />
        <line
            stroke={props.color || 'none'}
            strokeWidth="1px"
            fill={props.fill || 'none'}
            x1="18.66"
            y1="6.57"
            x2="5.15"
            y2="6.57"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1px"
            fill={props.fill || 'none'}
            d="M11.75,5.59V3.45a4.55,4.55,0,0,0-3,4.29v.53l-.51.53v.54"
            transform="translate(-2.34 -2.72)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1px"
            fill={props.fill || 'none'}
            d="M16.74,5.59V3.45a4.58,4.58,0,0,1,3,4.29v.53l.5.53v.54"
            transform="translate(-2.34 -2.72)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1px"
            fill={props.fill || 'none'}
            d="M26.85,17.06l-2.4,2.4-1.93-1.92,2.41-2.4c-1-1-3.05-.8-4.33.5a3.27,3.27,0,0,0-.84,3.62,1.29,1.29,0,0,1-.33,1.39l-4.06,4.06a1.43,1.43,0,0,0-.2,1.81,1.36,1.36,0,0,0,1.89.32l.18-.15,4.11-4.11a1.31,1.31,0,0,1,1.4-.33,3.26,3.26,0,0,0,3.62-.85C27.65,20.11,27.83,18,26.85,17.06Z"
            transform="translate(-2.34 -2.72)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1px"
            fill={props.fill || 'none'}
            d="M19.68,10.48a5.42,5.42,0,0,1-10.83,0"
            transform="translate(-2.34 -2.72)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="1px"
            fill={props.fill || 'none'}
            d="M17.82,18H11.06c-3.67,0-8.53,3.32-8.53,7.41h0a1.38,1.38,0,0,0,1.3,1.45H13.5"
            transform="translate(-2.34 -2.72)"
        />
    </svg>
);

export const SupportUserIcon = (props) => (
    <svg
        width={props.width || 30}
        height={props.height || 30}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="21 28 55 42">
        <path
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            d="M42.87,56.57H55.21c7.37,0,17.17,6.65,17.17,14.86h0a2.78,2.78,0,0,1-2.62,2.92H28.31a2.79,2.79,0,0,1-2.62-2.92h0C25.69,63.22,35.49,56.57,42.87,56.57Z"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            d="M60.76,39.31a11.72,11.72,0,0,0-23.44,0"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            x="33.38"
            y="38.07"
            width="3.92"
            height="9.33"
            rx="0.79"
            transform="translate(70.69 85.47) rotate(-180)"
        />
        <rect
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            x="60.77"
            y="38.07"
            width="3.92"
            height="9.33"
            rx="0.79"
            transform="translate(125.46 85.47) rotate(-180)"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            d="M40.32,41.48s8.12-.34,8.7-7"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            d="M57.69,41.52s-8.12-.38-8.71-7"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            d="M40.63,47.72a10.16,10.16,0,0,1-.55-3.33,10.5,10.5,0,0,1,.45-3"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            d="M57.5,41.45a10.2,10.2,0,0,1,.43,2.94c0,5.31-4,9.62-8.93,9.62a8.66,8.66,0,0,1-6.82-3.42"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            d="M35.41,47.25a1.94,1.94,0,0,0,1.94,2h11"
        />
        <path
            stroke={props.color || 'none'}
            strokeWidth="2"
            fill={props.fill || 'none'}
            d="M45.67,47.59H50.9a.2.2,0,0,1,.2.2V50.4a.2.2,0,0,1-.2.2H45.67a.51.51,0,0,1-.51-.51v-2a.51.51,0,0,1,.51-.51Z"
            transform="translate(96.27 98.2) rotate(-180)"
        />
    </svg>
);

export const ThermometerIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 477.833 477.833"
        style={{ enableBackground: 'new 0 0 477.833 477.833' }}>
        <g>
            <g>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.color || 'none'}
                    d="M268.492,358.572c-2.996-5.189-7.305-9.498-12.494-12.494V187.733c0-9.426-7.641-17.067-17.067-17.067
			s-17.067,7.641-17.067,17.067v158.345c-16.326,9.426-21.919,30.301-12.494,46.627s30.301,21.919,46.627,12.494
			C272.324,395.773,277.918,374.897,268.492,358.572z"
                />
            </g>
        </g>
        <g>
            <g>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.color || 'none'}
                    d="M324.265,319.351V85.333C324.209,38.228,286.037,0.056,238.932,0c-47.105,0.056-85.277,38.228-85.333,85.333v234.018
			c-15.521,23.169-20.777,51.722-14.524,78.899c8.979,39.023,39.802,69.279,78.985,77.534c6.822,1.364,13.762,2.05,20.719,2.048
			c56.497,0.141,102.412-45.544,102.553-102.041c0-0.108,0-0.216,0-0.325C341.317,355.486,335.378,335.957,324.265,319.351z
			 M282.23,428.339l-0.034,0.034c-29.156,23.904-72.17,19.646-96.074-9.511c-6.688-8.157-11.394-17.754-13.75-28.036
			c-4.482-19.476-0.107-39.936,11.947-55.876c2.216-2.954,3.413-6.547,3.413-10.24V85.333c0-28.277,22.923-51.2,51.2-51.2
			s51.2,22.923,51.2,51.2v239.394c0,3.693,1.198,7.286,3.413,10.24C315.527,364.062,310.525,405.338,282.23,428.339z"
                />
            </g>
        </g>
    </svg>
);

export const StethoscopeIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="90 -20 8 231"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <path
            stroke={props.color || 'none'}
            fill={props.color || 'none'}
            strokeWidth="2.5"
            d="M158.121,91.413c0-13.733-11.175-24.906-24.91-24.906c-13.735,0-24.91,11.173-24.91,24.906
        c0,11.124,7.329,20.565,17.41,23.756v24.946c0,14.044-11.426,25.471-25.471,25.471c-14.042,0-25.467-11.426-25.467-25.471V88.978
        c21.146-3.581,37.307-22.016,37.307-44.165V7.5c0-4.142-3.357-7.5-7.5-7.5H85.928c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5
        H97.08v29.813c0,16.435-13.371,29.805-29.807,29.805c-16.437,0-29.809-13.37-29.809-29.805V15h11.154c4.143,0,7.5-3.358,7.5-7.5
        S52.762,0,48.619,0H29.965c-4.143,0-7.5,3.358-7.5,7.5v37.313c0,22.149,16.16,40.585,37.309,44.165v51.138
        c0,22.315,18.153,40.471,40.467,40.471c22.315,0,40.471-18.155,40.471-40.471v-24.946
        C150.792,111.979,158.121,102.537,158.121,91.413z M133.211,101.325c-5.465,0-9.91-4.447-9.91-9.912c0-5.462,4.445-9.906,9.91-9.906
        c5.465,0,9.91,4.444,9.91,9.906C143.121,96.878,138.676,101.325,133.211,101.325z"
        />
    </svg>
);

export const MaxStrengthIcon = (props) => (
    <svg
        width={props.width || 30}
        height={props.height || 30}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100.000000 100.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
            fill={props.fill || 'none'}
            stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M693 752 c-16 -17 -19 -472 -3 -503 8 -15 21 -19 58 -19 27 0 53 5
    60 12 14 14 17 484 3 506 -11 19 -101 21 -118 4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M527 624 c-13 -13 -8 -369 5 -382 16 -16 93 -15 107 2 8 9 11 70 9
    197 l-3 184 -55 3 c-31 2 -59 0 -63 -4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M366 492 c-8 -13 -9 -239 -2 -251 10 -15 99 -14 114 1 17 17 17 229
    0 246 -13 13 -104 17 -112 4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M203 364 c-18 -8 -17 -108 1 -123 8 -7 36 -11 63 -9 l48 3 0 65 0 65
    -50 2 c-27 1 -56 0 -62 -3z"
            />
        </g>
    </svg>
);

export const HighStrengthIcon = (props) => (
    <svg
        width={props.width || 30}
        height={props.height || 30}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100.000000 100.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
            fill={props.fill || 'none'}
            stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M693 752 c-16 -17 -19 -472 -3 -503 8 -15 21 -19 58 -19 27 0 53 5
    60 12 14 14 17 484 3 506 -11 19 -101 21 -118 4z m87 -252 l0 -230 -30 0 -30
    0 0 230 0 230 30 0 30 0 0 -230z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M527 624 c-13 -13 -8 -369 5 -382 16 -16 93 -15 107 2 8 9 11 70 9
    197 l-3 184 -55 3 c-31 2 -59 0 -63 -4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M366 492 c-8 -13 -9 -239 -2 -251 10 -15 99 -14 114 1 17 17 17 229
    0 246 -13 13 -104 17 -112 4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M203 364 c-18 -8 -17 -108 1 -123 8 -7 36 -11 63 -9 l48 3 0 65 0 65
    -50 2 c-27 1 -56 0 -62 -3z"
            />
        </g>
    </svg>
);

export const MedStrengthIcon = (props) => (
    <svg
        width={props.width || 30}
        height={props.height || 30}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100.000000 100.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
            fill={props.fill || 'none'}
            stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M693 752 c-16 -17 -19 -472 -3 -503 8 -15 21 -19 58 -19 27 0 53 5
    60 12 14 14 17 484 3 506 -11 19 -101 21 -118 4z m87 -252 l0 -230 -30 0 -30
    0 0 230 0 230 30 0 30 0 0 -230z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M527 624 c-13 -13 -8 -369 5 -382 16 -16 93 -15 107 2 8 9 11 70 9
    197 l-3 184 -55 3 c-31 2 -59 0 -63 -4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M366 492 c-8 -13 -9 -239 -2 -251 10 -15 99 -14 114 1 17 17 17 229
    0 246 -13 13 -104 17 -112 4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M203 364 c-18 -8 -17 -108 1 -123 8 -7 36 -11 63 -9 l48 3 0 65 0 65
    -50 2 c-27 1 -56 0 -62 -3z"
            />
        </g>
    </svg>
);

export const LowStrengthIcon = (props) => (
    <svg
        width={props.width || 30}
        height={props.height || 30}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100.000000 100.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
            fill={props.fill || 'none'}
            stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M693 752 c-16 -17 -19 -472 -3 -503 8 -15 21 -19 58 -19 27 0 53 5
    60 12 14 14 17 484 3 506 -11 19 -101 21 -118 4z m87 -252 l0 -230 -30 0 -30
    0 0 230 0 230 30 0 30 0 0 -230z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M527 624 c-13 -13 -8 -369 5 -382 16 -16 93 -15 107 2 8 9 11 70 9
    197 l-3 184 -55 3 c-31 2 -59 0 -63 -4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M366 492 c-8 -13 -9 -239 -2 -251 10 -15 99 -14 114 1 17 17 17 229
    0 246 -13 13 -104 17 -112 4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                d="M203 364 c-18 -8 -17 -108 1 -123 8 -7 36 -11 63 -9 l48 3 0 65 0 65
    -50 2 c-27 1 -56 0 -62 -3z"
            />
        </g>
    </svg>
);

export const NoneStrengthIcon = (props) => (
    <svg
        width={props.width || 30}
        height={props.height || 30}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100.000000 100.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
            fill={props.fill || 'none'}
            stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M693 752 c-16 -17 -19 -472 -3 -503 8 -15 21 -19 58 -19 27 0 53 5
    60 12 14 14 17 484 3 506 -11 19 -101 21 -118 4z m87 -252 l0 -230 -30 0 -30
    0 0 230 0 230 30 0 30 0 0 -230z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M527 624 c-13 -13 -8 -369 5 -382 16 -16 93 -15 107 2 8 9 11 70 9
    197 l-3 184 -55 3 c-31 2 -59 0 -63 -4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M366 492 c-8 -13 -9 -239 -2 -251 10 -15 99 -14 114 1 17 17 17 229
    0 246 -13 13 -104 17 -112 4z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={'#D3D3D3'}
                d="M203 364 c-18 -8 -17 -108 1 -123 8 -7 36 -11 63 -9 l48 3 0 65 0 65
    -50 2 c-27 1 -56 0 -62 -3z"
            />
        </g>
    </svg>
);

export const ThermostatIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 30}
        height={props.height || 30}
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            fill={props.color || 'none'}
            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            stroke="none">
            <path
                stroke={props.color || 'none'}
                d="M2295 4850 c-290 -39 -531 -112 -780 -238 -567 -287 -991 -800 -1169
        -1415 -116 -400 -116 -874 0 -1274 107 -370 293 -689 564 -967 196 -202 382
        -337 630 -460 322 -160 653 -236 1022 -236 367 0 686 74 1013 234 464 229 818
        582 1050 1048 158 319 235 651 235 1018 0 370 -73 685 -235 1016 -226 462
        -587 823 -1049 1049 -214 105 -387 162 -626 207 -121 22 -534 33 -655 18z
        m495 -250 c239 -29 458 -93 665 -194 400 -196 714 -499 919 -888 156 -295 236
        -619 236 -958 0 -790 -443 -1499 -1155 -1846 -414 -202 -895 -257 -1350 -155
        -606 136 -1116 542 -1390 1106 -140 287 -204 569 -205 890 0 327 65 615 204
        900 108 220 228 388 400 560 318 317 724 517 1176 580 117 16 386 19 500 5z"
            />
            <path
                stroke={props.color || 'none'}
                d="M2350 4499 c-915 -103 -1629 -822 -1729 -1741 -88 -801 353 -1592
        1084 -1949 968 -472 2134 -71 2606 896 440 904 126 1983 -733 2517 -355 220
        -813 324 -1228 277z m260 -674 l0 -215 -50 0 -50 0 0 215 0 215 50 0 50 0 0
        -215z m-630 -153 c152 -262 190 -335 181 -346 -13 -15 -69 -41 -76 -34 -6 6
        -386 661 -392 675 -7 18 69 64 83 50 6 -7 98 -162 204 -345z m294 161 c26 -98
        51 -191 57 -207 7 -22 6 -32 -3 -38 -17 -10 -78 -22 -84 -15 -6 6 -103 362
        -107 391 -1 14 8 22 38 31 22 7 43 13 46 14 3 1 27 -79 53 -176z m694 156 c19
        -7 22 -14 16 -32 -4 -12 -29 -102 -55 -201 -26 -98 -50 -180 -53 -183 -6 -7
        -67 5 -84 15 -9 6 -10 16 -3 38 6 16 31 109 57 206 l47 178 26 -7 c14 -3 36
        -10 49 -14z m333 -140 c26 -13 39 -25 35 -34 -7 -20 -196 -349 -205 -358 -9
        -9 -81 30 -81 45 0 11 200 368 207 368 2 0 22 -9 44 -21z m-1596 -359 l150
        -150 -38 -37 -37 -38 -152 152 -152 152 34 36 c19 19 36 35 40 35 3 0 73 -67
        155 -150z m1905 115 l34 -36 -152 -152 -152 -152 -37 38 -38 37 150 150 c82
        83 152 150 155 150 4 0 21 -16 40 -35z m-1945 -495 c-36 -68 -22 -71 -228 45
        -205 117 -194 104 -150 171 14 22 16 21 202 -85 189 -106 189 -106 176 -131z
        m2181 189 c14 -22 24 -42 22 -44 -7 -6 -363 -207 -370 -208 -4 -1 -19 17 -33
        39 l-25 42 183 105 c100 58 185 105 189 106 4 0 19 -17 34 -40z m-1446 -349
        l0 -50 -36 0 c-124 0 -219 -77 -237 -192 -7 -43 -4 -44 49 -22 26 11 58 15
        101 12 74 -5 129 -38 178 -107 26 -37 30 -53 34 -123 4 -100 -9 -147 -57 -200
        -128 -142 -361 -81 -403 106 -7 32 -10 114 -7 216 3 152 5 169 29 221 31 65
        82 120 142 150 59 31 84 37 150 38 l57 1 0 -50z m600 1 l0 -48 -60 -6 c-79 -7
        -141 -43 -176 -102 -23 -40 -45 -125 -32 -125 3 0 22 7 41 15 57 23 135 19
        194 -10 60 -30 100 -78 119 -143 53 -176 -57 -342 -225 -342 -71 0 -125 25
        -173 78 -55 61 -60 91 -56 312 3 189 4 197 30 246 56 107 163 172 286 173 l52
        1 0 -49z m-1647 -13 l199 -53 -7 -40 c-3 -22 -10 -44 -15 -49 -6 -6 -318 69
        -406 99 -14 4 4 95 19 95 6 0 100 -24 210 -52z m2644 6 c8 -33 8 -47 -1 -49
        -88 -30 -400 -105 -406 -99 -5 5 -12 27 -15 49 l-7 40 194 52 c106 28 200 52
        209 52 11 1 19 -13 26 -45z m-2487 -384 l0 -50 -215 0 -215 0 0 50 0 50 215 0
        215 0 0 -50z m2530 0 l0 -50 -215 0 -215 0 0 50 0 50 215 0 215 0 0 -50z
        m-2506 -238 c3 -5 8 -26 11 -48 l7 -39 -199 -53 c-109 -29 -203 -52 -210 -52
        -6 0 -14 18 -18 40 -4 22 -7 43 -8 46 -2 7 362 110 395 113 9 0 19 -3 22 -7z
        m2263 -42 c103 -28 193 -53 200 -55 8 -3 8 -15 1 -47 -6 -24 -13 -45 -14 -47
        -2 -2 -97 20 -210 50 l-206 54 7 39 c6 44 12 56 25 56 5 0 93 -23 197 -50z
        m-2139 -251 l22 -37 -182 -103 c-100 -57 -185 -105 -189 -107 -4 -2 -20 16
        -35 39 -15 24 -23 45 -18 46 5 2 90 50 189 107 99 57 183 101 186 98 3 -4 16
        -23 27 -43z m2027 -65 l186 -106 -25 -41 c-13 -23 -28 -41 -33 -39 -4 1 -90
        49 -190 105 l-182 103 25 42 c14 23 27 42 29 42 2 0 88 -48 190 -106z m-1865
        -149 l34 -36 -152 -152 -152 -152 -37 38 -38 37 150 150 c82 83 152 150 155
        150 4 0 21 -16 40 -35z m1675 -115 l150 -150 -38 -37 -37 -38 -152 152 -152
        152 34 36 c19 19 36 35 40 35 3 0 73 -67 155 -150z m-840 -175 c83 -34 145
        -128 145 -220 0 -93 -62 -186 -147 -222 -18 -7 -60 -13 -93 -13 -102 0 -175
        46 -216 135 -33 70 -32 136 4 205 59 117 187 165 307 115z"
            />
            <path
                stroke={props.color || 'none'}
                d="M2193 2580 c-50 -30 -67 -64 -67 -135 0 -71 17 -105 67 -135 65 -40
        154 -13 183 55 21 50 18 133 -6 172 -37 61 -116 81 -177 43z"
            />
            <path
                stroke={props.color || 'none'}
                d="M2801 2582 c-91 -50 -97 -218 -9 -272 83 -51 184 0 202 102 23 129
        -89 228 -193 170z"
            />
            <path
                stroke={props.color || 'none'}
                d="M2483 1419 c-45 -29 -70 -96 -55 -147 6 -21 25 -51 42 -67 28 -26 38
        -30 91 -30 57 0 63 2 94 37 45 49 53 95 26 150 -11 24 -34 51 -50 61 -40 23
        -108 22 -148 -4z"
            />
        </g>
    </svg>
);

export const HubspotIcon = (props) => (
    <svg 
        version="1.0" 
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 30}
        height={props.height || 30} 
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
         stroke={props.color || 'none'} fill={props.color || 'none'}>
            <path stroke={props.color || 'none'} fill={props.color || 'none'} d="M2315 5109 c-800 -83 -1501 -518 -1927 -1196 -487 -774 -516 -1777
            -75 -2578 200 -364 487 -676 841 -913 238 -159 600 -311 876 -366 214 -43 295
            -51 530 -51 236 0 333 10 532 51 880 184 1615 842 1898 1702 92 278 125 491
            125 802 0 301 -32 513 -116 775 -124 390 -330 728 -622 1024 -399 404 -893
            653 -1462 737 -123 18 -478 26 -600 13z m-692 -1102 c73 -36 149 -119 177
            -194 16 -44 21 -76 19 -137 l-2 -81 439 -343 c241 -188 490 -381 551 -428
            l113 -86 52 35 c103 68 215 114 341 141 l27 6 0 203 -1 202 -44 27 c-121 73
            -169 254 -105 391 111 236 459 236 570 0 64 -137 18 -308 -106 -394 l-44 -30
            0 -198 0 -199 68 -16 c318 -78 551 -302 649 -623 24 -79 26 -104 26 -238 0
            -134 -2 -159 -26 -238 -95 -312 -323 -534 -632 -618 -114 -31 -326 -31 -440 0
            -91 24 -203 75 -271 122 l-46 32 -162 -162 -161 -161 3 -74 c4 -63 0 -83 -20
            -128 -84 -183 -318 -229 -461 -90 -56 54 -79 105 -85 188 -4 61 -1 80 20 125
            33 73 66 109 130 144 48 27 62 30 140 29 l87 0 162 162 162 162 -20 29 c-11
            15 -33 53 -48 83 -125 249 -125 542 0 793 25 50 45 92 45 93 0 2 -243 193
            -541 424 l-540 421 -59 -22 c-81 -29 -192 -24 -270 12 -120 56 -192 166 -198
            304 -5 113 21 180 102 261 83 82 141 105 257 101 69 -2 96 -8 142 -30z"/>
            <path stroke={props.color || 'none'} fill={props.color || 'none'} d="M3361 2484 c-172 -46 -300 -187 -332 -365 -37 -209 92 -428 295 -500
            252 -88 523 57 591 316 85 329 -225 638 -554 549z"/>
        </g>
    </svg>
)

export const KnowledgeBaseIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 30}
        height={props.height || 30}
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill={props.color || 'none'}
            stroke="none">
            <path
                stroke={props.color || 'none'}
                d="M2534 4883 c-12 -2 -34 -18 -50 -34 -26 -27 -29 -38 -33 -110 -4
        -102 4 -141 35 -172 35 -35 75 -42 118 -22 53 25 69 68 64 181 -3 89 -5 95
        -33 123 -31 29 -64 41 -101 34z"
            />
            <path
                stroke={props.color || 'none'}
                d="M1583 4485 c-33 -14 -63 -59 -63 -95 0 -43 56 -112 144 -178 43 -33
        100 -30 137 7 24 24 29 38 29 76 0 45 -3 50 -67 112 -60 57 -115 94 -140 93
        -4 -1 -22 -7 -40 -15z"
            />
            <path
                stroke={props.color || 'none'}
                d="M3455 4486 c-16 -8 -60 -43 -97 -79 -65 -62 -68 -67 -68 -112 0 -38
        5 -52 29 -76 37 -37 94 -40 137 -7 88 66 144 135 144 178 0 37 -30 81 -65 96
        -41 17 -42 17 -80 0z"
            />
            <path
                stroke={props.color || 'none'}
                d="M2375 4354 c-297 -66 -551 -283 -664 -564 -89 -224 -78 -495 29 -719
        57 -118 116 -196 220 -292 117 -109 130 -137 130 -292 0 -218 61 -327 225
        -404 59 -27 64 -28 235 -28 215 1 261 14 350 104 87 88 102 128 110 302 6 134
        9 149 35 198 19 35 54 74 106 116 135 112 244 281 292 454 31 114 31 354 -1
        465 -91 318 -318 549 -629 642 -113 34 -327 43 -438 18z m322 -209 c50 -9 112
        -31 173 -61 79 -39 110 -62 181 -133 73 -73 93 -101 132 -181 60 -126 72 -181
        71 -320 -1 -95 -6 -129 -27 -195 -37 -111 -90 -196 -171 -274 -153 -146 -176
        -171 -201 -220 -39 -79 -55 -155 -55 -271 0 -121 -14 -161 -69 -197 -31 -21
        -45 -23 -178 -23 -163 0 -187 8 -226 70 -18 29 -22 56 -28 180 -9 213 -26 249
        -184 405 -120 118 -178 202 -214 310 -169 510 267 1010 796 910z"
            />
            <path
                stroke={props.color || 'none'}
                d="M1204 3560 c-35 -14 -64 -59 -64 -99 0 -74 55 -111 163 -111 89 0
        123 8 152 37 50 51 38 135 -25 168 -32 17 -189 20 -226 5z"
            />
            <path
                stroke={props.color || 'none'}
                d="M3688 3555 c-86 -48 -63 -179 33 -199 55 -11 158 -6 193 8 71 30 89
        110 37 168 -29 33 -30 33 -133 36 -78 2 -110 -2 -130 -13z"
            />
            <path
                stroke={props.color || 'none'}
                d="M509 3211 c-63 -9 -96 -33 -109 -80 -7 -27 -10 -373 -8 -1085 l3
        -1046 31 -31 32 -31 164 -4 c343 -7 647 -66 938 -182 218 -87 633 -305 889
        -468 47 -30 97 -54 111 -54 14 0 64 24 111 54 277 176 725 408 946 490 144 53
        359 109 506 130 119 18 380 36 474 33 58 -2 65 0 95 31 l33 32 3 1049 c2 826
        0 1056 -10 1087 -24 70 -50 77 -288 82 -290 6 -505 -17 -748 -79 -140 -36
        -170 -51 -188 -96 -20 -46 -10 -86 28 -118 38 -32 64 -32 203 5 170 46 353 70
        583 77 l202 6 0 -930 0 -930 -122 -7 c-434 -25 -797 -125 -1219 -336 -105 -53
        -342 -183 -430 -236 -31 -19 -59 -34 -63 -34 -3 0 -6 153 -6 340 0 365 -3 390
        -51 424 -30 21 -88 21 -118 0 -48 -34 -51 -59 -51 -424 0 -187 -2 -340 -5
        -340 -2 0 -63 34 -135 75 -630 362 -1041 500 -1582 531 l-118 7 0 930 0 930
        203 -6 c229 -7 412 -31 582 -77 139 -37 165 -37 203 -5 62 52 47 141 -30 175
        -93 40 -331 89 -537 110 -111 11 -446 12 -522 1z"
            />
            <path
                stroke={props.color || 'none'}
                d="M2274 1962 c-52 -42 -58 -106 -15 -154 l29 -33 272 0 272 0 29 33
        c43 48 37 112 -15 154 -19 16 -50 18 -286 18 -236 0 -267 -2 -286 -18z"
            />
            <path
                stroke={props.color || 'none'}
                d="M2344 1676 c-47 -47 -47 -95 0 -142 l34 -34 182 0 182 0 34 34 c26
        26 34 42 34 71 0 29 -8 45 -34 71 l-34 34 -182 0 -182 0 -34 -34z"
            />
        </g>
    </svg>
);

export const SuspiciousActivityIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={props.color || 'none'}
        width={props.width || 30}
        height={props.height || 30}
        version="1.1"
        id="Layer_1"
        viewBox="0 0 512.001 512.001">
        <g>
            <g>
                <path d="M263.974,4.588c-136.762,0-248.026,111.263-248.026,248.026c0,43.554,11.381,86.123,32.966,123.599    c-1.549,1.81-2.912,3.801-4.047,5.962L3.654,460.65c-8.18,15.578-2.163,34.908,13.416,43.089    c4.643,2.438,9.699,3.675,14.799,3.675c3.188,0,6.393-0.483,9.524-1.458c8.139-2.534,14.802-8.086,18.765-15.631l31.27-59.542    c21.039,20.409,45.239,36.749,72.091,48.657c31.704,14.059,65.502,21.187,100.456,21.187    c136.762,0,248.026-111.259,248.026-248.014C512,115.851,400.736,4.588,263.974,4.588z M85.674,403.607l-41.212,78.475    c-1.761,3.353-4.723,5.821-8.34,6.946c-3.617,1.126-7.457,0.776-10.81-0.985c-6.922-3.636-9.598-12.227-5.962-19.149    l41.214-78.476c1.761-3.353,4.723-5.821,8.34-6.946c1.391-0.433,2.815-0.648,4.232-0.648c2.266,0,4.513,0.55,6.576,1.633    c3.353,1.761,5.821,4.723,6.946,8.34C87.783,396.414,87.435,400.252,85.674,403.607z M263.974,482.898    c-32.463,0-63.843-6.616-93.27-19.666c-26.526-11.764-50.266-28.191-70.655-48.87l1.32-2.514    c3.963-7.547,4.75-16.184,2.216-24.323c-1.629-5.234-4.511-9.851-8.364-13.539l14.358-27.343    c15.277,6.644,31.855,10.137,48.45,10.137c45.362,0,86.635-24.933,107.708-65.067c15.078-28.705,18.057-61.609,8.394-92.649    c-9.666-31.04-30.797-56.434-59.499-71.504c-17.374-9.133-36.894-13.961-56.448-13.961c-45.366,0-86.637,24.928-107.707,65.055    c-15.105,28.744-18.107,61.656-8.453,92.672c8.769,28.171,27.026,51.703,51.85,67.093l-14.347,27.324    c-5.176-1.068-10.562-0.832-15.75,0.759c-19.714-34.576-30.099-73.781-30.099-113.888c0-126.987,103.31-230.297,230.297-230.297    c126.985,0,230.297,103.31,230.297,230.297C494.271,379.593,390.961,482.898,263.974,482.898z M58.952,266.059    c-8.246-26.494-5.683-54.605,7.22-79.158c17.999-34.277,53.256-55.57,92.012-55.57c16.692,0,33.358,4.124,48.203,11.927    c24.513,12.87,42.56,34.562,50.817,61.079c8.257,26.519,5.715,54.622-7.161,79.135c-18.002,34.284-53.26,55.581-92.012,55.581    c-16.68,0-33.353-4.124-48.215-11.926C85.26,314.234,67.195,292.547,58.952,266.059z"/>
            </g>
        </g>
        <g>
            <g>
                <path d="M199.465,156.375c-21.058-11.058-45.158-13.256-67.862-6.19c-22.705,7.068-41.296,22.557-52.348,43.612    c-11.059,21.052-13.258,45.149-6.191,67.853c7.067,22.705,22.556,41.299,43.614,52.358c13.172,6.915,27.3,10.192,41.237,10.192    c32.048,0,63.065-17.333,78.972-47.614l0.001-0.001C259.705,233.115,242.916,179.19,199.465,156.375z M221.192,268.341    c-18.281,34.798-61.468,48.244-96.271,29.971c-16.865-8.856-29.269-23.748-34.928-41.931c-5.66-18.181-3.899-37.48,4.959-54.342    c8.851-16.864,23.739-29.267,41.922-34.927c6.993-2.177,14.15-3.255,21.272-3.255c11.395,0,22.699,2.763,33.077,8.214    C226.02,190.341,239.465,233.529,221.192,268.341z"/>
            </g>
        </g>
        <g>
            <g>
                <path d="M158.104,202.391c-18.085,0-32.797,14.713-32.797,32.797s14.713,32.797,32.797,32.797s32.797-14.713,32.797-32.797    S176.188,202.391,158.104,202.391z"/>
            </g>
        </g>
        <g>
            <g>
                <path d="M416.445,198.802h-93.203c-4.897,0-8.864,3.969-8.864,8.864s3.968,8.864,8.864,8.864h19.651    c-3.681,5.301-5.846,11.729-5.846,18.658c0,5.431,1.334,10.553,3.682,15.068h-2.09c-4.897,0-8.864,3.969-8.864,8.864    s3.968,8.864,8.864,8.864h62.41c4.897,0,8.864-3.969,8.864-8.864s-3.968-8.864-8.864-8.864h-2.088    c2.346-4.515,3.682-9.637,3.682-15.068c0-6.928-2.165-13.357-5.846-18.658h19.651c4.897,0,8.864-3.969,8.864-8.864    S421.342,198.802,416.445,198.802z"/>
            </g>
        </g>
        <g>
            <g>
                <path d="M333.113,367.215H194.834c-4.896,0-8.864,3.969-8.864,8.864c0,4.896,3.969,8.864,8.864,8.864h138.277    c4.897,0,8.864-3.969,8.864-8.864C341.976,371.184,338.008,367.215,333.113,367.215z"/>
            </g>
        </g>
        <g>
            <g>
                <path d="M297.768,395.58H230.18c-4.896,0-8.864,3.969-8.864,8.864s3.969,8.864,8.864,8.864h67.588    c4.897,0,8.864-3.969,8.864-8.864S302.664,395.58,297.768,395.58z"/>
            </g>
        </g>
        <g>
            <g>
                <g>
                    <circle cx="170.988" cy="231.881" r="8.864"/>
                    <circle cx="382.551" cy="231.881" r="8.864"/>
                </g>
            </g>
        </g>
    </svg>
)

///////////////////////
// WEATHER ICONS    //
//////////////////////

export const WeatherIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 30}
        height={props.height || 30}
        viewBox="40 40 462.000000 462.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            fill={props.color || 'none'}
            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="0.6"
                d="M1790 3880 l0 -190 150 0 150 0 0 190 0 190 -150 0 -150 0 0 -190z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="0.6"
                d="M940 3655 l-105 -105 140 -140 140 -140 105 105 105 105 -140 140
        -140 140 -105 -105z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="0.6"
                d="M2647 3622 l-137 -137 108 -108 107 -107 140 140 140 140 -105 105
        c-58 58 -107 105 -110 105 -3 0 -67 -62 -143 -138z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="0.6"
                d="M1800 3574 c-229 -45 -421 -161 -555 -334 -121 -157 -177 -326 -176
        -534 0 -234 83 -435 246 -602 l80 -82 -23 -58 c-52 -128 -65 -299 -36 -442 58
        -281 254 -497 539 -593 l70 -24 1144 -3 c1256 -3 1197 -5 1326 58 277 135 380
        504 214 765 -60 95 -176 187 -280 224 l-26 10 -6 148 c-5 164 -29 279 -86 413
        -127 297 -382 535 -686 640 -236 82 -538 80 -772 -5 -37 -13 -68 -23 -69 -22
        -146 226 -319 361 -539 422 -59 16 -311 29 -365 19z m280 -309 c102 -27 180
        -73 260 -154 41 -42 81 -88 89 -103 14 -27 13 -29 -80 -125 -122 -125 -209
        -255 -254 -375 -17 -47 -19 -48 -59 -48 -109 0 -296 -70 -404 -151 -60 -46
        -69 -44 -125 24 -96 117 -138 232 -139 377 -1 261 172 487 425 555 69 18 218
        18 287 0z m1245 -356 c218 -38 430 -179 557 -371 129 -195 166 -417 114 -694
        -14 -78 -26 -147 -26 -153 0 -7 39 -11 123 -11 107 0 128 -3 172 -24 100 -46
        153 -137 142 -242 -6 -63 -26 -102 -73 -148 -73 -71 4 -67 -1234 -64 l-1115 3
        -56 23 c-126 51 -233 158 -279 279 -31 80 -38 208 -16 293 45 175 205 321 387
        352 45 8 99 9 171 2 l106 -9 32 110 c71 247 186 408 383 536 183 118 382 157
        612 118z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="0.6"
                d="M560 2700 l0 -150 190 0 190 0 0 150 0 150 -190 0 -190 0 0 -150z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="0.6"
                d="M972 1997 c-72 -73 -132 -137 -132 -142 0 -6 46 -56 103 -113 l102
        -102 140 140 140 140 -105 105 c-58 58 -107 105 -110 105 -3 0 -65 -60 -138
        -133z"
            />
        </g>
    </svg>
);

export const SunIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 495 495"
        style={{ enableBackground: 'new 0 0 495 495' }}>
        <g>
            <path
                style={{ fill: '#FFCD00' }}
                d="M495,267.5v-40h-74.324c-3.799-33.108-16.904-63.424-36.634-88.257l52.61-52.61l-28.285-28.284
            l-52.609,52.609c-24.834-19.731-55.15-32.835-88.257-36.634V0h-40v74.324c6.565-0.753,13.236-1.154,20-1.154v348.66
            c-6.764,0-13.435-0.401-20-1.154V495h40v-74.324c33.107-3.799,63.423-16.904,88.257-36.634l52.609,52.609l28.285-28.284
            l-52.61-52.61c19.731-24.833,32.835-55.149,36.634-88.257H495z"
            />
            <path
                style={{ fill: '#FFDA44' }}
                d="M247.5,73.17c-6.764,0-13.435,0.401-20,1.154c-33.107,3.799-63.423,16.904-88.257,36.634
            L86.634,58.349L58.349,86.633l52.61,52.61c-19.731,24.833-32.835,55.149-36.634,88.257H0v40h74.324
            c3.799,33.108,16.904,63.424,36.634,88.257l-52.61,52.61l28.285,28.284l52.609-52.609c24.834,19.731,55.15,32.835,88.257,36.634
            c6.565,0.753,13.236,1.154,20,1.154V73.17z"
            />
        </g>
    </svg>
);

export const MoonIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 495 495"
        style={{ enableBackground: 'new 0 0 495 495' }}>
        <path style={{ fill: '#FFDE55' }} d="M247.5,0v495C383.972,495,495,383.972,495,247.5S383.972,0,247.5,0z" />
        <path style={{ fill: '#FFEB99' }} d="M0,247.5C0,383.972,111.028,495,247.5,495V0C111.028,0,0,111.028,0,247.5z" />
    </svg>
);

export const SunCloudsIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 484.834 484.834"
        style={{ enableBackground: 'new 0 0 484.834 484.834' }}>
        <g>
            <path
                style={{ fill: '#BDDBFF' }}
                d="M238.063,88.063c-12.659,0-24.991,1.55-36.81,4.467c-55.463,13.693-99.559,57.644-112.534,114.336
            C38.476,215.042,0,258.742,0,311.258c0,58.318,47.445,105.763,105.763,105.763h132.3V88.063z"
            />
            <path
                style={{ fill: '#9BC9FF' }}
                d="M387.407,206.867c-15.739-68.772-77.271-118.804-149.343-118.804v328.958h132.3
            c58.318,0,105.763-47.445,105.763-105.763c0-20.127-5.657-38.956-15.457-54.99C444.9,230.467,418.394,211.909,387.407,206.867z"
            />
            <path
                style={{ fill: '#FFCD00' }}
                d="M456.492,170.685c-2.5-11.828-7.17-22.864-13.573-32.672l20.069-20.069l-28.285-28.284
            l-20.069,20.069c-9.808-6.403-20.843-11.073-32.672-13.573V67.813h-40v28.368c-10.252,2.174-20.11,6.001-29.145,11.328
            c36.456,20.387,63.9,55.294,74.122,97.413l2.172,2.242c22.251,3.998,42.107,14.976,57.214,30.581
            c4.713-8.46,8.135-17.58,10.14-27.061h28.368v-40H456.492z"
            />
        </g>
    </svg>
);

export const MoonCloudsIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 476.127 476.127"
        style={{ enableBackground: 'new 0 0 476.127 476.127' }}>
        <g>
            <path
                style={{ fill: '#FFDE55' }}
                d="M362.958,149.034c11.435,16.047,19.877,34.437,24.449,54.414
            c20.953,3.409,39.856,13.001,54.779,26.829c11.56-9.694,20.77-22.11,26.69-36.402c20.046-48.396-3.019-104.078-51.414-124.123
            c-15.406-6.382-32.273-8.596-48.779-6.406l-34.26,4.546l21.012,27.44C367.174,110.663,370.02,131.159,362.958,149.034z"
            />
            <path
                style={{ fill: '#2488FF' }}
                d="M238.063,84.644c-12.659,0-24.991,1.55-36.81,4.467c-55.463,13.693-99.559,57.644-112.534,114.336
            C38.476,211.623,0,255.322,0,307.838c0,58.318,47.445,105.763,105.763,105.763h132.3V84.644z"
            />
            <path
                style={{ fill: '#006DF0' }}
                d="M387.407,203.448c-15.739-68.772-77.271-118.804-149.343-118.804v328.958h132.3
            c58.318,0,105.763-47.445,105.763-105.763c0-20.127-5.657-38.956-15.457-54.99C444.9,227.047,418.394,208.49,387.407,203.448z"
            />
        </g>
    </svg>
);

export const CloudIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 476.127 476.127"
        style={{ enableBackground: 'new 0 0 476.127 476.127' }}>
        <g>
            <path
                style={{ fill: '#BDDBFF' }}
                d="M201.254,78.052c-55.463,13.693-99.559,57.644-112.534,114.336C38.476,200.564,0,244.263,0,296.779
            c0,58.318,47.445,105.763,105.763,105.763h132.3V73.585C225.404,73.585,213.072,75.134,201.254,78.052z"
            />
            <path
                style={{ fill: '#9BC9FF' }}
                d="M460.67,241.789c-15.77-25.801-42.276-44.359-73.263-49.401
            c-15.739-68.772-77.271-118.804-149.343-118.804v328.958h132.3c58.318,0,105.763-47.445,105.763-105.763
            C476.127,276.652,470.47,257.823,460.67,241.789z"
            />
        </g>
    </svg>
);

export const CloudsIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 495 495"
        style={{ enableBackground: 'new 0 0 495 495' }}>
        <g>
            <path
                style={{ fill: '#57A4FF' }}
                d="M478.287,269.323C489.221,254.714,495,237.327,495,219.04c0-40.53-28.86-74.446-67.111-82.278
            c-13.431-51.897-60.56-89.308-115.567-89.308c-49.282,0-93.286,30.531-111.068,75.603c11.818-2.918,24.15-4.467,36.81-4.467
            c72.072,0,133.604,50.031,149.343,118.804c30.987,5.042,57.493,23.599,73.263,49.401
            C467.304,281.923,473.238,276.07,478.287,269.323z"
            />
            <path
                style={{ fill: '#BDDBFF' }}
                d="M238.063,118.589c-12.659,0-24.991,1.55-36.81,4.467C145.791,136.749,101.695,180.7,88.72,237.393
            C38.476,245.568,0,289.267,0,341.783c0,58.318,47.445,105.763,105.763,105.763h132.3V118.589z"
            />
            <path
                style={{ fill: '#9BC9FF' }}
                d="M387.407,237.393c-15.739-68.772-77.271-118.804-149.343-118.804v328.958h132.3
            c58.318,0,105.763-47.445,105.763-105.763c0-20.127-5.657-38.956-15.457-54.99C444.9,260.992,418.394,242.435,387.407,237.393z"
            />
        </g>
    </svg>
);

export const RainIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 476.127 476.127"
        style={{ enableBackground: 'new 0 0 476.127 476.127' }}>
        <g>
            <rect x="85.763" y="408.668" style={{ fill: '#D1E7F8' }} width="40" height="64.77" />
            <path
                style={{ fill: '#D1E7F8' }}
                d="M105.763,331.646c-6.837,0-13.521-0.66-20-1.905v42.004h40v-40.099H105.763z"
            />
            <rect x="173.963" y="331.646" style={{ fill: '#D1E7F8' }} width="40" height="141.792" />
            <rect x="262.164" y="428.668" style={{ fill: '#BDDBFF' }} width="40" height="44.77" />
            <rect x="262.164" y="331.646" style={{ fill: '#BDDBFF' }} width="40" height="60.099" />
            <path
                style={{ fill: '#BDDBFF' }}
                d="M238.063,2.689c-12.659,0-24.991,1.55-36.81,4.467C145.791,20.849,101.695,64.8,88.72,121.493
            C38.476,129.668,0,173.367,0,225.883c0,58.318,47.445,105.763,105.763,105.763h132.3V2.689z"
            />
            <path
                style={{ fill: '#BDDBFF' }}
                d="M370.364,331.646h-20v141.792h40V329.741C383.885,330.987,377.2,331.646,370.364,331.646z"
            />
            <path
                style={{ fill: '#9BC9FF' }}
                d="M387.407,121.493C371.667,52.72,310.135,2.689,238.063,2.689v328.958h132.3
            c58.318,0,105.763-47.445,105.763-105.763c0-20.127-5.657-38.956-15.457-54.99C444.9,145.092,418.394,126.535,387.407,121.493z"
            />
        </g>
    </svg>
);

export const RainSunIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 490.999 490.999"
        style={{ enableBackground: 'new 0 0 490.999 490.999' }}>
        <g>
            <rect x="88.845" y="426.23" style={{ fill: '#D1E7F8' }} width="40" height="64.77" />
            <path
                style={{ fill: '#D1E7F8' }}
                d="M108.846,349.208c-6.837,0-13.521-0.66-20-1.905v42.004h40v-40.099H108.846z"
            />
            <rect x="177.046" y="349.208" style={{ fill: '#D1E7F8' }} width="40" height="141.791" />
            <rect x="265.247" y="446.23" style={{ fill: '#BDDBFF' }} width="40" height="44.77" />
            <rect x="265.247" y="349.208" style={{ fill: '#BDDBFF' }} width="40" height="60.099" />
            <path
                style={{ fill: '#BDDBFF' }}
                d="M373.446,349.208h-20v141.791h40V347.303C386.968,348.548,380.283,349.208,373.446,349.208z"
            />
            <path
                style={{ fill: '#BDDBFF' }}
                d="M241.146,20.25c-12.659,0-24.991,1.55-36.81,4.467c-55.463,13.693-99.559,57.644-112.534,114.336
            c-50.244,8.175-88.72,51.875-88.72,104.391c0,58.318,47.445,105.763,105.763,105.763h132.3V20.25z"
            />
            <path
                style={{ fill: '#9BC9FF' }}
                d="M390.489,139.054C374.75,70.282,313.218,20.25,241.146,20.25v328.958h132.3
            c58.318,0,105.763-47.445,105.763-105.763c0-20.127-5.657-38.956-15.457-54.99C447.983,162.654,421.477,144.096,390.489,139.054z"
            />
            <path
                style={{ fill: '#FFCD00' }}
                d="M459.575,102.872c-2.5-11.828-7.17-22.864-13.573-32.672l20.069-20.069l-28.285-28.284
            l-20.069,20.069c-9.808-6.403-20.843-11.073-32.672-13.573V0h-40v28.368c-10.252,2.174-20.11,6.001-29.145,11.328
            c36.456,20.387,63.9,55.294,74.122,97.413l2.172,2.242c22.251,3.998,42.107,14.976,57.214,30.581
            c4.713-8.46,8.135-17.58,10.14-27.061h28.368v-40H459.575z"
            />
        </g>
    </svg>
);

export const RainMoonIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 492.868 492.868"
        style={{ enableBackground: 'new 0 0 492.868 492.868' }}>
        <rect x="270.518" y="448.099" style={{ fill: '#2488FF' }} width="40" height="44.769" />
        <g>
            <path
                style={{ fill: '#FFDE55' }}
                d="M371.329,86.509c11.435,16.047,19.877,34.437,24.449,54.414
            c20.953,3.409,39.856,13.001,54.779,26.829c11.56-9.694,20.77-22.11,26.69-36.402c20.046-48.396-3.019-104.078-51.414-124.123
            c-15.406-6.382-32.273-8.596-48.779-6.406l-34.26,4.546l21.012,27.44C375.545,48.138,378.39,68.634,371.329,86.509z"
            />
            <path
                style={{ fill: '#2488FF' }}
                d="M246.434,22.119c-12.659,0-24.991,1.55-36.81,4.467C154.161,40.279,110.065,84.23,97.091,140.922
            c-50.244,8.175-88.72,51.875-88.72,104.391c0,58.318,47.445,105.763,105.763,105.763h132.3V22.119z"
            />
            <path
                style={{ fill: '#006DF0' }}
                d="M395.777,140.922C380.038,72.15,318.506,22.119,246.434,22.119v328.958h132.3
            c58.318,0,105.763-47.445,105.763-105.763c0-20.127-5.657-38.956-15.457-54.99C453.271,164.522,426.764,145.964,395.777,140.922z"
            />
            <rect x="94.118" y="428.099" style={{ fill: '#57A4FF' }} width="40" height="64.769" />
            <path
                style={{ fill: '#57A4FF' }}
                d="M114.134,351.076c-6.842,0-13.532-0.661-20.016-1.908v42.008h40v-40.1H114.134z"
            />
            <rect x="182.318" y="351.076" style={{ fill: '#57A4FF' }} width="40" height="141.792" />
            <rect x="270.518" y="351.076" style={{ fill: '#2488FF' }} width="40" height="60.1" />
            <path
                style={{ fill: '#2488FF' }}
                d="M378.734,351.076h-20.016v141.792h40V349.174C392.244,350.417,385.565,351.076,378.734,351.076z"
            />
        </g>
    </svg>
);

export const ThunderstormIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 476.127 476.127"
        style={{ enableBackground: 'new 0 0 476.127 476.127' }}>
        <g>
            <path
                style={{ fill: '#ACABB1' }}
                d="M238.063,2.689c-12.659,0-24.991,1.55-36.81,4.467C145.791,20.849,101.695,64.8,88.72,121.493
            C38.476,129.668,0,173.367,0,225.883c0,58.318,47.445,105.763,105.763,105.763h132.3V2.689z"
            />
            <path
                style={{ fill: '#898890' }}
                d="M387.407,121.493C371.667,52.72,310.135,2.689,238.063,2.689v328.958h132.3
            c58.318,0,105.763-47.445,105.763-105.763c0-20.127-5.657-38.956-15.457-54.99C444.9,145.092,418.394,126.535,387.407,121.493z"
            />
            <polygon
                style={{ fill: '#FFDA44' }}
                points="155.455,473.438 115.455,473.438 115.455,368.646 155.13,368.646 155.13,331.646 
            195.13,331.646 195.13,408.646 155.455,408.646 	"
            />
            <polygon
                style={{ fill: '#FFCD00' }}
                points="273.024,473.438 233.024,473.438 233.025,368.646 272.7,368.646 272.701,331.646 
            312.701,331.646 312.7,408.646 273.025,408.646 	"
            />
        </g>
    </svg>
);

export const SnowIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 495 495"
        style={{ enableBackground: 'new 0 0 495 495' }}>
        <g>
            <polygon
                style={{ fill: '#D1E7F8' }}
                points="227.5,0 227.5,50.11 202.642,25.252 174.358,53.536 227.5,106.678 227.5,212.859 
            135.545,159.769 116.093,87.175 77.457,97.528 86.555,131.484 43.159,106.429 23.159,141.071 66.555,166.125 32.599,175.224 
            42.951,213.861 115.545,194.41 207.5,247.5 115.545,300.59 42.951,281.139 32.599,319.776 66.555,328.875 23.159,353.929 
            43.159,388.571 86.555,363.516 77.457,397.472 116.093,407.825 135.545,335.231 227.5,282.141 227.5,388.322 174.358,441.464 
            202.642,469.748 227.5,444.89 227.5,495 247.5,495 247.5,0 	"
            />
            <polygon
                style={{ fill: '#BDDBFF' }}
                points="462.401,319.776 452.049,281.139 379.455,300.59 287.5,247.5 379.455,194.41 
            452.049,213.861 462.401,175.224 428.445,166.125 471.841,141.071 451.841,106.429 408.445,131.484 417.543,97.528 378.907,87.175 
            359.455,159.769 267.5,212.859 267.5,106.678 320.642,53.536 292.358,25.252 267.5,50.11 267.5,0 247.5,0 247.5,495 267.5,495 
            267.5,444.89 292.358,469.748 320.642,441.464 267.5,388.322 267.5,282.141 359.455,335.231 378.907,407.825 417.543,397.472 
            408.445,363.516 451.841,388.571 471.841,353.929 428.445,328.875 	"
            />
        </g>
    </svg>
);

export const MistIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        viewBox="0 0 512 531"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Group-4">
                <path
                    d="M54,376 L457,376 L457,413 L54,413 L54,376 Z M237.428251,376 L273.571749,376 L273.571749,413 L237.428251,413 L237.428251,376 Z"
                    id="Combined-Shape"
                    style={{ fill: '#D2E9F9' }}></path>
                <path
                    d="M54,494 L457,494 L457,531 L54,531 L54,494 Z M237.428251,494 L273.571749,494 L273.571749,531 L237.428251,531 L237.428251,494 Z"
                    id="Combined-Shape-Copy-5"
                    style={{ fill: '#D2E9F9' }}></path>
                <path
                    d="M54,435 L457,435 L457,472 L54,472 L54,435 Z M163.334081,435 L200.381166,435 L200.381166,472 L163.334081,472 L163.334081,435 Z M310.618834,435 L347.665919,435 L347.665919,472 L310.618834,472 L310.618834,435 Z"
                    id="Combined-Shape"
                    style={{ fill: '#BDDBFF' }}></path>
                <g id="Group-13">
                    <path
                        d="M256,0.000743750827 C256.166609,0.000248033231 256.333275,0 256.5,0 C334.302791,0 399.490114,54.013241 416.609768,126.587522 C470.749796,135.683614 512,182.774556 512,239.5 C512,302.235847 461.545277,353.187361 399,353.990376 L399,354 L256,354 L256,0.000718002513 Z"
                        id="Combined-Shape"
                        style={{ fill: '#9BC9FF' }}></path>
                    <path
                        d="M1.29674049e-13,0.000743750827 C0.166608507,0.000248033231 0.333275295,0 0.500000014,0 C78.3027911,0 143.490114,54.013241 160.609768,126.587522 C214.749796,135.683614 256,182.774556 256,239.5 C256,302.235847 205.545277,353.187361 143,353.990376 L143,354 L1.38994061e-08,354 L1.38994096e-08,0.000718002513 Z"
                        id="Combined-Shape"
                        style={{ fill: '#BDDBFF' }}
                        transform="translate(128.000000, 177.000000) scale(-1, 1) translate(-128.000000, -177.000000) "></path>
                </g>
            </g>
        </g>
    </svg>
);

export const LightBulb = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 20}
        height={props.height || 20}
        viewBox="0 0 306.29 435.36">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Capa_1" data-name="Capa 1">
                <path
                    style={{
                        fill: 'none',
                        stroke: props.color || '#808080',
                        strokeMiterlimit: 10,
                        strokeWidth: props.strokeWidth || 25
                    }}
                    d="M264.37,257c-56,56-50,126-50,126H91.91s6-70-50-126-30.62-147.28-19-167C32,74.53,60.35,9,153.11,7h.06c92.76,2,121.11,67.53,130.2,83C295,109.67,320.37,201,264.37,257Z"
                />
                <line
                    style={{
                        fill: 'none',
                        stroke: props.color || '#808080',
                        strokeMiterlimit: 10,
                        strokeWidth: props.strokeWidth || 25,
                        strokeLinecap: 'round'
                    }}
                    x1="116.12"
                    y1="428.36"
                    x2="190.17"
                    y2="428.36"
                />
            </g>
        </g>
    </svg>
);

export const AuctionIcon = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 115.13 109.56">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1" fill={props.fill || '#000000'}>
                <path
                    id="Combined-Shape"
                    fillRule="evenodd"
                    d="M59.16,94.19a4.49,4.49,0,0,1,4.48,4.49v10.88H0V98.68a4.49,4.49,0,0,1,4.48-4.49Zm-1.94,3.2H6.42a3.21,3.21,0,0,0-3.21,3.21h0v5.76H60.43V100.6a3.21,3.21,0,0,0-3.21-3.21Z"
                />
                <path
                    id="Combined-Shape-Copy-6"
                    d="M52.73,84a4.49,4.49,0,0,1,4.48,4.48v9H6.43v-9A4.48,4.48,0,0,1,10.91,84Zm-1.29,2.8H12.19A3.2,3.2,0,0,0,9,90H9v4.64H54.65V90a3.21,3.21,0,0,0-3.21-3.2Z"
                />
                <path
                    id="Combined-Shape-2"
                    data-name="Combined-Shape"
                    d="M111.88,71a7.36,7.36,0,1,1-8.23,12.21L56.46,51.34l8.23-12.21Zm-1.8,2.65-44.51-30-4.66,6.9,44.52,30a4.16,4.16,0,0,0,4.65-6.9Z"
                />
                <path
                    id="Combined-Shape-3"
                    data-name="Combined-Shape"
                    d="M81.23,19.46A6.39,6.39,0,0,1,83,28.34l-.35.53a6.4,6.4,0,0,1-8.89,1.73L46.49,12.24a6.4,6.4,0,0,1-1.73-8.89l.36-.53A6.39,6.39,0,0,1,54,1.1Zm-2.07,2.46-26.67-18a3.52,3.52,0,1,0-3.94,5.83h0l26.67,18a3.52,3.52,0,1,0,3.94-5.84Z"
                />
                <path
                    id="Combined-Shape-Copy-7"
                    d="M51,64a6.4,6.4,0,0,1,1.73,8.89l-.36.53a6.4,6.4,0,0,1-8.89,1.73L16.29,56.83a6.41,6.41,0,0,1-1.73-8.89l.36-.53a6.4,6.4,0,0,1,8.89-1.73ZM49,66.51l-26.67-18a3.52,3.52,0,0,0-3.94,5.84h0L45,72.35A3.52,3.52,0,0,0,49,66.51Z"
                />
                <path
                    id="Combined-Shape-4"
                    data-name="Combined-Shape"
                    d="M76,28.29,49.81,67,22.63,48.71,48.77,10Zm-4.46.86L49.64,14.41,27.09,47.85,48.94,62.59Z"
                />
            </g>
        </g>
    </svg>
);

export const CreateNoteIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="20 20 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <g id="note_added" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                opacity="0"
                x="0"
                y="0"
                width="150"
                height="150"></rect>
            <g transform="translate(35.000000, 36.000000)" fill="#000000">
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    d="M61.5000133,0.000499612351 C62.3284405,0.000499612351 63.0000133,0.672072488 63.0000133,1.50049961 L63.000881,46.5193036 C62.752225,46.5066215 62.5018826,46.5002018 62.2500139,46.5002018 C61.309397,46.5002018 60.3900658,46.5897377 59.5003688,46.7606079 L59.5000161,4.00047719 C59.5000161,3.72433482 59.2761585,3.50047719 59.0000161,3.50047719 L18.3959341,3.50035131 L3.49993412,18.5293513 L3.50005889,72.0000352 C3.50005889,72.2454951 3.67693405,72.4496436 3.91018326,72.4919796 L4.00005889,72.5000352 L54.9070767,72.5006701 C57.0515523,73.7699102 59.5639967,74.5000224 62.2500139,74.5000224 C62.5018826,74.5000224 62.752225,74.4936026 63.000881,74.4809205 L63.0000133,74.5000128 C63.0000133,75.3284399 62.3284405,76.0000128 61.5000133,76.0000128 L1.50006275,76.0000128 C0.671635624,76.0000128 6.27484277e-05,75.3284399 6.27484277e-05,74.5000128 L0,17.1172233 L17.117,0.000223303271 L61.5000133,0.000499612351 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    d="M20.0000471,0.000499612351 L20.0000471,20.0003715 L6.27484277e-05,20.0003715 L4.36482299e-05,16.832 L16.8320436,0 L20.0000471,0.000499612351 Z M17.000058,5.00046759 L16.4498834,5.00029299 L6.17163092,15.2786422 L5.99988345,15.107293 L6.00005804,16.5003939 L17.000058,16.5003939 L17.000058,5.00046759 Z"
                    id="Combined-Shape"></path>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle"
                    x="13.5000522"
                    y="27.0003267"
                    width="35.9999718"
                    height="3.49997758"
                    rx="1.74998879"></rect>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle-Copy-2"
                    x="13.5000522"
                    y="37.5002594"
                    width="35.9999718"
                    height="3.49997758"
                    rx="1.74998879"></rect>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle-Copy-3"
                    x="13.5000522"
                    y="47.5001954"
                    width="23.9999812"
                    height="3.49997758"
                    rx="1.74998879"></rect>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle-Copy-4"
                    x="13.5000522"
                    y="57.5001313"
                    width="23.9999812"
                    height="3.49997758"
                    rx="1.74998879"></rect>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    d="M62.2500139,43.0002242 C72.0530605,43.0002242 80,50.8351909 80,60.5001121 C80,70.1650333 72.0530605,78 62.2500139,78 C52.4469673,78 44.5000278,70.1650333 44.5000278,60.5001121 C44.5000278,50.8351909 52.4469673,43.0002242 62.2500139,43.0002242 Z M62.2500139,46.4509063 C54.3799624,46.4509063 48.0000251,52.74095 48.0000251,60.5001121 C48.0000251,68.2592742 54.3799624,74.5493179 62.2500139,74.5493179 C70.1200654,74.5493179 76.5000027,68.2592742 76.5000027,60.5001121 C76.5000027,52.74095 70.1200654,46.4509063 62.2500139,46.4509063 Z"
                    id="Combined-Shape"></path>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle"
                    x="60.5000153"
                    y="52.5001633"
                    width="3.49999725"
                    height="15.9998975"
                    rx="1.74999863"></rect>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    d="M62.2500627,52.5001121 C63.2165549,52.5001121 64.0000515,53.2836088 64.0000515,54.2501009 L64.0000515,66.7501233 C64.0000515,67.7166154 63.2165549,68.5001121 62.2500627,68.5001121 C61.2835706,68.5001121 60.500074,67.7166154 60.500074,66.7501233 L60.500074,54.2501009 C60.500074,53.2836088 61.2835706,52.5001121 62.2500627,52.5001121 Z"
                    id="Rectangle"
                    transform="translate(62.250063, 60.500112) rotate(90.000000) translate(-62.250063, -60.500112) "></path>
            </g>
        </g>
    </svg>
);

export const RemoveNoteIcon = (props) => (
    <svg
        width={props.width || 25}
        height={props.height || 25}
        viewBox="20 20 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <g id="note_removed" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || '#D3D3D3'}
                opacity="0"
                x="0"
                y="0"
                width="150"
                height="150"></rect>
            <g transform="translate(35.000000, 36.000000)" fill="#000000">
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    d="M61.5000133,0.000499612351 C62.3284405,0.000499612351 63.0000133,0.672072488 63.0000133,1.50049961 L63.000881,46.5193036 C62.752225,46.5066215 62.5018826,46.5002018 62.2500139,46.5002018 C61.309397,46.5002018 60.3900658,46.5897377 59.5003688,46.7606079 L59.5000161,4.00047719 C59.5000161,3.72433482 59.2761585,3.50047719 59.0000161,3.50047719 L18.3959341,3.50035131 L3.49993412,18.5293513 L3.50005889,72.0000352 C3.50005889,72.2454951 3.67693405,72.4496436 3.91018326,72.4919796 L4.00005889,72.5000352 L54.9070767,72.5006701 C57.0515523,73.7699102 59.5639967,74.5000224 62.2500139,74.5000224 C62.5018826,74.5000224 62.752225,74.4936026 63.000881,74.4809205 L63.0000133,74.5000128 C63.0000133,75.3284399 62.3284405,76.0000128 61.5000133,76.0000128 L1.50006275,76.0000128 C0.671635624,76.0000128 6.27484277e-05,75.3284399 6.27484277e-05,74.5000128 L0,17.1172233 L17.117,0.000223303271 L61.5000133,0.000499612351 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    d="M20.0000471,0.000499612351 L20.0000471,20.0003715 L6.27484277e-05,20.0003715 L4.36482299e-05,16.832 L16.8320436,0 L20.0000471,0.000499612351 Z M17.000058,5.00046759 L16.4498834,5.00029299 L6.17163092,15.2786422 L5.99988345,15.107293 L6.00005804,16.5003939 L17.000058,16.5003939 L17.000058,5.00046759 Z"
                    id="Combined-Shape"></path>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle"
                    x="13.5000522"
                    y="27.0003267"
                    width="35.9999718"
                    height="3.49997758"
                    rx="1.74998879"></rect>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle-Copy-2"
                    x="13.5000522"
                    y="37.5002594"
                    width="35.9999718"
                    height="3.49997758"
                    rx="1.74998879"></rect>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle-Copy-3"
                    x="13.5000522"
                    y="47.5001954"
                    width="23.9999812"
                    height="3.49997758"
                    rx="1.74998879"></rect>
                <rect
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    id="Rectangle-Copy-4"
                    x="13.5000522"
                    y="57.5001313"
                    width="23.9999812"
                    height="3.49997758"
                    rx="1.74998879"></rect>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    d="M62.2500139,43.0002242 C72.0530605,43.0002242 80,50.8351909 80,60.5001121 C80,70.1650333 72.0530605,78 62.2500139,78 C52.4469673,78 44.5000278,70.1650333 44.5000278,60.5001121 C44.5000278,50.8351909 52.4469673,43.0002242 62.2500139,43.0002242 Z M62.2500139,46.4509063 C54.3799624,46.4509063 48.0000251,52.74095 48.0000251,60.5001121 C48.0000251,68.2592742 54.3799624,74.5493179 62.2500139,74.5493179 C70.1200654,74.5493179 76.5000027,68.2592742 76.5000027,60.5001121 C76.5000027,52.74095 70.1200654,46.4509063 62.2500139,46.4509063 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="2.5"
                    fill={props.fill || '#D3D3D3'}
                    d="M62.2500627,53.0001089 C63.2165549,53.0001089 64.0000515,53.7836056 64.0000515,54.7500977 L64.0000515,67.2501201 C64.0000515,68.2166122 63.2165549,69.0001089 62.2500627,69.0001089 C61.2835706,69.0001089 60.500074,68.2166122 60.500074,67.2501201 L60.500074,54.7500977 C60.500074,53.7836056 61.2835706,53.0001089 62.2500627,53.0001089 Z"
                    id="Rectangle"
                    transform="translate(62.250063, 61.000109) rotate(90.000000) translate(-62.250063, -61.000109) "></path>
            </g>
        </g>
    </svg>
);

export const WifiIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 25}
        height={props.height || 25}
        viewBox="0 0 512.000000 404.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            transform="translate(0.000000,404.000000) scale(0.100000,-0.100000)"
            stroke={props.color || 'none'}
            strokeWidth="2.5"
            fill={props.fill || '#D3D3D3'}>
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M2290 4029 c-738 -62 -1372 -308 -1955 -759 -44 -34 -138 -113 -208
        -177 l-129 -116 180 -180 180 -180 120 107 c247 220 481 377 769 512 753 356
        1626 389 2413 92 139 -52 401 -181 525 -259 141 -88 341 -239 469 -354 l108
        -98 180 180 180 180 -129 116 c-534 482 -1137 776 -1838 896 -258 45 -617 61
        -865 40z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M2355 3014 c-579 -48 -1145 -300 -1573 -700 l-63 -59 180 -179 180
        -180 73 65 c329 293 707 471 1123 531 116 16 454 16 570 0 416 -60 794 -238
        1123 -531 l73 -65 180 180 180 179 -63 59 c-394 368 -866 595 -1422 682 -89
        14 -462 26 -561 18z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M2350 1985 c-325 -45 -608 -178 -863 -407 l-48 -43 180 -179 179
        -179 89 71 c111 91 274 174 408 209 89 24 118 27 265 27 147 0 176 -3 265 -27
        134 -35 297 -118 408 -209 l89 -71 179 179 180 179 -48 43 c-363 326 -820 470
        -1283 407z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M2462 804 c-184 -49 -305 -205 -305 -394 0 -362 435 -542 694 -287
        130 127 156 320 66 493 -24 47 -112 128 -169 157 -92 46 -191 57 -286 31z"
            />
        </g>
    </svg>
);

export const CustomerFeedbackIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 35}
        height={props.height || 35}
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M400 4467 c-49 -16 -133 -102 -148 -153 -17 -60 -17 -3448 0 -3508
        16 -55 99 -138 154 -154 32 -9 525 -12 2156 -12 2385 0 2172 -8 2251 80 24 26
        49 66 55 88 17 57 17 3447 0 3504 -6 22 -31 62 -55 88 -79 88 135 80 -2257 79
        -1516 -1 -2131 -4 -2156 -12z m4295 -172 l25 -24 0 -296 0 -295 -2160 0 -2160
        0 0 295 0 296 25 24 24 25 2111 0 2111 0 24 -25z m25 -2110 l0 -1336 -25 -24
        -24 -25 -2111 0 -2111 0 -24 25 -25 24 0 1336 0 1335 2160 0 2160 0 0 -1335z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M735 4146 c-101 -44 -125 -178 -46 -257 112 -113 296 -12 267 146
        -18 94 -131 151 -221 111z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M1215 4146 c-101 -44 -125 -178 -46 -257 112 -113 296 -12 267 146
        -18 94 -131 151 -221 111z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M1695 4146 c-101 -44 -125 -178 -46 -257 112 -113 296 -12 267 146
        -18 94 -131 151 -221 111z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M720 3187 c-49 -16 -133 -102 -148 -153 -17 -59 -17 -1049 0 -1108
        16 -55 99 -138 154 -154 32 -9 456 -12 1836 -12 2026 0 1853 -7 1931 80 24 26
        49 66 55 88 17 56 17 1048 0 1104 -6 22 -31 62 -55 88 -78 87 96 80 -1937 79
        -1283 -1 -1811 -4 -1836 -12z m3655 -172 l25 -24 0 -511 0 -511 -25 -24 -24
        -25 -1791 0 -1791 0 -24 25 -25 24 0 511 0 511 25 24 24 25 1791 0 1791 0 24
        -25z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M1336 2907 c-10 -8 -44 -63 -75 -123 l-56 -109 -120 -17 c-106 -15
        -122 -20 -142 -43 -41 -47 -32 -69 69 -171 l91 -94 -18 -107 c-24 -132 -23
        -148 6 -179 34 -36 66 -30 183 32 l106 56 105 -56 c115 -62 150 -68 183 -33
        27 28 27 56 5 188 l-16 100 91 93 c101 102 110 124 69 171 -20 23 -36 28 -142
        43 l-120 17 -56 109 c-60 116 -77 136 -119 136 -14 0 -34 -6 -44 -13z m74
        -308 c25 -52 59 -79 102 -79 13 0 33 -3 46 -6 22 -6 21 -8 -23 -55 -48 -51
        -51 -66 -36 -146 5 -24 7 -43 4 -43 -2 0 -26 11 -53 25 -62 31 -78 31 -141 -1
        -28 -14 -52 -24 -54 -22 -2 2 1 23 5 48 15 77 12 88 -35 139 -44 47 -45 49
        -23 55 13 3 33 6 45 6 42 0 72 23 100 76 15 30 31 54 34 54 3 0 16 -23 29 -51z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M2521 2906 c-15 -8 -46 -56 -80 -122 l-56 -109 -120 -17 c-106 -15
        -122 -20 -142 -43 -41 -47 -32 -69 69 -171 l91 -93 -16 -100 c-23 -136 -22
        -163 6 -189 35 -33 66 -27 181 34 l106 56 106 -56 c116 -62 150 -68 182 -33
        27 28 27 56 5 188 l-16 100 91 93 c101 102 110 124 69 171 -20 23 -36 28 -142
        43 l-120 17 -56 109 c-54 104 -81 135 -119 135 -8 0 -26 -6 -39 -13z m69 -307
        c25 -52 59 -79 102 -79 13 0 33 -3 46 -6 22 -6 21 -8 -23 -55 -47 -51 -50 -62
        -35 -139 4 -25 7 -46 5 -48 -2 -2 -26 8 -54 22 -28 14 -60 26 -71 26 -11 0
        -43 -12 -71 -26 -28 -14 -52 -24 -54 -22 -2 2 1 23 5 48 15 77 12 88 -35 139
        -44 47 -45 49 -23 55 13 3 33 6 46 6 43 0 77 27 102 79 13 28 26 51 30 51 4 0
        17 -23 30 -51z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M3701 2906 c-15 -8 -46 -56 -80 -122 l-56 -109 -120 -17 c-106 -15
        -122 -20 -142 -43 -41 -47 -32 -69 69 -171 l91 -93 -16 -100 c-23 -136 -22
        -163 6 -189 35 -33 66 -27 181 34 l106 56 106 -56 c116 -62 150 -68 182 -33
        27 29 28 61 5 190 l-17 97 92 94 c101 102 110 124 69 171 -20 23 -36 28 -142
        43 l-120 17 -56 109 c-54 104 -81 135 -119 135 -8 0 -26 -6 -39 -13z m69 -307
        c25 -52 59 -79 102 -79 13 0 33 -3 46 -6 22 -6 21 -8 -23 -55 -47 -51 -50 -62
        -35 -139 4 -25 7 -46 5 -48 -2 -2 -26 8 -54 22 -28 14 -60 26 -71 26 -11 0
        -43 -12 -71 -26 -28 -14 -53 -24 -54 -22 -2 2 0 21 5 43 17 74 13 93 -35 144
        -44 47 -45 49 -23 55 13 3 33 6 46 6 43 0 77 27 102 79 13 28 26 51 30 51 4 0
        17 -23 30 -51z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M1625 1575 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 l24 -25 271
        0 271 0 24 25 c16 15 25 36 25 55 0 19 -9 40 -25 55 l-24 25 -271 0 -271 0
        -24 -25z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M2425 1575 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 l24 -25 511
        0 511 0 24 25 c16 15 25 36 25 55 0 19 -9 40 -25 55 l-24 25 -511 0 -511 0
        -24 -25z"
            />
            <path
                stroke={props.color || 'none'}
                strokeWidth="2.5"
                fill={props.fill || props.color || '#D3D3D3'}
                d="M1625 1255 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 l24 -25 911
        0 911 0 24 25 c16 15 25 36 25 55 0 19 -9 40 -25 55 l-24 25 -911 0 -911 0
        -24 -25z"
            />
        </g>
    </svg>
);

export const UserFeedbackIcon = (props) => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 35}
        height={props.height || 35}
        viewBox="0 0 200.000000 200.000000"
        preserveAspectRatio="xMidYMid meet">
        <g
            fill={props.color || 'none'}
            transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
            stroke="none">
            <path
                stroke={props.color || 'none'}
                d="M149 1884 c-24 -25 -24 -28 -27 -246 -4 -289 4 -308 125 -308 l62 0
        56 -81 c41 -57 62 -79 75 -77 11 2 43 37 72 78 l54 75 631 5 c492 4 633 8 645
        18 35 28 39 65 36 290 -3 218 -3 221 -27 246 l-24 26 -827 0 -827 0 -24 -26z
        m1660 -38 c8 -9 11 -79 9 -232 l-3 -219 -637 -3 -637 -2 -48 -70 c-26 -38 -51
        -70 -54 -70 -5 0 -58 72 -91 124 -4 6 -42 13 -85 16 l-78 5 -3 219 c-2 153 1
        223 9 232 17 21 1601 21 1618 0z"
            />
            <path
                stroke={props.color || 'none'}
                d="M383 1725 c-14 -29 -24 -37 -55 -41 -59 -10 -67 -29 -30 -67 27 -28
        30 -37 25 -74 -7 -53 12 -64 64 -39 32 15 38 15 59 1 28 -18 61 -20 67 -2 2 6
        2 27 -1 45 -4 26 1 39 23 62 30 31 30 63 0 68 -53 8 -64 14 -84 47 -26 44 -47
        44 -68 0z m69 -124 c-3 -22 -9 -26 -36 -27 -27 0 -32 3 -29 17 3 9 0 20 -6 24
        -8 4 -4 13 11 25 20 16 24 16 43 2 14 -11 20 -24 17 -41z"
            />
            <path
                stroke={props.color || 'none'}
                d="M773 1733 c-23 -38 -43 -53 -69 -53 -12 0 -27 -7 -34 -15 -11 -13 -8
        -21 16 -46 25 -27 29 -36 26 -80 -4 -44 -2 -49 18 -49 11 0 34 7 51 15 27 14
        32 14 51 0 13 -8 33 -15 45 -15 21 0 23 5 23 51 0 43 5 56 26 76 36 34 25 54
        -37 67 -17 4 -35 19 -48 41 -25 42 -45 44 -68 8z m67 -123 c-4 -8 -6 -20 -3
        -25 2 -7 -11 -11 -31 -11 -19 0 -33 4 -30 8 3 4 1 15 -4 25 -7 12 -4 21 11 34
        20 15 23 15 43 0 15 -10 19 -21 14 -31z"
            />
            <path
                stroke={props.color || 'none'}
                d="M1159 1725 c-20 -33 -26 -37 -81 -49 -35 -8 -36 -29 -2 -63 19 -19
        25 -35 24 -62 -1 -20 -2 -42 -1 -48 1 -18 42 -16 69 2 19 14 24 14 51 0 17 -8
        40 -15 51 -15 20 0 22 5 18 49 -3 44 1 53 26 80 24 25 27 33 16 46 -7 8 -22
        15 -34 15 -26 0 -46 15 -69 53 -23 36 -43 34 -68 -8z m69 -118 c-5 -9 -7 -21
        -4 -25 3 -4 -11 -8 -30 -8 -22 0 -33 4 -30 11 2 7 0 18 -4 25 -5 9 -1 19 13
        30 20 16 23 17 43 1 17 -12 20 -20 12 -34z"
            />
            <path
                stroke={props.color || 'none'}
                d="M1547 1725 c-15 -32 -27 -39 -82 -47 -30 -5 -30 -37 0 -68 22 -23 27
        -36 23 -62 -3 -18 -3 -39 -1 -45 6 -18 39 -16 67 2 21 14 27 14 59 -1 52 -25
        71 -14 64 39 -5 37 -2 46 25 74 37 38 29 57 -30 67 -31 4 -41 12 -55 41 -22
        46 -48 46 -70 0z m72 -109 c-5 -6 -9 -17 -9 -26 0 -11 -9 -16 -27 -15 -37 0
        -48 42 -19 66 19 15 22 15 42 0 14 -10 19 -20 13 -25z"
            />
            <path
                stroke={props.color || 'none'}
                d="M1218 1180 c-14 -10 -35 -47 -48 -82 -63 -174 -131 -254 -237 -278
        -28 -7 -32 -5 -38 17 -7 30 -41 43 -116 43 -46 0 -59 3 -59 15 0 8 -9 24 -20
        35 -18 18 -33 20 -183 20 -131 0 -167 -3 -185 -16 l-22 -15 0 -398 c0 -373 1
        -399 18 -414 16 -14 44 -17 189 -17 152 0 172 2 186 18 10 10 17 26 17 35 0
        14 11 17 71 17 62 0 73 3 92 24 l21 23 51 -23 c81 -38 141 -44 407 -44 274 0
        294 4 323 60 19 36 19 57 1 92 -12 23 -12 32 2 70 14 40 14 46 -2 79 -15 32
        -15 38 -1 65 19 37 19 57 0 94 -14 26 -13 33 1 64 20 40 14 74 -20 113 l-24
        28 -157 3 c-142 3 -156 5 -150 20 52 123 66 264 31 315 -37 55 -104 72 -148
        37z m92 -60 c31 -31 27 -116 -11 -220 -41 -114 -44 -130 -28 -141 8 -5 88 -9
        180 -9 173 0 189 -4 189 -45 0 -38 -19 -45 -121 -45 -74 0 -100 -4 -109 -15
        -10 -12 -10 -18 0 -30 9 -10 39 -15 113 -17 l102 -3 10 -29 c8 -24 6 -31 -14
        -47 -19 -16 -40 -19 -117 -19 -94 0 -109 -5 -98 -34 5 -13 24 -16 102 -16 101
        0 132 -12 132 -51 0 -39 -26 -49 -130 -49 -81 0 -99 -3 -104 -16 -13 -34 12
        -44 113 -44 62 0 101 -4 109 -12 18 -18 14 -56 -7 -68 -12 -6 -118 -10 -274
        -10 -226 0 -262 2 -318 20 -35 11 -79 29 -96 40 l-33 20 0 235 c0 180 3 237
        13 240 6 2 30 9 53 14 96 25 179 113 233 248 18 43 36 88 41 101 12 28 43 29
        70 2z m-818 -492 c3 -255 4 -263 23 -263 19 0 20 8 23 263 l2 263 63 -3 62 -3
        0 -370 0 -370 -150 0 -150 0 -3 373 -2 372 65 0 65 0 2 -262z m353 -108 l0
        -295 -62 -3 -63 -3 0 301 0 301 63 -3 62 -3 0 -295z"
            />
            <path
                stroke={props.color || 'none'}
                d="M521 304 c-24 -30 -26 -46 -10 -77 16 -30 28 -37 66 -37 37 0 73 32
        73 66 0 67 -88 100 -129 48z m64 -54 c-5 -8 -11 -8 -17 -2 -6 6 -7 16 -3 22 5
        8 11 8 17 2 6 -6 7 -16 3 -22z"
            />
        </g>
    </svg>
);

export const LightMode = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 894.38 628.5">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect style={{ fill: '#f5f7f9' }} x="0.16" width="894.22" height="628.5" />
                <rect style={{ fill: '#fff' }} y="0.36" width="894" height="90" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="56" y="28.36" width="152" height="34" rx="17" />
                <rect style={{ fill: '#cccccc' }} x="56" y="128.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#fff' }} x="216" y="128.36" width="295" height="206" rx="17" />
                <rect style={{ fill: '#fff' }} x="216" y="359.36" width="295" height="189" rx="17" />
                <rect style={{ fill: '#fff' }} x="544" y="128.36" width="295" height="165" rx="17" />
                <rect style={{ fill: '#fff' }} x="544" y="317.36" width="295" height="201" rx="17" />
                <rect style={{ fill: '#cccccc' }} x="56" y="191.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#cccccc' }} x="56" y="254.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#cccccc' }} x="56" y="317.36" width="115" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="805" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="747" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="644" y="28.36" width="79" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#cccccc' }} x="309" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="235" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="309" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="383" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="563" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="637" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#cccccc' }} x="309" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="563" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#cccccc' }} x="637" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#cccccc' }} x="712" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="235" y="434.36" width="251" height="34" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="235" y="484.36" width="251" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="566" y="147.36" width="91" height="34" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="566" y="205.36" width="251" height="34" rx="17" />
            </g>
        </g>
    </svg>
);

export const LightMode1 = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 894.38 628.5">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect style={{ fill: '#f1f0ee' }} x="0.16" width="894.22" height="628.5" />
                <rect style={{ fill: '#fff' }} y="0.36" width="894" height="90" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="56" y="28.36" width="152" height="34" rx="17" />
                <rect style={{ fill: '#a3a3a3' }} x="56" y="128.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#fff' }} x="216" y="128.36" width="295" height="206" rx="17" />
                <rect style={{ fill: '#fff' }} x="216" y="359.36" width="295" height="189" rx="17" />
                <rect style={{ fill: '#fff' }} x="544" y="128.36" width="295" height="165" rx="17" />
                <rect style={{ fill: '#fff' }} x="544" y="317.36" width="295" height="201" rx="17" />
                <rect style={{ fill: '#a3a3a3' }} x="56" y="191.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#a3a3a3' }} x="56" y="254.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#a3a3a3' }} x="56" y="317.36" width="115" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="805" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="747" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="644" y="28.36" width="79" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#a3a3a3' }} x="309" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="235" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="309" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="383" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="563" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="637" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#a3a3a3' }} x="309" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="563" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#a3a3a3' }} x="637" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#a3a3a3' }} x="712" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="235" y="434.36" width="251" height="34" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="235" y="484.36" width="251" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="566" y="147.36" width="91" height="34" rx="17" />
                <rect style={{ fill: '#f2f2f2' }} x="566" y="205.36" width="251" height="34" rx="17" />
            </g>
        </g>
    </svg>
);

export const LightMode2 = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 894.38 628.5">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect style={{ fill: '#D7D8DF' }} x="0.16" width="894.22" height="628.5" />
                <rect style={{ fill: '#fafafa' }} y="0.36" width="894" height="90" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="56" y="28.36" width="152" height="34" rx="17" />
                <rect style={{ fill: '#8a8a8a' }} x="56" y="128.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#fafafa' }} x="216" y="128.36" width="295" height="206" rx="17" />
                <rect style={{ fill: '#fafafa' }} x="216" y="359.36" width="295" height="189" rx="17" />
                <rect style={{ fill: '#fafafa' }} x="544" y="128.36" width="295" height="165" rx="17" />
                <rect style={{ fill: '#fafafa' }} x="544" y="317.36" width="295" height="201" rx="17" />
                <rect style={{ fill: '#8a8a8a' }} x="56" y="191.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#8a8a8a' }} x="56" y="254.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#8a8a8a' }} x="56" y="317.36" width="115" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="805" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="747" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="644" y="28.36" width="79" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#8a8a8a' }} x="309" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#c7c7c7' }} x="235" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#c7c7c7' }} x="309" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#c7c7c7' }} x="383" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#c7c7c7' }} x="563" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#c7c7c7' }} x="637" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#8a8a8a' }} x="309" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="563" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#8a8a8a' }} x="637" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#8a8a8a' }} x="712" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#c7c7c7' }} x="235" y="434.36" width="251" height="34" rx="17" />
                <rect style={{ fill: '#c7c7c7' }} x="235" y="484.36" width="251" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="566" y="147.36" width="91" height="34" rx="17" />
                <rect style={{ fill: '#c7c7c7' }} x="566" y="205.36" width="251" height="34" rx="17" />
            </g>
        </g>
    </svg>
);

export const HighContrastMode = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 894.38 628.5">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect style={{ fill: '#f8f9fa' }} x="0.16" width="894.22" height="628.5" />
                <rect style={{ fill: '#fff' }} y="0.36" width="894" height="90" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="56" y="28.36" width="152" height="34" rx="17" />
                <rect style={{ fill: '#8c8c8c' }} x="56" y="128.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#fff' }} x="216" y="128.36" width="295" height="206" rx="17" />
                <rect style={{ fill: '#fff' }} x="216" y="359.36" width="295" height="189" rx="17" />
                <rect style={{ fill: '#fff' }} x="544" y="128.36" width="295" height="165" rx="17" />
                <rect style={{ fill: '#fff' }} x="544" y="317.36" width="295" height="201" rx="17" />
                <rect style={{ fill: '#8c8c8c' }} x="56" y="191.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#8c8c8c' }} x="56" y="254.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#8c8c8c' }} x="56" y="317.36" width="115" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="805" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="747" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="644" y="28.36" width="79" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#666666' }} x="309" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#b3b3b3' }} x="235" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#b3b3b3' }} x="309" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#b3b3b3' }} x="383" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#b3b3b3' }} x="563" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#b3b3b3' }} x="637" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#666666' }} x="309" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="563" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#666666' }} x="637" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#666666' }} x="712" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#b3b3b3' }} x="235" y="434.36" width="251" height="34" rx="17" />
                <rect style={{ fill: '#b3b3b3' }} x="235" y="484.36" width="251" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="566" y="147.36" width="91" height="34" rx="17" />
                <rect style={{ fill: '#b3b3b3' }} x="566" y="205.36" width="251" height="34" rx="17" />
            </g>
        </g>
    </svg>
);

export const DarkMode = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 894.38 628.5">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect style={{ fill: '#11161d' }} x="0.16" width="894.22" height="628.5" />
                <rect style={{ fill: '#1c2938' }} y="0.36" width="894" height="90" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="56" y="28.36" width="152" height="34" rx="17" />
                <rect style={{ fill: '#2b3e55' }} x="56" y="128.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#1c2938' }} x="216" y="128.36" width="295" height="206" rx="17" />
                <rect style={{ fill: '#1c2938' }} x="216" y="359.36" width="295" height="189" rx="17" />
                <rect style={{ fill: '#1c2938' }} x="544" y="128.36" width="295" height="165" rx="17" />
                <rect style={{ fill: '#1c2938' }} x="544" y="317.36" width="295" height="201" rx="17" />
                <rect style={{ fill: '#2b3e55' }} x="56" y="191.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#2b3e55' }} x="56" y="254.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#2b3e55' }} x="56" y="317.36" width="115" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="805" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="747" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="644" y="28.36" width="79" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#11161D' }} x="309" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#2B3E55' }} x="235" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#2B3E55' }} x="309" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#2B3E55' }} x="383" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#2B3E55' }} x="563" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#2B3E55' }} x="637" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#11161D' }} x="309" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="563" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#11161D' }} x="637" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#11161D' }} x="712" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#2B3E55' }} x="235" y="434.36" width="251" height="34" rx="17" />
                <rect style={{ fill: '#2B3E55' }} x="235" y="484.36" width="251" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="566" y="147.36" width="91" height="34" rx="17" />
                <rect style={{ fill: '#2B3E55' }} x="566" y="205.36" width="251" height="34" rx="17" />
            </g>
        </g>
    </svg>
);

export const DarkMode1 = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 894.38 628.5">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect style={{ fill: '#121212' }} x="0.16" width="894.22" height="628.5" />
                <rect style={{ fill: '#1C1C1C' }} y="0.36" width="894" height="90" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="56" y="28.36" width="152" height="34" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="56" y="128.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#1C1C1C' }} x="216" y="128.36" width="295" height="206" rx="17" />
                <rect style={{ fill: '#1C1C1C' }} x="216" y="359.36" width="295" height="189" rx="17" />
                <rect style={{ fill: '#1C1C1C' }} x="544" y="128.36" width="295" height="165" rx="17" />
                <rect style={{ fill: '#1C1C1C' }} x="544" y="317.36" width="295" height="201" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="56" y="191.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="56" y="254.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="56" y="317.36" width="115" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="805" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="747" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="644" y="28.36" width="79" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#121212' }} x="309" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="235" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="309" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="383" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="563" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="637" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#121212' }} x="309" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="563" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#121212' }} x="637" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#121212' }} x="712" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="235" y="434.36" width="251" height="34" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="235" y="484.36" width="251" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="566" y="147.36" width="91" height="34" rx="17" />
                <rect style={{ fill: '#4d5052' }} x="566" y="205.36" width="251" height="34" rx="17" />
            </g>
        </g>
    </svg>
);

export const DarkMode2 = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 894.38 628.5">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect style={{ fill: '#212121' }} x="0.16" width="894.22" height="628.5" />
                <rect style={{ fill: '#333333' }} y="0.36" width="894" height="90" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="56" y="28.36" width="152" height="34" rx="17" />
                <rect style={{ fill: '#72767a' }} x="56" y="128.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#333333' }} x="216" y="128.36" width="295" height="206" rx="17" />
                <rect style={{ fill: '#333333' }} x="216" y="359.36" width="295" height="189" rx="17" />
                <rect style={{ fill: '#333333' }} x="544" y="128.36" width="295" height="165" rx="17" />
                <rect style={{ fill: '#333333' }} x="544" y="317.36" width="295" height="201" rx="17" />
                <rect style={{ fill: '#72767a' }} x="56" y="191.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#72767a' }} x="56" y="254.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#72767a' }} x="56" y="317.36" width="115" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="805" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="747" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="644" y="28.36" width="79" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#212121' }} x="309" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#72767a' }} x="235" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#72767a' }} x="309" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#72767a' }} x="383" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#72767a' }} x="563" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#72767a' }} x="637" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#212121' }} x="309" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="563" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#212121' }} x="637" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#212121' }} x="712" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#72767a' }} x="235" y="434.36" width="251" height="34" rx="17" />
                <rect style={{ fill: '#72767a' }} x="235" y="484.36" width="251" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="566" y="147.36" width="91" height="34" rx="17" />
                <rect style={{ fill: '#72767a' }} x="566" y="205.36" width="251" height="34" rx="17" />
            </g>
        </g>
    </svg>
);

export const DarkMode3 = (props) => (
    <svg         
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 894.38 628.5">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect style={{ fill: '#2b2a40' }} x="0.16" width="894.22" height="628.5" />
                <rect style={{ fill: '#37364e' }} y="0.36" width="894" height="90" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="56" y="28.36" width="152" height="34" rx="17" />
                <rect style={{ fill: '#423e59' }} x="56" y="128.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#37364e' }} x="216" y="128.36" width="295" height="206" rx="17" />
                <rect style={{ fill: '#37364e' }} x="216" y="359.36" width="295" height="189" rx="17" />
                <rect style={{ fill: '#37364e' }} x="544" y="128.36" width="295" height="165" rx="17" />
                <rect style={{ fill: '#37364e' }} x="544" y="317.36" width="295" height="201" rx="17" />
                <rect style={{ fill: '#423e59' }} x="56" y="191.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#423e59' }} x="56" y="254.36" width="115" height="34" rx="17" />
                <rect style={{ fill: '#423e59' }} x="56" y="317.36" width="115" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="805" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="747" y="28.36" width="34" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="644" y="28.36" width="79" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#232233' }} x="309" y="145.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#423e59' }} x="235" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#423e59' }} x="309" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#423e59' }} x="383" y="208.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#423e59' }} x="563" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: '#423e59' }} x="637" y="397.36" width="60" height="74" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="235" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#232233' }} x="309" y="376.36" width="60" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="563" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#232233' }} x="637" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#232233' }} x="712" y="338.36" width="60" height="34" rx="17" />
                <rect style={{ fill: '#423e59' }} x="235" y="434.36" width="251" height="34" rx="17" />
                <rect style={{ fill: '#423e59' }} x="235" y="484.36" width="251" height="34" rx="17" />
                <rect style={{ fill: props.fill || '#0070ce' }} x="566" y="147.36" width="91" height="34" rx="17" />
                <rect style={{ fill: '#423e59' }} x="566" y="205.36" width="251" height="34" rx="17" />
            </g>
        </g>
    </svg>
);

export const SlidesIcon = (props) => (
    <svg 
        width={props.width || 20} 
        height={props.height || 20} 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 68 57">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                    style={{ fill: props.color || '#808080' }}
                    d="M54,8H14a5,5,0,0,0-5,5H49a5,5,0,0,1,5,5V49a5,5,0,0,0,5-5V13A5,5,0,0,0,54,8Z"
                />
                <path
                    style={{ fill: props.color || '#808080' }}
                    d="M63,0H23a5,5,0,0,0-5,5H58a5,5,0,0,1,5,5V41a5,5,0,0,0,5-5V5A5,5,0,0,0,63,0Z"
                />
                <rect style={{ fill: props.color || '#808080' }} y="16" width="50" height="41" rx="5.03" />
            </g>
        </g>
    </svg>
);

export const WizardWand = (props) => (
    <svg
        width={props.width || 20}
        height={props.height || 20}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 497.05 502.64">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Capa_1" data-name="Capa 1">
                <path
                    style={{ fill: props.color || '#010002' }}
                    d="M258.93,151.48l52.38-.69c6.88-.09,15.87,4.49,19.89,10.16l30.22,42.75c4,5.63,8.95,4.88,11-1.79l15.6-50c2-6.66,9.1-13.74,15.72-15.79l50-15.53c6.67-2,7.44-7,1.79-11L412.76,79.35c-5.68-4-10.25-12.92-10.1-19.85l.63-52.37c.08-6.88-4.36-9.23-10-5L351.39,33.4c-5.52,4.14-15.43,5.7-22,3.52L279.79,20.05c-6.58-2.2-10.16,1.34-8,7.87l16.89,49.59c2.16,6.52.63,16.46-3.45,22l-31.38,41.93C249.7,147.08,252,151.52,258.93,151.48Z"
                />
                <path
                    style={{ fill: props.color || '#010002' }}
                    d="M496,432.2l.86-.88L73,7.56,72.54,8c-.06,0-.06-.08-.13-.11-7-7.09-28.52,2.89-47.89,22.24S-4.79,71,2.26,78.05c.05.07.13.07.15.09l-.49.52,423.8,423.82.84-.91c8.41,4.45,28.11-5.28,46.08-23.29S500.4,440.57,496,432.2ZM122.67,128.33c-10.24,10.25-21,17.76-30,21.64L30,86.92C38.89,83,49.57,75.53,59.75,65.39S77.26,44.66,81.21,35.77L144.05,99C140.12,107.84,132.68,118.3,122.67,128.33Z"
                />
            </g>
        </g>
    </svg>
);

export const CreatedByAutoIcon = (props) => (
    <svg 
        width={props.width || 20} 
        height={props.height || 20} 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 60 60">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Capa_1" data-name="Capa 1">
                <path
                    style={{ fill: props.color || '#808080' }}
                    d="M10.5,6A4.5,4.5,0,1,0,15,10.5,4.51,4.51,0,0,0,10.5,6Zm0,7A2.5,2.5,0,1,1,13,10.5,2.5,2.5,0,0,1,10.5,13Z"
                />
                <circle style={{ fill: props.color || '#808080' }} cx="50" cy="9" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="46" cy="9" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="52" cy="12" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="48" cy="12" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="42" cy="9" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="44" cy="12" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="38" cy="9" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="40" cy="12" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="34" cy="9" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="36" cy="12" r="1" />
                <path
                    style={{ fill: props.color || '#808080' }}
                    d="M60,16.39V4.61A4.62,4.62,0,0,0,55.39,0H4.61A4.62,4.62,0,0,0,0,4.61V16.39A4.56,4.56,0,0,0,1.78,20,4.56,4.56,0,0,0,0,23.61V35.39A4.58,4.58,0,0,0,1.78,39,4.58,4.58,0,0,0,0,42.61V54.39A4.62,4.62,0,0,0,4.61,59H42A13,13,0,0,0,57.55,39.44a4.6,4.6,0,0,0,2.45-4V23.61A4.56,4.56,0,0,0,58.22,20,4.56,4.56,0,0,0,60,16.39ZM38.7,57H4.61A2.61,2.61,0,0,1,2,54.39V42.61A2.61,2.61,0,0,1,4.61,40H36.06l-.2.33c-.18.3-.35.61-.5.92-.08.15-.16.31-.23.47s-.15.35-.22.53-.14.36-.2.55-.11.32-.16.48c-.1.33-.19.67-.26,1,0,.12,0,.24-.07.36,0,.28-.09.55-.12.83,0,.12,0,.24,0,.36A11.46,11.46,0,0,0,34,47a13,13,0,0,0,.08,1.4c0,.13,0,.26.06.39,0,.33.09.66.16,1l.12.45c.08.29.15.58.25.86s.11.32.17.48.21.52.32.77l.24.51c.12.23.24.45.37.67s.2.35.31.52.27.39.41.58.25.35.38.52.29.34.45.51.29.33.44.49.36.34.55.51S38.56,56.89,38.7,57ZM47,58a11.06,11.06,0,0,1-4.24-.85l-.09,0a8.16,8.16,0,0,1-.84-.41,2,2,0,0,1-.25-.14L41,56.19,40.74,56c-.22-.15-.44-.32-.65-.49L40,55.46c-.26-.22-.51-.44-.75-.68l0,0c-.22-.23-.43-.46-.64-.7l-.11-.15c-.18-.22-.36-.45-.52-.69a.76.76,0,0,0-.08-.11c-.18-.27-.35-.55-.5-.83,0-.06-.06-.12-.09-.17q-.18-.34-.33-.69c0-.1-.09-.19-.13-.29s-.17-.46-.25-.69a2.09,2.09,0,0,0-.08-.23,9.32,9.32,0,0,1-.23-.91L36.19,49c0-.24-.08-.48-.11-.72l0-.3c0-.33,0-.66,0-1s0-.71,0-1.06c0-.16.05-.32.07-.48s.05-.36.08-.54.09-.4.14-.6.07-.26.1-.38.14-.44.22-.66.07-.2.11-.29.19-.46.3-.68a2.56,2.56,0,0,1,.11-.24c.12-.23.24-.46.38-.68l.11-.19c.14-.23.3-.45.46-.68l.11-.14q.25-.35.54-.66l.09-.11a9.63,9.63,0,0,1,.72-.71.52.52,0,0,1,.11-.1,9.46,9.46,0,0,1,.78-.64l.1-.07a10.44,10.44,0,0,1,.89-.58l.05,0a10.46,10.46,0,0,1,1-.51h0a10.57,10.57,0,0,1,3.28-.89h0A11.27,11.27,0,0,1,47,36a10.94,10.94,0,0,1,5.46,1.46h0a9.19,9.19,0,0,1,.93.6l.07,0c.27.21.54.42.81.65l.09.09a9.78,9.78,0,0,1,.72.72A11,11,0,0,1,47,58ZM58,23.61V35.39a2.62,2.62,0,0,1-1.78,2.46,13,13,0,0,0-7.93-3.79Q47.65,34,47,34a13,13,0,0,0-9.34,4l0,0h-33A2.61,2.61,0,0,1,2,35.39V23.61A2.61,2.61,0,0,1,4.61,21H55.39A2.61,2.61,0,0,1,58,23.61ZM4.61,19A2.61,2.61,0,0,1,2,16.39V4.61A2.61,2.61,0,0,1,4.61,2H55.39A2.61,2.61,0,0,1,58,4.61V16.39A2.61,2.61,0,0,1,55.39,19Z"
                />
                <path
                    style={{ fill: props.color || '#808080' }}
                    d="M10.5,34A4.5,4.5,0,1,0,6,29.5,4.51,4.51,0,0,0,10.5,34Zm0-7A2.5,2.5,0,1,1,8,29.5,2.5,2.5,0,0,1,10.5,27Z"
                />
                <circle style={{ fill: props.color || '#808080' }} cx="50" cy="28" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="46" cy="28" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="52" cy="31" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="48" cy="31" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="42" cy="28" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="44" cy="31" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="38" cy="28" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="40" cy="31" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="34" cy="28" r="1" />
                <circle style={{ fill: props.color || '#808080' }} cx="36" cy="31" r="1" />
                <path
                    style={{ fill: props.color || '#808080' }}
                    d="M10.5,44A4.5,4.5,0,1,0,15,48.5,4.51,4.51,0,0,0,10.5,44Zm0,7A2.5,2.5,0,1,1,13,48.5,2.5,2.5,0,0,1,10.5,51Z"
                />
                <path
                    style={{ fill: props.color || '#808080' }}
                    d="M53,46H48V41a1,1,0,0,0-2,0v5H41a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V48h5a1,1,0,0,0,0-2Z"
                />
            </g>
        </g>
    </svg>
);

export const DateRangeIcon = (props) => (
    <svg 
        width={props.width || 20} 
        height={props.height || 20} 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 18 20">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                    style={{ fill: props.color || '#808080' }}
                    d="M6,9H4v2H6Zm4,0H8v2h2Zm4,0H12v2h2Zm2-7H15V0H13V2H5V0H3V2H2A2,2,0,0,0,0,4V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V4A2,2,0,0,0,16,2Zm0,16H2V7H16Z"
                />
            </g>
        </g>
    </svg>
);

export const UserCreatePeople = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        width={props.width || 1066.10578}
        height={props.height || 824.1997}
        viewBox="0 0 1066.10578 824.1997">
        <polygon
            points="962.551 394.71 946.672 466.13 933.782 524.07 923.508 570.28 910.626 628.22 868.531 817.51 346.914 576.48 308.572 558.76 260.039 536.33 221.683 518.61 175.551 497.29 201.704 459.24 223.452 427.6 250.965 387.57 272.707 355.95 517.369 0 776.55 229.8 822.703 270.72 859.505 303.35 905.666 344.27 962.551 394.71"
            fill={!props.darkTheme ? '#f2f2f2' : 'rgba(0, 0, 0, 0.15)'}
        />
        <path
            d="M271.30076,642.73135C236.42088,623.287,214.707,596.74014,206.7617,563.829c-5.89942-24.43555-4.2041-51.93262,5.03808-81.72754a218.88823,218.88823,0,0,1,30.439-61.48437c70.63818-99.98633,77.01367-165.1377,69.92334-202.18653-7.77393-40.623-33.03125-57.49414-33.28565-57.65967l1.09034-1.67675c.26074.16943,26.18359,17.43261,34.14453,58.87988,4.58935,23.89453,2.43017,51.14062-6.41748,80.981-11.01172,37.13769-32.48438,78.459-63.82129,122.8164a216.90408,216.90408,0,0,0-30.1626,60.92188c-15.1582,48.86718-17.30273,115.99707,58.56445,158.292Z"
            transform="translate(-66.94711 -37.90015)"
            fill={!props.darkTheme ? '#2f2e41' : '#cccccc'}
        />
        <path
            d="M288.07412,642.73135C322.954,623.287,344.66787,596.74014,352.61318,563.829c5.89942-24.43555,4.2041-51.93262-5.03808-81.72754a218.88823,218.88823,0,0,0-30.439-61.48437c-70.63818-99.98633-77.01367-165.1377-69.92334-202.18653,7.77393-40.623,33.03125-57.49414,33.28565-57.65967l-1.09034-1.67675c-.26074.16943-26.18359,17.43261-34.14453,58.87988-4.58935,23.89453-2.43017,51.14062,6.41748,80.981,11.01172,37.13769,32.48438,78.459,63.82129,122.8164a216.90408,216.90408,0,0,1,30.1626,60.92188c15.1582,48.86718,17.30273,115.99707-58.56445,158.292Z"
            transform="translate(-66.94711 -37.90015)"
            fill={!props.darkTheme ? '#2f2e41' : '#cccccc'}
        />
        <path
            d="M1048.30076,558.73135C1013.42088,539.287,991.707,512.74014,983.7617,479.829c-5.89942-24.43555-4.2041-51.93262,5.03808-81.72754a218.88823,218.88823,0,0,1,30.439-61.48437c70.63818-99.98633,77.01367-165.1377,69.92334-202.18653-7.77393-40.623-33.03125-57.49414-33.28565-57.65967l1.09034-1.67675c.26074.16943,26.18359,17.43261,34.14453,58.87988,4.58935,23.89453,2.43017,51.14062-6.41748,80.981-11.01172,37.13769-32.48438,78.459-63.82129,122.8164a216.90408,216.90408,0,0,0-30.1626,60.92188c-15.1582,48.86718-17.30273,115.99707,58.56445,158.292Z"
            transform="translate(-66.94711 -37.90015)"
            fill={!props.darkTheme ? '#2f2e41' : '#cccccc'}
        />
        <path
            d="M1065.07412,558.73135c34.87988-19.44433,56.59375-45.99121,64.53906-78.90234,5.89942-24.43555,4.2041-51.93262-5.03808-81.72754a218.88823,218.88823,0,0,0-30.439-61.48437c-70.63818-99.98633-77.01367-165.1377-69.92334-202.18653,7.77393-40.623,33.03125-57.49414,33.28565-57.65967l-1.09034-1.67675c-.26074.16943-26.18359,17.43261-34.14453,58.87988-4.58935,23.89453-2.43017,51.14062,6.41748,80.981,11.01172,37.13769,32.48438,78.459,63.82129,122.8164a216.90408,216.90408,0,0,1,30.1626,60.92188c15.1582,48.86718,17.30273,115.99707-58.56445,158.292Z"
            transform="translate(-66.94711 -37.90015)"
            fill={!props.darkTheme ? '#2f2e41' : '#cccccc'}
        />
        <path
            d="M534.762,337.84484c-26.20687-44.2815-78.05507-46.34521-78.05507-46.34521s-50.52312-6.46085-82.93338,60.98042c-30.209,62.86081-71.90115,123.55421-6.71211,138.26947l11.775-36.64918,7.29222,39.37767a255.06843,255.06843,0,0,0,27.892.47669c69.81221-2.25395,136.29778.65944,134.157-24.39211C545.332,436.26009,559.97826,380.4525,534.762,337.84484Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#2f2e41"
        />
        <path
            d="M427.19425,430.52233c9.03031,19.97526,14.72473,43.78567,18.12479,70.23353l72.49913-4.5312c-16.66786-23.6189-22.20214-50.72822-15.85919-81.56152Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#ffb8b8"
        />
        <path
            d="M427.19425,430.52233c9.03031,19.97526,14.72473,43.78567,18.12479,70.23353l72.49913-4.5312c-16.66786-23.6189-22.20214-50.72822-15.85919-81.56152Z"
            transform="translate(-66.94711 -37.90015)"
            opacity="0.2"
        />
        <path
            d="M90.81926,810.84366s-37.5228,20.09888-18.48195,37.25877,44.19287-22.71411,44.19287-22.71411Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#ffb8b8"
        />
        <polygon
            points="482.591 714.334 482.005 741.792 480.754 801.122 480.754 801.132 480.39 818.314 240.438 818.314 250.19 764.163 250.2 764.123 258.932 715.656 262.829 693.951 262.829 693.941 459.937 666.755 482.591 714.334"
            fill="#2f2e41"
        />
        <path
            d="M549.53654,752.23722l-.58908,27.459c-69.73517-1.78991-177.82675-18.62329-223.07067-26.14509l3.89676-21.70432,197.107-27.18718Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#3f3d56"
        />
        <circle cx="395.36391" cy="355.23981" r="56.63995" fill="#ffb8b8" />
        <path
            d="M571.05972,782.82279s6.79679,61.17114-33.984,56.63994l-6.7968-61.17114L494.02939,742.042l-101.9519-2.2656L317.31276,810.01s-2.2656-72.49913,6.79679-79.29592,29.45278-22.656,29.45278-22.656v-11.328L292.39118,572.12219s36.24957-74.76473,65.70234-77.03033l38.51516-2.26559s13.59359-6.7968,13.59359-9.0624-2.2656-20.39038,9.06239-15.85918c0,0,1.01941-23.24506,12.95916-16.15372,0,0,37.58646,29.45277,75.73905,1.2914,0,0,17.78489-3.26246,15.51929,5.79993s0,15.85918,4.5312,15.85918,24.92157,6.7968,24.92157,11.328c0,.97419,1.4727,10.3538,3.78337,24.46843v.02268c8.40556,51.45164,27.935,165.81911,27.935,165.81911S605.04368,705.79246,571.05972,782.82279Z"
            transform="translate(-66.94711 -37.90015)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M308.25037,560.7942l-15.85919,11.328-144.99826,185.779L70.3626,819.07235s43.04636-6.79679,33.984,29.45277L369.42151,696.73007Z"
            transform="translate(-66.94711 -37.90015)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M556.7183,510.4979v.02268c-3.01286,17.717-101.20407,14.02406-114.79766,14.02406s-24.92158-2.2656-38.51516-11.328-6.7968-20.39038-6.7968-20.39038,11.57456-8.81583,11.57456-11.08143-2.2656-20.39038,9.06239-15.85919c0,0,1.01941-23.245,12.95915-16.15372,0,0,39.6055,31.47181,77.75809,3.31044,0,0,17.78489-3.26246,15.51929,5.79993s0,15.85918,4.5312,15.85918,24.92157,6.7968,24.92157,11.328C552.93493,487.00366,554.40763,496.38327,556.7183,510.4979Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#3f3d56"
        />
        <path
            d="M545.00534,425.99113s-18.12478-38.51516-36.24956-20.39038,20.39038,45.312,20.39038,45.312Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#ffb8b8"
        />
        <path
            d="M545.00534,416.92874s-27.98762,35.36953-36.64979,38.07515c0,0,25.3218,100.12632,57.04017,127.31349l18.12478,92.88951s77.03033-31.71837,58.90555-83.82712q-.27187-.78163-.541-1.55376a513.98548,513.98548,0,0,0-62.09845-122.40839Z"
            transform="translate(-66.94711 -37.90015)"
            fill={props.color || '#0070ce'}
        />
        <polygon points="463.102 483.933 518.839 637.307 498.449 544.417 463.102 483.933" opacity="0.2" />
        <polygon
            points="456.229 295.676 405.005 268.845 334.268 279.821 319.632 344.46 356.064 343.059 366.242 319.311 366.242 342.668 383.052 342.021 392.809 304.213 398.907 344.46 458.668 343.241 456.229 295.676"
            fill="#2f2e41"
        />
        <path
            d="M1007.07589,682.23771,1036.13813,785.909s-5.98872,91.827,21.95862,73.86082c28.59982-18.3856,17.96614-95.81944,17.96614-95.81944L1059.311,670.94362Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#a0616a"
        />
        <path
            d="M1022.60526,391.41495l23.99994,23.99994V529.76753s14.11761,21.17641,11.29408,26.82345-5.647,5.64705-2.82352,9.88233,5.64705,7.0588,2.82352,9.88233-2.82352,9.88232,0,12.70584,8.47057,7.05881,4.23529,11.29409-9.88233,1.41176-4.23529,16.94113,15.52937,19.76466,12.70585,25.4117-2.82352,19.76465-2.82352,19.76465l-60.70572,8.47057L994.37,511.41463Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#d0cde1"
        />
        <polygon
            points="1003.658 623.161 933.07 625.985 935.893 655.632 998.011 644.338 1003.658 623.161"
            fill="#3f3d56"
        />
        <polygon
            points="809.541 205.986 801.07 290.691 887.188 303.397 893.541 254.692 899.894 205.986 809.541 205.986"
            fill="#a0616a"
        />
        <polygon
            points="809.541 205.527 801.07 290.233 887.188 302.939 893.541 254.233 899.894 205.527 809.541 205.527"
            opacity="0.1"
        />
        <path
            d="M689.42968,646.94368l47.99987,103.05855s8.47057,47.99987,21.17642,49.41163,25.41169-49.41163,25.41169-49.41163l-16.94113-26.82346-19.76465-76.23509Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#a0616a"
        />
        <path
            d="M1018.00305,857.214H746.6346c2.15028-34.01065,3.503-54.97836,3.503-54.97836l3.604-5.67348,17.47475-27.45889L783.694,749.49843l4.351-6.84456,1.61527-2.53384,17.09113-3.11943L983.0737,704.82727a215.42643,215.42643,0,0,0,12.32623,38.1093c1.20133,2.73581,2.49348,5.47156,3.87652,8.17706,4.43179,8.65158,9.84279,16.84886,16.27348,22.88581,1.46375,1.37293,2.52379,5.03749,3.21026,10.67061C1020.45617,798.47014,1019.97156,824.13207,1018.00305,857.214Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#2f2e41"
        />
        <circle cx="856.83489" cy="165.7506" r="67.76452" fill="#a0616a" />
        <path
            d="M772.72358,342.00332l-9.88233-5.647s-43.76459,29.647-57.8822,95.99974-23.99993,83.2939-23.99993,83.2939-14.11761,2.82352-4.23529,12.70584,9.88233,8.47057,1.41176,14.11761-14.11761-5.647-8.47056,5.647,12.70585,8.47056,7.0588,15.52937-15.52937,7.0588-9.88232,12.70585-5.647,18.35289,1.41176,23.99993,9.88232,7.05881,9.88232,16.94113a49.9927,49.9927,0,0,0,2.82353,16.94113h73.41156s-14.11761-26.82345-9.88232-32.4705,5.647-11.29408,2.82352-14.11761-11.29409,2.82353-2.82352-4.23528,11.29408-2.82352,8.47056-11.29409-8.47056-4.23528-2.82352-8.47056,9.88233-2.82352,7.05881-7.05881-8.47057-4.23528-2.82353-7.0588,9.88233,0,8.47057-7.05881-2.82352-4.23528,0-7.0588,32.4705-98.82327,32.4705-101.64679S772.72358,342.00332,772.72358,342.00332Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#d0cde1"
        />
        <polygon
            points="691.659 590.691 602.718 596.338 625.306 617.514 687.424 618.926 691.659 590.691"
            fill="#3f3d56"
        />
        <path
            d="M784.01766,734.47286l-18.35289,33.88226s55.05868,7.05881,74.82333,14.11761,70.588,16.94113,70.588,16.94113L923.782,750.00223Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#3f3d56"
        />
        <polygon
            points="878.011 712.102 893.541 758.69 955.658 745.984 948.599 702.22 878.011 712.102"
            fill="#3f3d56"
        />
        <path
            d="M970.37011,294.00345s-4.23529-2.82352-14.11761,2.82352-42.35283,8.47057-57.8822-8.47056-26.82346-31.05874-31.05874-28.23522-7.05881,35.294-7.05881,35.294L846.13514,306.7093l-83.29389,29.647,7.0588,190.58772,12.70585,43.76459s-9.88232,33.88227,2.82352,53.64692-7.0588,26.82346-7.0588,26.82346-4.23528,5.647-1.41176,19.76465-2.82352,66.35276-2.82352,66.35276,119.99968,53.64692,245.6464,7.05881l-14.11761-53.64692-7.05881-119.99968s7.05881-19.76465,5.64705-28.23522,42.35283-127.05848,42.35283-127.05848-7.05881-59.294-43.76459-71.99981-42.35283-25.41169-42.35283-25.41169S977.42891,299.65049,970.37011,294.00345Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#d0cde1"
        />
        <path
            d="M855.54758,212.33147s-7.037-10.55549-4.33045-21.92294a66.44367,66.44367,0,0,0,1.89457-19.7577s5.68372-18.40444,11.36745-28.68928,2.97719-14.61529,20.84032-17.86313,10.55549-26.524,57.6492-1.35327a13.81105,13.81105,0,0,0,14.34464,5.41307c9.74353-1.89457,13.262,11.6381,13.262,11.6381s6.49569-3.78914,8.93157,1.62393,19.8043-3.24882,19.8043,33.2894-19.76465,69.17629-19.76465,69.17629,1.44894-61.46168-30.75883-67.68672-66.85142-24.35881-75.24168-1.08261S855.54758,212.33147,855.54758,212.33147Z"
            transform="translate(-66.94711 -37.90015)"
            fill="#2f2e41"
        />
        <ellipse cx="913.30532" cy="180.57409" rx="6.35292" ry="8.47057" fill="#a0616a" />
    </svg>
);

export const MaleAvatarSketch = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        width={props.width || 676}
        height={props.height || 676}
        viewBox="0 0 676 676">
        <path
            d="M938,450a336.852,336.852,0,0,1-27.22,133.1L909.66,585.68A338.559,338.559,0,0,1,541.35,782.93q-3.045-.54-6.08-1.12a334.98111,334.98111,0,0,1-61.14-18.03q-4.815-1.935-9.56-4.01c-2.16-.94-4.32-1.91-6.46-2.91A338.41424,338.41424,0,0,1,262,450c0-186.67,151.33-338,338-338S938,263.33,938,450Z"
            transform="translate(-262 -112)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M541.35,782.93q-3.045-.54-6.08-1.12c-1.32-38.31-5.85-116.94-21.30005-199.29C505.52,537.45,493.79,491.25,477.52,449.95a412.60387,412.60387,0,0,0-19.07-41.84c-16.44-31.05-36.38-57.19-60.56-74.9l3.56-4.86q30.165,22.11,54.22,62.08,7.215,11.97,13.86005,25.54,7.125,14.52,13.59,30.83,4.125,10.38,7.97,21.48,16.74,48.195,28.46,109.98,2.59506,13.65,4.94,27.97C536.6,680.2,540.25,748.59,541.35,782.93Z"
            transform="translate(-262 -112)"
            opacity="0.2"
        />
        <path
            d="M464.57,759.77c-2.16-.94-4.32-1.91-6.46-2.91-2.09-22.7-5.93-50.86-12.95-77.59A254.55666,254.55666,0,0,0,433.35,644.07c-8.01-18.75-18.38-34.69-31.79-44.52l3.56-4.85c14.04,10.28,24.87,26.53,33.24,45.54,9.43,21.42,15.72,46.35,19.91,70.17C461.38,728.1,463.34,745.19,464.57,759.77Z"
            transform="translate(-262 -112)"
            opacity="0.2"
        />
        <circle cx="102.26174" cy="190.98167" r="30.08857" opacity="0.2" />
        <circle cx="111.9514" cy="449.99083" r="30.08857" opacity="0.2" />
        <path
            d="M483.71449,353.52139c-6.38046,35.99732,7.70456,68.59225,7.70456,68.59225s24.42979-25.76825,30.81025-61.76557-7.70457-68.59225-7.70457-68.59225S490.09494,317.52407,483.71449,353.52139Z"
            transform="translate(-262 -112)"
            opacity="0.2"
        />
        <path
            d="M383.71766,438.97122c34.33494,12.555,68.83676,4.498,68.83676,4.498s-21.16612-28.41279-55.50106-40.96784-68.83675-4.498-68.83675-4.498S349.38272,426.41617,383.71766,438.97122Z"
            transform="translate(-262 -112)"
            opacity="0.2"
        />
        <path
            d="M377.89534,668.333c24.066,8.80008,48.28314,3.0594,48.28314,3.0594S411.37687,651.384,387.31086,642.5839s-48.28314-3.0594-48.28314-3.0594S353.82933,659.53292,377.89534,668.333Z"
            transform="translate(-262 -112)"
            opacity="0.2"
        />
        <circle cx="337.30608" cy="281.0788" r="131.77014" fill="#d0cde1" />
        <path
            d="M547.83337,493.96531s16.47127,78.23852,16.47127,86.47415,78.23852,45.296,78.23852,45.296L712.546,613.382,737.253,539.26129s-41.17817-61.76725-41.17817-86.47415Z"
            transform="translate(-262 -112)"
            fill="#d0cde1"
        />
        <path
            d="M910.78,583.1,909.66,585.68A338.559,338.559,0,0,1,541.35,782.93q-3.045-.54-6.08-1.12a334.98111,334.98111,0,0,1-61.14-18.03q-4.815-1.935-9.56-4.01c-2.16-.94-4.32-1.91-6.46-2.91a337.59273,337.59273,0,0,1-55.25-32.28l-15.62-45.31,8.78-6.69995,18.06-13.79,19.27-14.71,5.01-3.83,75.61-57.72,5.58-4.26,39.3-30,.01-.01s42.5,69.25,104.27,48.66,60.42-79.63,60.42-79.63Z"
            transform="translate(-262 -112)"
            fill="#2f2e41"
        />
        <path
            d="M485.03538,286.916s41.83653-90.64581,122.02321-69.72755,125.50958,52.29566,128.996,83.67306-1.74319,78.44348-1.74319,78.44348-8.716-64.498-64.498-50.55247-142.94147,3.48638-142.94147,3.48638L512.9264,457.74849s-15.6887-22.66145-33.12058-8.71594S429.25335,314.807,485.03538,286.916Z"
            transform="translate(-262 -112)"
            fill="#2f2e41"
        />
        <path
            d="M474.13,763.78q-4.815-1.935-9.56-4.01c-2.16-.94-4.32-1.91-6.46-2.91a338.835,338.835,0,0,1-87.59-58.7c9.19-12.52,16.72-18.89,16.72-18.89h61.77l9.26,31.14Z"
            transform="translate(-262 -112)"
            fill="#2f2e41"
        />
        <path
            d="M856.67,576.32l52.99,9.36A337.94434,337.94434,0,0,1,852.9,674.25Z"
            transform="translate(-262 -112)"
            fill="#2f2e41"
        />
    </svg>
);

export const CoworkersSketch = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        width={props.width || 715.29587}
        height={props.height || 604.16998}
        viewBox="0 0 715.29587 604.16998">
        <path
            d="M948.01805,354.635q1.25976,4.92,2.36035,9.89H700.64793v-9.89Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M940.05813,328.565a305.61151,305.61151,0,0,0-14.04-33.26q-2.46-4.995-5.11-9.89c-.29-.56-.6-1.12-.91-1.68v73.6h21.58v-24.39Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M926.01805,295.305h-6.02V285.415h.91016Q923.56322,290.305,926.01805,295.305Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <polygon
            points="697.706 180.65 677.646 180.65 677.646 190.54 699.226 190.54 699.226 185.03 697.706 180.65"
            fill="#ccc"
        />
        <rect x="644.38463" y="124.017" width="21.57574" height="85.4041" fill="#e6e6e6" />
        <rect x="644.38463" y="137.50186" width="21.57574" height="9.8889" fill="#ccc" />
        <rect x="644.38463" y="180.65341" width="21.57574" height="9.8889" fill="#ccc" />
        <path
            d="M809.918,271.435h-77.3999a4.50681,4.50681,0,0,0-4.5,4.5v77.4a4.65641,4.65641,0,0,0,.18994,1.3,4.50994,4.50994,0,0,0,4.31006,3.2H809.918a4.50948,4.50948,0,0,0,4.31006-3.2,4.63848,4.63848,0,0,0,.18994-1.3v-77.4A4.50681,4.50681,0,0,0,809.918,271.435Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M804.418,276.935h-66.3999a4.50681,4.50681,0,0,0-4.5,4.5v66.4a4.50681,4.50681,0,0,0,4.5,4.5H804.418a4.50681,4.50681,0,0,0,4.5-4.5v-66.4A4.50681,4.50681,0,0,0,804.418,276.935Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#fff"
        />
        <path
            d="M792.83836,288.515H749.59813a4.50681,4.50681,0,0,0-4.5,4.5v43.24a4.50676,4.50676,0,0,0,4.5,4.5h43.24023a4.52349,4.52349,0,0,0,4.5-4.5v-43.24A4.50681,4.50681,0,0,0,792.83836,288.515Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M790.17235,328.62827l-9.13281-15.819a2.00023,2.00023,0,0,0-3.46436,0l-6.66895,11.55108-8.74609-15.14728a1.99984,1.99984,0,0,0-3.46387.00007l-9.1333,15.81909-10.86474,18.819H759.6533l-2.07617,3.596h43.46094Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#fff"
        />
        <circle cx="544.59673" cy="150.08772" r="6.29292" fill="#fff" />
        <path
            d="M957.56834,424.515q-.10547-5.82-.46045-11.58c-.0996-1.84-.21972-3.67-.36962-5.5H914.51805a4.50681,4.50681,0,0,0-4.5,4.5v77.4a4.08953,4.08953,0,0,0,.12988,1.05,4.50432,4.50432,0,0,0,4.37012,3.45H953.438c.2002-1.14.39014-2.3.56006-3.45.10986-.68.22022-1.37.32031-2.05.23975-1.63.46973-3.26.67969-4.89q.45043-3.33.81006-6.69,1.31982-12.04494,1.7002-24.35v-.01q.13476-4.635.13964-9.31v-12C957.64793,428.885,957.6284,426.695,957.56834,424.515Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M957.56834,424.515q-.10547-5.82-.46045-11.58H920.01805a4.50681,4.50681,0,0,0-4.5,4.5v66.4a4.50681,4.50681,0,0,0,4.5,4.5h34.30029c.23975-1.63.46973-3.26.67969-4.89q.45043-3.33.81006-6.69,1.31982-12.04494,1.7002-24.35v-.01q.13476-4.635.13964-9.31v-12C957.64793,428.885,957.6284,426.695,957.56834,424.515Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#fff"
        />
        <path
            d="M957.56834,424.515H931.59813a4.50681,4.50681,0,0,0-4.5,4.5v43.24a4.50676,4.50676,0,0,0,4.5,4.5h24.21q1.31982-12.04494,1.7002-24.35v-.01q.13476-4.635.13964-9.31v-12C957.64793,428.885,957.6284,426.695,957.56834,424.515Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M957.50829,452.405q-.375,12.3-1.7002,24.35-.35962,3.36-.81006,6.69H939.57811l2.08008-3.59h-20.96l6.3999-11.09,4.46-7.73,9.14014-15.82a1.99145,1.99145,0,0,1,3.46,0l8.75,15.15Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#fff"
        />
        <path
            d="M881.73827,228.785H700.64793v-9.89H872.75829Q877.34837,223.74,881.73827,228.785Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M796.83836,160.195q11.06984,6.09,21.57959,13.05v48.34H796.83836Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <rect x="554.48565" y="44.90582" width="21.57574" height="9.8889" fill="#ccc" />
        <path
            d="M851.67821,198.645v22.94H830.09813v-40.21q7.54541,5.50506,14.75,11.45Q848.29783,195.675,851.67821,198.645Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M851.67821,198.645v4.06H830.09813v-9.88h14.75Q848.29783,195.675,851.67821,198.645Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M774.80809,149.175q8.56494,3.85491,16.83984,8.22l-4.43994,8.96-14.75,29.81-4.38965,8.86-6.87011,13.87-1.51026,3.05-6.1499-3.05-13.18018-6.53,8.37012-16.92h.01026l4.37988-8.86,14.76025-29.81,4.33985-8.76.0498-.1Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <polygon
            points="549.246 9.57 544.856 18.44 525.526 8.86 529.866 0.1 529.916 0 532.456 1.26 549.246 9.57"
            fill="#ccc"
        />
        <rect
            x="755.6482"
            y="185.01745"
            width="9.8889"
            height="21.57574"
            transform="translate(5.29589 642.64123) rotate(-63.6604)"
            fill="#ccc"
        />
        <path
            d="M953.998,490.385c-.16992,1.15-.35986,2.31-.56006,3.45-.34961,2.16-.73,4.3-1.13965,6.44H700.64793v-9.89Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <rect x="554.48565" y="259.76454" width="21.57574" height="85.40411" fill="#e6e6e6" />
        <rect x="554.48565" y="273.24943" width="21.57574" height="9.88889" fill="#ccc" />
        <rect x="554.48565" y="316.40098" width="21.57574" height="9.88889" fill="#ccc" />
        <rect x="587.74828" y="259.76454" width="21.57574" height="85.40411" fill="#e6e6e6" />
        <rect x="587.74828" y="273.24943" width="21.57574" height="9.88889" fill="#ccc" />
        <rect x="587.74828" y="316.40098" width="21.57574" height="9.88889" fill="#ccc" />
        <rect
            x="726.26691"
            y="439.59375"
            width="85.40411"
            height="21.57574"
            transform="translate(-218.19047 791.77108) rotate(-63.6604)"
            fill="#e6e6e6"
        />
        <rect
            x="774.79411"
            y="417.84108"
            width="9.88889"
            height="21.57574"
            transform="translate(-192.70495 789.32135) rotate(-63.6604)"
            fill="#ccc"
        />
        <rect
            x="755.64818"
            y="456.51258"
            width="9.88889"
            height="21.57574"
            transform="translate(-238.01263 793.67647) rotate(-63.6604)"
            fill="#ccc"
        />
        <path
            d="M535.15014,528.49686a19.79134,19.79134,0,0,1,2.57027,1.762L626.74915,502.553l5.02034-22.08811,34.32513,3.21966-5.08744,39.96635a15.0408,15.0408,0,0,1-12.56839,12.95649L543.66567,553.19537a19.73558,19.73558,0,1,1-8.51553-24.69851Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ffb8b8"
        />
        <path
            d="M681.958,496.935l-.58984-10.08v-.01l-.16016-2.76-1.73974-29.68a23.47273,23.47273,0,0,0-21.33008-25.35,23.14957,23.14957,0,0,0-5.33985.14,23.54326,23.54326,0,0,0-20.15039,21.18l-3.60986,15.02-6.31006,26.27a8.41756,8.41756,0,0,0,4.34033,9.48,8.27547,8.27547,0,0,0,3.12989.92l10.52.94,10.12988.9,11.68994,1.04.84033.07,2.15967.2,7.23.64h.02a8.56288,8.56288,0,0,0,6.62012-2.36005,8.58059,8.58059,0,0,0,1.58984-2.12,8.24536,8.24536,0,0,0,.96-4.44Z"
            transform="translate(-242.35207 -147.91501)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M779.65374,374.70751c0,34.22533-31.64676,29.04864-70.685,29.04864s-70.685,5.17669-70.685-29.04864,15.45864-94.89222,70.685-94.89222C766.09771,279.81529,779.65374,340.48219,779.65374,374.70751Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#2f2e41"
        />
        <circle
            cx="708.73237"
            cy="356.13468"
            r="47.56429"
            transform="translate(-286.59441 457.54389) rotate(-45)"
            fill="#ffb8b8"
        />
        <path
            d="M775.688,423.695a29.37016,29.37016,0,0,0-2.90967-2.46,30.91983,30.91983,0,0,0-22.63037-5.99006l-87.6499,11.09a31.11934,31.11934,0,0,0-27.1499,33.78c.25,2.8.53027,5.75.83984,8.82.40039,3.85.8501,7.89,1.37012,12.07.85986,7.03,1.91016,14.45,3.16016,22,1.08984,6.5,2.33007,13.09,3.75,19.6q.61523,2.82,1.27978,5.62a.03607.03607,0,0,0,.01026.03c.0498.23005.0996.46.15966.68a.07353.07353,0,0,0,.01026.05q.93016,3.9,1.95019,7.71c.25977.94.50977,1.87.76953,2.79.7002,2.5,1.44043,4.95,2.2002,7.36,5.71,17.93,13.25976,33.2,23.23,41.32.12988.12.26025.22.3999.32995l.40039.31.57959-.18,2.46-.73,2.1001-.64,27.36035-8.23,6.80957-2.05,21.88037-6.59h.00977l20.01025-6.02,2.43994-.74,17.19-5.17.5498-6.42.74024-8.52.43994-5.12,3.48-40.38,2.02978-23.56,2.2002-25.58A31.07666,31.07666,0,0,0,775.688,423.695Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#2f2e41"
        />
        <path
            d="M824.69823,619.085c-.23-.67-.4502-1.34-.68018-2-10.27978-30-25.43994-52.69-47.75-65.05-.00976,0-.00976-.01-.02-.01l-.37988-.21-19.43994,6.73-2.39991.83-2.5.87-.03027.01-18.19971,6.3-.03027.01-14.27978,4.94H718.978l-13.21,4.57h-.00976l-3.07032,1.07-23.08984,7.99-2.68018.93-2.3999.83-.37012.13-.06982,1.14-1.6499,28.92-.10987,2-2.06005,36.09-68.41016,96.91h46.7998a308.16253,308.16253,0,0,0,46.84034-3.57l43.90966-47.32a2.9075,2.9075,0,0,1,4.94043,1.44l6.44971,32a309.22958,309.22958,0,0,0,88-48.42C835.708,661.365,831.208,638.715,824.69823,619.085Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#2f2e41"
        />
        <path
            d="M653.77631,351.46855v0H672.5889l8.29947-23.23891,1.65952,23.23891h8.99165l4.84144-13.556.96829,13.556h66.81187v0a50.35092,50.35092,0,0,0-50.35093-50.35092h-9.683A50.35092,50.35092,0,0,0,653.77631,351.46855Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#2f2e41"
        />
        <path
            d="M538.06146,603.47244a22.78775,22.78775,0,0,1-31.05941-16.00863l-80.46558-9.11312,26.973-32.30021,72.27622,13.606a22.91124,22.91124,0,0,1,12.27573,43.816Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#a0616a"
        />
        <path
            d="M494.67821,543.685l-34.01026-6.08-2.46972-.44a14.21295,14.21295,0,0,1-11.10987-18.09l16.69971-55.49.5-1.65a32.46828,32.46828,0,0,0-15.23-37.51,32.27694,32.27694,0,0,0-47.02,20.54l-21.2998,86.93-.79,3.22a43.43889,43.43889,0,0,0,38.16992,53.6c.06982.01.12988.01.20019.02l12.75,1.13,16.53955,1.47,20.8003,1.85,19.41015,1.73a10.17352,10.17352,0,0,0,10.94-8.38c.02978-.14.0498-.28.06982-.42l4.12012-30.76.04-.28A10.17007,10.17007,0,0,0,494.67821,543.685Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M442.27994,310.61657c-13.57683,26.69293-24.277,54.22413-54.22412,54.22413a54.22413,54.22413,0,0,1-54.22413-54.22413c0-29.94715,24.27906-53.84919,54.22413-54.22412C418.4907,256.01137,467.55,260.933,442.27994,310.61657Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#2f2e41"
        />
        <path
            d="M476.33836,659.815l-1.23047-12.28-.91992.05L312.498,655.375l.41992,12.43.71045,21.29a308.81037,308.81037,0,0,0,82.38965,44.85l1.05029-8.14a2.90385,2.90385,0,0,1,5.67969-.36l3.18994,11.89a305.31881,305.31881,0,0,0,79.59033,14.41Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#2f2e41"
        />
        <circle
            cx="390.72433"
            cy="318.33238"
            r="47.5643"
            transform="translate(-353.00655 221.60621) rotate(-45)"
            fill="#a0616a"
        />
        <path
            d="M485.6284,648.365l-9.43017-29.28-.16016-.5-.48-1.5-2.68994-8.34c-.87012-2.71-1.7002-5.43-2.47022-8.16q-1.06494-3.69-1.98974-7.4-1.31984-5.16-2.3999-10.36a256.72524,256.72524,0,0,1-4.87012-35.33q-.33033-4.935-.47022-9.88995a255.64018,255.64018,0,0,1,5.43018-60.31,81.78628,81.78628,0,0,0-40.33984-88.57,80.416,80.416,0,0,0-32.64014-9.79c-.79-.06-1.58008-.11-2.37988-.16a80.96226,80.96226,0,0,0-64.94,26.26,82.57424,82.57424,0,0,0-11.32031,15.68,81.446,81.446,0,0,0-9.31982,51.69l11.23974,75.47-2.55957,31.77-3.02,37.44-.16015,2-3.22022,39.92a8.69417,8.69417,0,0,0,5.48,8.8,8.50982,8.50982,0,0,0,3.2002.61005c.16015,0,.31006,0,.47021-.01l159.75-8.59,1.46-.08a8.70416,8.70416,0,0,0,7.83008-11.37Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M441.1975,291.45155a64.691,64.691,0,0,1-36.97056,11.42551,39.64324,39.64324,0,0,0,15.71262,6.4643,130.44529,130.44529,0,0,1-53.28286.29939,34.48533,34.48533,0,0,1-11.15425-3.831c-3.37787-2.05046-6.20359-5.31552-6.88493-9.20785-1.169-6.67831,4.03481-12.74571,9.44275-16.8348a69.6535,69.6535,0,0,1,58.532-11.69631c6.5384,1.6901,13.08839,4.54566,17.33526,9.79648s5.50486,13.34591,1.45867,18.75289Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#2f2e41"
        />
        <path
            d="M443.62927,593.57759a22.78777,22.78777,0,0,1-31.39874-15.33241l-80.644-7.36881,26.26738-32.87663,72.55386,12.03789a22.91125,22.91125,0,0,1,13.22153,43.54Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#a0616a"
        />
        <path
            d="M398.96825,534.745l-18.23-2.85-18.39014-2.88a14.211,14.211,0,0,1-11.5-17.84l15.96-57.5a32.4688,32.4688,0,0,0-16.04-37.17005,31.98313,31.98313,0,0,0-28.60986-.75,32.07774,32.07774,0,0,0-17.9502,22.29l-20.12988,90.61a43.46415,43.46415,0,0,0,39.51025,52.78l69.62989,4.67A10.18509,10.18509,0,0,0,403.978,577.495c.03028-.13995.04-.28.06006-.42l3.4502-30.84.02978-.28A10.17894,10.17894,0,0,0,398.96825,534.745Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M707.44512,486.94456l-4.173,2.27685L651.8605,517.27273l-4.173,2.27685a8.71537,8.71537,0,0,0-3.47236,11.8117l38.28506,70.16778a8.71535,8.71535,0,0,0,11.81168,3.47238l.01078-.00588,59.736-32.59327.01078-.00588a8.71535,8.71535,0,0,0,3.47237-11.81168L719.2568,490.417A8.71535,8.71535,0,0,0,707.44512,486.94456Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M708.64555,489.14449l-4.94258,2.69678L653.8304,519.05283l-4.9425,2.69673a6.2064,6.2064,0,0,0-2.47276,8.41138l38.28506,70.16778a6.20638,6.20638,0,0,0,8.41137,2.47274l.01078-.00588,59.736-32.59326.01085-.00593a6.20637,6.20637,0,0,0,2.4727-8.41132l-38.28507-70.16778A6.20638,6.20638,0,0,0,708.64555,489.14449Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#fff"
        />
        <path
            d="M710.04832,508.955a1.45948,1.45948,0,0,0-1.97021-.58l-1.98975,1.09-20.29,11.07a1.45206,1.45206,0,0,0,1.38965,2.55l22.28028-12.16A1.45963,1.45963,0,0,0,710.04832,508.955Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M717.63817,510.385a1.43548,1.43548,0,0,0-1.96-.57l-27.53028,15.02a1.44776,1.44776,0,1,0,1.39014,2.54l1.28027-.69995,8.00977-4.37006h.01025l18.21973-9.95A1.43939,1.43939,0,0,0,717.63817,510.385Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M687.71825,534.325l-8.74024-16.03a.70192.70192,0,0,0-.94971-.27l-4.24023,2.31-2.19971,1.2-11.81006,6.44-2.29,1.25a.70222.70222,0,0,0-.27.95l.56,1.03,8.17969,15a.69309.69309,0,0,0,.93994.27l14.1001-7.69,2.2002-1.2,4.23974-2.31A.69677.69677,0,0,0,687.71825,534.325Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M721.09813,529.295a1.44744,1.44744,0,0,0-1.96-.58L688.918,545.205a1.44975,1.44975,0,0,0-.73,1.53,1.21141,1.21141,0,0,0,.15039.44,1.47285,1.47285,0,0,0,.29.37l.00977.01a1.462,1.462,0,0,0,1.66992.2l30.22021-16.49A1.44715,1.44715,0,0,0,721.09813,529.295Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <path
            d="M728.69823,530.725a1.44981,1.44981,0,0,0-1.97022-.57l-35.46972,19.35a1.41479,1.41479,0,0,0-.73,1.51v.01a1.20984,1.20984,0,0,0,.14991.44,1.39909,1.39909,0,0,0,.2998.38,1.42971,1.42971,0,0,0,1.66992.2l35.47022-19.35A1.45655,1.45655,0,0,0,728.69823,530.725Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#e6e6e6"
        />
        <circle cx="436.4441" cy="407.19056" r="6.15041" fill="#e6e6e6" />
        <path
            d="M725.44512,459.94456l-4.173,2.27685L669.8605,490.27273l-4.173,2.27685a8.71537,8.71537,0,0,0-3.47236,11.8117l38.28506,70.16778a8.71535,8.71535,0,0,0,11.81168,3.47238l.01078-.00588,59.736-32.59327.01078-.00588a8.71535,8.71535,0,0,0,3.47237-11.81168L737.2568,463.417A8.71535,8.71535,0,0,0,725.44512,459.94456Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M726.64555,462.14449l-4.94258,2.69678L671.8304,492.05283l-4.9425,2.69673a6.2064,6.2064,0,0,0-2.47276,8.41138l38.28506,70.16778a6.20638,6.20638,0,0,0,8.41137,2.47274l.01078-.00588,59.736-32.59326.01085-.00593a6.20637,6.20637,0,0,0,2.4727-8.41132l-38.28507-70.16778A6.20638,6.20638,0,0,0,726.64555,462.14449Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#fff"
        />
        <path
            d="M728.04832,481.955a1.45948,1.45948,0,0,0-1.97021-.58l-10.25977,5.6-2.86035,1.56-9.15967,5a1.45206,1.45206,0,0,0,1.38965,2.55l10.8003-5.89,2.25976-1.24,9.22022-5.03A1.45963,1.45963,0,0,0,728.04832,481.955Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M735.63817,483.385a1.43548,1.43548,0,0,0-1.96-.57l-14.31006,7.81-2.2002,1.2-11.02,6.01a1.44776,1.44776,0,1,0,1.39014,2.54l11.02-6.01,2.2002-1.2,14.2998-7.81A1.43939,1.43939,0,0,0,735.63817,483.385Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M705.71825,507.325l-6.97022-12.78-1.19971-2.2-.57031-1.05a.70192.70192,0,0,0-.94971-.27l-14.1499,7.72-6.39013,3.48005a.70222.70222,0,0,0-.27.95l.56982,1.04.62012,1.15.58008,1.05v.01l6.96972,12.78a.69309.69309,0,0,0,.93994.27l20.54-11.2A.69677.69677,0,0,0,705.71825,507.325Z"
            transform="translate(-242.35207 -147.91501)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M739.09813,502.295a1.44744,1.44744,0,0,0-1.96-.58l-9.03028,4.93-2.1997,1.2-8.72022,4.75-10.27,5.61a1.45214,1.45214,0,0,0,1.39014,2.55l18.99023-10.36,2.19971-1.2,9.03027-4.93A1.44715,1.44715,0,0,0,739.09813,502.295Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <path
            d="M746.69823,503.725a1.44981,1.44981,0,0,0-1.97022-.57l-14.27,7.79-2.1997,1.2-19,10.36a1.44766,1.44766,0,1,0,1.38964,2.54l18.99024-10.36,2.20019-1.2,14.27979-7.79A1.45655,1.45655,0,0,0,746.69823,503.725Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ccc"
        />
        <circle cx="454.4441" cy="380.19056" r="6.15041" fill="#ccc" />
        <path
            d="M700.92771,562.68332a19.79115,19.79115,0,0,1,3.06756.54874l69.75009-61.87614-4.5103-22.19787,32.61085-11.18542,11.80356,38.521a15.04079,15.04079,0,0,1-6.12594,16.97964l-88.67413,58.2191a19.73558,19.73558,0,1,1-17.92169-19.009Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#ffb8b8"
        />
        <path
            d="M821.75829,473.515,801.998,435.775a23.47654,23.47654,0,0,0-29.21973-14.54c-.22021.06-.43017.13-.6499.21a23.52681,23.52681,0,0,0-14.46045,29.93l7.93018,41.71a8.44646,8.44646,0,0,0,4.08008,5.74,8.25123,8.25123,0,0,0,3.77978,1.12,8.13863,8.13863,0,0,0,3.23-.45l4.24024-1.48,27.21972-9.48,8.90039-3.1a8.47065,8.47065,0,0,0,4.71-11.92Z"
            transform="translate(-242.35207 -147.91501)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M896.35207,619.085h-653a1,1,0,0,1,0-2h653a1,1,0,0,1,0,2Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#3f3d56"
        />
        <path
            d="M355.84813,600.585v.5a17.5147,17.5147,0,0,0,10.43017,16,17.23214,17.23214,0,0,0,7.06983,1.5h161.5v-18Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#3f3d56"
        />
        <path
            d="M647.60789,481.955a32.59279,32.59279,0,0,0-11.41992-13.02,31.97294,31.97294,0,0,0-7.1499-3.54,32.37532,32.37532,0,0,0-10.68994-1.81h-155a32.53759,32.53759,0,0,0-32.5,32.5v90a31.37346,31.37346,0,0,0,.22021,3.78,32.78466,32.78466,0,0,0,1.13965,5.54,31.94021,31.94021,0,0,0,2.06006,5.18,32.46476,32.46476,0,0,0,29.08008,18h155a32.48771,32.48771,0,0,0,32.5-32.5v-90A32.22154,32.22154,0,0,0,647.60789,481.955Z"
            transform="translate(-242.35207 -147.91501)"
            fill="#3f3d56"
        />
        <circle cx="306.99606" cy="393.16998" r="8" fill="#fff" />
    </svg>
);

export const TimeManagementSketch = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        width={props.width || 675.67004}
        height={props.height || 631.94692}
        viewBox="0 0 675.67004 631.94692">
        <path
            d="M886.75657,617.4844l30.31095,4.737a98.98541,98.98541,0,0,0,20.60431-42.93875c-22.16391,18.14266-55.86923,8.5016-82.74464,18.40656A59.5399,59.5399,0,0,0,819.307,635.03277L804.49369,650.9701A99.77016,99.77016,0,0,0,887.905,646.378a96.3717,96.3717,0,0,0,19.64-14.09929C896.93923,625.60042,886.75657,617.4844,886.75657,617.4844Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#f2f2f2"
        />
        <path
            d="M875.99631,569.00709l29.24218-9.2783a98.98538,98.98538,0,0,0-.70813-47.62114c-11.74636,26.12313-46.21379,32.5259-65.851,53.37718a59.53993,59.53993,0,0,0-15.227,49.31l-6.15081,20.871a99.77014,99.77014,0,0,0,72.60872-41.31,96.37253,96.37253,0,0,0,11.29063-21.37854C888.72981,571.73,875.99631,569.00709,875.99631,569.00709Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#f2f2f2"
        />
        <path
            d="M937.835,660.62474a1.18647,1.18647,0,0,1-1.19006,1.19H263.355a1.19,1.19,0,0,1,0-2.38h673.29A1.18651,1.18651,0,0,1,937.835,660.62474Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#ccc"
        />
        <circle cx="278.99773" cy="260.8659" r="215" fill="#e6e6e6" />
        <path
            d="M726.16271,394.89244a184.74377,184.74377,0,0,1-74.67,148.51c-1.55,1.16-3.13,2.29-4.72,3.39a185.03127,185.03127,0,0,1-211.22,0c-1.59-1.1-3.17-2.23-4.72-3.39a185.01966,185.01966,0,0,1,0-297.02c1.55-1.16,3.13-2.29,4.72-3.39a185.0315,185.0315,0,0,1,211.22,0c1.59,1.1,3.17,2.23,4.72,3.39A184.74369,184.74369,0,0,1,726.16271,394.89244Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <circle cx="278.99773" cy="260.8659" r="169" fill={props.color || '#0070ce'} />
        <path
            d="M541.60362,226.36486c-2.562,0-5.10815.067-7.64221.1798a168.99467,168.99467,0,0,1-7.15649,337.168c4.87781.42328,9.81116.65223,14.7987.65223a169,169,0,0,0,0-338Z"
            transform="translate(-262.16498 -134.02654)"
            opacity="0.2"
        />
        <path
            d="M541.66271,213.89244a5.50968,5.50968,0,0,0-5.5,5.5v24a5.5,5.5,0,0,0,11,0v-24A5.50968,5.50968,0,0,0,541.66271,213.89244Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M651.49272,246.38243c-1.55-1.16-3.13-2.29-4.72-3.39a5.49662,5.49662,0,0,0-4.9,2.39l-13.51,19.83a5.49872,5.49872,0,0,0,9.09,6.19l13.51-19.83A5.4644,5.4644,0,0,0,651.49272,246.38243Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M712.87273,336.80242a5.4929,5.4929,0,0,0-7.16-3.02l-22.24,9.03a5.49945,5.49945,0,0,0,4.14,10.19l22.24-9.03A5.51241,5.51241,0,0,0,712.87273,336.80242Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M453.96269,265.21245l-13.51-19.83a5.49661,5.49661,0,0,0-4.9-2.39c-1.59,1.1-3.17,2.23-4.72,3.39a5.46442,5.46442,0,0,0,.53,5.19l13.51,19.83a5.49872,5.49872,0,0,0,9.09-6.19Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M398.85271,342.81243l-22.24-9.03a5.49942,5.49942,0,0,0-4.14,10.18994l22.24,9.03a5.49945,5.49945,0,0,0,4.14-10.19Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M541.66271,540.89244a5.50968,5.50968,0,0,0-5.5,5.5v24a5.5,5.5,0,0,0,11,0v-24A5.50968,5.50968,0,0,0,541.66271,540.89244Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M650.96269,538.21245l-13.51-19.83a5.49872,5.49872,0,1,0-9.09,6.19l13.51,19.83a5.49657,5.49657,0,0,0,4.9,2.39c1.59-1.1,3.17-2.23,4.72-3.39A5.46436,5.46436,0,0,0,650.96269,538.21245Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M709.85271,445.81243l-22.24-9.03a5.49942,5.49942,0,0,0-4.14,10.18994l22.24,9.03a5.49945,5.49945,0,0,0,4.14-10.19Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M452.51268,516.93242a5.5,5.5,0,0,0-7.63995,1.45l-13.51,19.83a5.46439,5.46439,0,0,0-.53,5.19c1.55,1.16,3.13,2.29,4.72,3.39a5.49656,5.49656,0,0,0,4.9-2.39l13.51-19.83A5.49838,5.49838,0,0,0,452.51268,516.93242Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M401.87273,439.80242a5.4929,5.4929,0,0,0-7.16-3.02l-22.24,9.03a5.49945,5.49945,0,0,0,4.14,10.19l22.24-9.03A5.51241,5.51241,0,0,0,401.87273,439.80242Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#fff"
        />
        <path
            d="M548.79894,392.16338a11.5131,11.5131,0,0,1-9.40873,13.26558l-97.59815,16.60128a11.5,11.5,0,0,1-3.85686-22.67432l97.59815-16.60127A11.5131,11.5131,0,0,1,548.79894,392.16338Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#3f3d56"
        />
        <path
            d="M651.51837,500.29429a7.5082,7.5082,0,0,1-10.60652.04177l-105.063-104.23895a7.5,7.5,0,0,1,10.56475-10.64828l105.063,104.23895A7.50819,7.50819,0,0,1,651.51837,500.29429Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#3f3d56"
        />
        <circle cx="278.99773" cy="260.8659" r="13" fill="#ccc" />
        <path
            d="M451.61885,169.47127c-19.95483,31.3725-50.40146,52.19272-87.94977,65.87042a7.05892,7.05892,0,0,1-9.88158-1.41838l0,0c-20.3959-27.23248-15.79051-66.15312,11.1278-86.96189a62.06846,62.06846,0,0,1,87.55785,11.87509l.56413.75322A7.05892,7.05892,0,0,1,451.61885,169.47127Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#e6e6e6"
        />
        <path
            d="M629.85228,158.83648a62.06846,62.06846,0,0,1,87.55785-11.87509c26.91832,20.80877,31.52371,59.72941,11.1278,86.96189l0,0a7.05889,7.05889,0,0,1-9.88155,1.41838c-34.8573-13.34536-63.4422-36.43945-87.94983-65.87042a7.059,7.059,0,0,1-1.41838-9.88157Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#e6e6e6"
        />
        <path
            d="M621.10592,581.16067a5.50968,5.50968,0,0,0-2.11376,7.48546l31.74188,56.7226a5.5,5.5,0,0,0,9.59921-5.3717l-31.74188-56.7226A5.50968,5.50968,0,0,0,621.10592,581.16067Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#e6e6e6"
        />
        <path
            d="M453.734,583.27443,421.99216,639.997a5.5,5.5,0,0,0,9.59921,5.3717l31.74188-56.7226a5.5,5.5,0,1,0-9.59921-5.3717Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#e6e6e6"
        />
        <circle cx="394.99773" cy="508.8659" r="17" fill="#e6e6e6" />
        <circle cx="406.99773" cy="73.8659" r="17" fill="#e6e6e6" />
        <circle cx="277.99773" cy="33.8659" r="17" fill="#e6e6e6" />
        <circle cx="154.99773" cy="71.8659" r="17" fill="#e6e6e6" />
        <circle cx="165.99773" cy="508.8659" r="17" fill="#e6e6e6" />
        <path
            d="M643.82785,490.73326a8.51615,8.51615,0,0,0,12.95041,1.67682l26.67551,14.29343-1.43061-15.66135L656.911,479.86993a8.56232,8.56232,0,0,0-13.08312,10.86333Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#ffb7b7"
        />
        <path
            d="M663.26422,496.199l10.45348-14.42967,50.35989,23.80654,62.667-11.75832a21.47122,21.47122,0,0,1,25.43021,21.06258h0a21.49411,21.49411,0,0,1-21.43119,21.51043l-71.81625.13324Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#3f3d56"
        />
        <polygon
            points="384.999 611.399 374.422 606.341 388.951 562.133 404.56 569.599 384.999 611.399"
            fill="#ffb7b7"
        />
        <path
            d="M718.07,738.29872c-.7691.48175-1.5382.95554-2.31507,1.42951-1.546.94777-3.10749,1.88-4.669,2.79663-.78465.45843-1.57707.91685-2.36172,1.3675v.02314l-.04661.00777-.01551.00778-1.19641.29531-1.71686-4.537-.79243-2.08974-1.1187-2.95994-2.051-5.41478-10.79851-28.51121,16.78822-4.1408.62926,2.5715h.00778l.31072,1.274,5.86543,23.788,1.19637,4.86323.03883.14756.72249,2.9055.62153,2.51706.69139,2.81238Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#ffb7b7"
        />
        <path
            d="M818.21837,638.17372c-1.06431,1.70913-2.152,3.41049-3.24732,5.09629q-3.05317,4.70782-6.26938,9.27587c0,.00777-.00777.00777-.01555.01555a21.93387,21.93387,0,0,1-4.11742,3.0065c-.06216.04661-.13205.07767-.19422.1165a15.17964,15.17964,0,0,1-3.46487,1.39063c-.435.10873-.87787.2175-1.31292.32628-1.56925.37288-3.123.69142-4.669.97109-2.75012.48943-5.46917.839-8.17268,1.05653-.21754.02333-.435.03884-.65259.05439-11.117.81571-21.93889-.49721-33.23461-2.64912-5.578-1.05658-11.27244-2.32289-17.16893-3.6358-1.92663-.43505-3.861-.86232-5.81877-1.28959-.14761-.03106-.303-.06994-.45838-.101-2.79673-.61371-5.64006-1.2197-8.55334-1.81791-3.66686-.75354-7.45023-1.4838-11.38121-2.17523l.27967,5.53911a41.68909,41.68909,0,0,0,2.62583,12.4533c1.67807,4.90985,3.0065,8.79421.202,16.88144l-1.35176,3.91543a13.37221,13.37221,0,0,1-1.37508,11.83181l-.27188.41172,11.27243,28.519.73027,1.849h-5.77221l-7.10059.00778H696.69209l-17.36314-34.835-.83126-1.66252v-.08544l1.79457-66.94316c.02333-.59043.06994-1.18864.14761-1.77907a20.35271,20.35271,0,0,1,7.74545-13.704,19.60027,19.60027,0,0,1,14.59743-3.99314l5.9431.7691,12.14253,1.5693,8.55334,1.11092.17094.02328,25.22505,3.26288,1.81013-7.3803.33405-.12428,10.61989-3.89214,36.73054-13.46323.09322-.03105,2.41607-.88565.28744.46611c.08549.13987.17093.27971.2486.41954a71.99912,71.99912,0,0,1,5.80327,13.471,211.47728,211.47728,0,0,1,6.09844,23.28292q.10489.51275.18644.93226l.02333.08544c.02328.13206.03883.2175.04661.24083C820.36255,629.60479,819.77212,633.9087,818.21837,638.17372Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#2f2e41"
        />
        <path
            d="M819.76865,613.50321c-.11655-.49721-.26415-1.00215-.41949-1.49159a106.28979,106.28979,0,0,0-4.30386-10.89178c-1.83341-4.03975-4.032-8.36694-6.65-13.05146q-1.89946-3.40275-4.08637-7.0773-1.09539-1.84121-2.27623-3.75231a1.972,1.972,0,0,0-.101-.17089l-.22527-.37289-36.34216,4.86324-13.53311,1.81013-.80794,6.74325-.19421,1.6703c-.00778,0-.00778,0,0,.00777l-.54383,4.55247v.00778l-.72248,6.013-.06216-.00778-20.08216-2.60251-20.69591-2.68022-11.11706-1.43719a19.58836,19.58836,0,0,0-14.59743,3.99314,20.3629,20.3629,0,0,0-7.7454,13.704c-.06994.54382-.11655,1.10315-.13988,1.65475l-10.48779,24.85216a160.34347,160.34347,0,0,0-11.8551,46.64346l-7.69106,24.58806,1.09537.101,16.29879,1.51492,4.30386.404,9.47786-13.83611c1.07987-1.57707,2.10534-3.20071,3.06088-4.86323a73.86106,73.86106,0,0,0,4.18736-8.42133l20.5017-48.78763q2.37727.408,4.70785.77687,10.77918,1.748,20.69591,2.85112c21.49607,2.40055,40.11,2.587,56.68069.55159q6.98021-.85065,13.49429-2.2374,2.38894-.50113,4.71562-1.07986c.36511-.08545.72249-.17089,1.07987-.26416a19.82527,19.82527,0,0,0,13.86717-12.95824A20.22821,20.22821,0,0,0,819.76865,613.50321Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#2f2e41"
        />
        <path
            d="M650.54238,738.20692l-11.44332-5.48473-1.79458-.86231-2.86666,7.03847-20.01227,4.4049a4.74845,4.74845,0,0,0-.77687,9.035l19.55389,7.97851,6.20721-5.58572-1.52269,7.49684,7.36474,3.0065,8.07168-25.69121Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#2f2e41"
        />
        <polygon points="458.703 593.34 459.434 595.189 458.703 595.189 458.703 593.34" fill="#2f2e41" />
        <path
            d="M716.883,729.6106,704.89244,733.765l-1.88192.65,2.91542,7.01841-11.12085,17.21106a4.74844,4.74844,0,0,0,5.80521,6.9667l19.50836-8.08917.48047-8.3366,4.193,6.39847,7.34864-3.04564-12.34131-23.93495Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#2f2e41"
        />
        <path
            d="M816.77843,624.75865a4.40445,4.40445,0,0,1-2.043-.50683l-63.27441-33.0625-.731-2.99317-1.37793-9.47168.019-.08886,6.01758-27.74317c-.11035-.23828-.34082-.6289-.60107-1.07031-2.68653-4.55176-10.86231-18.40527,4.74121-37.48047l27.3955-31.93945,23.5127-1.01172.26758.33789A61.242,61.242,0,0,1,821.11485,536.617l-2.44824,44.2168,2.626,8.92969a24.6393,24.6393,0,0,1-.72168,15.94433l.602,14.459a4.41745,4.41745,0,0,1-4.39453,4.59179Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#3f3d56"
        />
        <path
            d="M761.89233,661.22445a8.5162,8.5162,0,0,0,2.12627-12.88426L779.23125,622.178l-15.70163.885-12.039,24.70838a8.56232,8.56232,0,0,0,10.40167,13.45308Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#ffb7b7"
        />
        <path
            d="M768.03088,641.99l-14.05733-10.94906,25.54384-49.50134L769.946,518.50143a21.47121,21.47121,0,0,1,21.9344-24.68218h0a21.49411,21.49411,0,0,1,20.752,22.16643l-2.36488,71.77743Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#3f3d56"
        />
        <path
            id="f4e08e8b-ef08-4d70-8ad3-b81af8a71ff9-482"
            data-name="a1ca5f83-7fa1-45b1-9d3b-bf096f25c0e5"
            d="M771.84232,467.13077V443.864a31.177,31.177,0,1,1,62.35408-.04005v.04005c5.49493,11.45055,2.05727,16.8945,0,23.2668a4.19307,4.19307,0,0,1-4.18608,4.18608H776.03048A4.1931,4.1931,0,0,1,771.84232,467.13077Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#2f2e41"
        />
        <circle cx="530.63215" cy="312.44125" r="23.33714" fill="#ffb7b7" />
        <path
            d="M817.22046,452.58578c-.21152-.03343-.423-.078-.63455-.11143-3.64026-.64562-7.28046-1.2801-10.90958-1.937l-.334-8.2266-4.39718,7.3694c-10.03015,3.32853-19.41462,1.44724-28.24248-2.70506a79.73731,79.73731,0,0,1-8.46054-4.66434,30.92749,30.92749,0,0,1,15.19553-21.886c.334-.18929.65677-.35617.99079-.52331a.0109.0109,0,0,0,.01107-.01115c.56776-.26716,1.14666-.52318,1.72556-.75691a25.70666,25.70666,0,0,1,26.98453,5.23209C816.27418,431.16737,819.48027,442.39976,817.22046,452.58578Z"
            transform="translate(-262.16498 -134.02654)"
            fill="#2f2e41"
        />
    </svg>
);

export const FaqSketch = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        dataname="Layer 1"
        width={props.width || '844.67538'}
        height={props.height || '595.26155'}
        viewBox="0 0 844.67538 595.26155">
        <circle cx="431.39281" cy="548" r="46" fill={props.color || '#0070ce'} />
        <path
            d="M883.86176,743.78487c25.7345-7.72868,53.09381-15.78786,73.50313-34.161,18.23763-16.41813,30.55024-41.48912,22.99475-66.1115-7.54-24.57187-30.12421-40.95629-53.44165-49.10532-13.225-4.62188-27.06087-7.18608-40.89147-9.20037-15.03485-2.18967-30.13615-3.98373-45.23026-5.71012q-91.67724-10.48563-184.04386-12.811c-30.38456-.76525-60.76358-.74682-91.15243-.3057-27.13937.394-55.72215.38417-80.899-11.15051-19.57846-8.96979-37.348-25.28881-42.8033-46.73352-6.29728-24.75467,5.318-49.96382,21.97993-67.892,8.78265-9.45011,19.04731-17.40385,29.63621-24.71743,11.4874-7.93416,23.37539-15.30643,35.52084-22.18813a494.63414,494.63414,0,0,1,74.7667-34.4685c12.74555-4.63445,25.68047-8.63281,38.72759-12.32143,11.017-3.11469,22.06832-6.23382,32.71588-10.47748,20.58349-8.20371,40.161-22.09985,45.39464-44.88142,4.96024-21.59145-3.40305-45.03067-18.065-61.07057-16.96282-18.557-42.53949-26.69181-67.06007-28.008-27.52842-1.47765-54.42246,5.412-80.29678,14.15585-27.59673,9.326-54.59854,20.04924-82.77827,27.60322a556.95783,556.95783,0,0,1-85.19574,15.83655c-14.08227,1.49951-28.59019,3.19273-42.75626,2.04475-11.87246-.96211-23.68426-4.45375-32.43408-12.87964-7.50252-7.22477-11.97184-17.154-10.4353-27.63238.27909-1.90318,3.17022-1.09407,2.89284.79752-1.8704,12.75513,6.79991,24.50863,17.48415,30.5293,12.34817,6.95832,27.37408,6.9678,41.1218,6.172a537.82528,537.82528,0,0,0,88.51452-12.79561c28.59252-6.53059,56.16382-15.86633,83.70391-25.83908,26.15594-9.47153,52.89665-18.71579,80.84009-20.76729,24.24611-1.78007,49.75165,1.75222,70.87426,14.42313,18.56387,11.136,32.21482,29.70722,36.56451,51.01813,4.25044,20.82462-1.63632,41.785-17.4,56.31714-16.32147,15.04633-38.7007,21.47909-59.55655,27.40368-26.45223,7.51437-52.33726,16.29809-77.39248,27.7031a485.82354,485.82354,0,0,0-72.8001,40.92805c-22.24625,15.20228-44.2007,34.33058-51.23658,61.45126-3.27739,12.63313-2.67227,26.03212,2.8116,37.96461,4.87605,10.60993,12.90656,19.53469,22.26169,26.41853,22.32074,16.42443,50.45266,19.79665,77.41421,20.13212,30.28143.37678,60.56382-.64518,90.85508-.148q92.5988,1.51977,184.81863,11.27265,23.108,2.44594,46.15759,5.40711c13.82158,1.776,27.68967,3.54058,41.27849,6.69464,24.16222,5.60822,47.67389,16.39167,62.69178,36.878a61.31938,61.31938,0,0,1,11.94709,30.44593c1.05134,11.52384-1.76985,23.0693-6.98016,33.32083-11.53233,22.69042-33.13363,37.12286-56.07337,46.60471-12.28683,5.0786-25.03167,8.926-37.7516,12.74609-1.853.55651-2.64487-2.338-.79752-2.89283Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#f2f2f2"
        />
        <circle cx="125.89281" cy="69.5" r="24" fill="#f2f2f2" />
        <circle cx="292.39281" cy="115" r="24" fill="#f2f2f2" />
        <circle cx="433.39281" cy="24" r="24" fill="#f2f2f2" />
        <circle cx="521.39281" cy="126" r="24" fill="#f2f2f2" />
        <circle cx="402.39281" cy="244" r="24" fill="#f2f2f2" />
        <circle cx="251.39281" cy="301" r="24" fill="#f2f2f2" />
        <circle cx="411.39281" cy="390" r="24" fill="#f2f2f2" />
        <circle cx="583.39281" cy="440" r="24" fill="#f2f2f2" />
        <circle cx="784.39281" cy="429" r="24" fill="#f2f2f2" />
        <path
            d="M604.12763,220.37264c-71.89185.50782-130.75611,58.92987-131.77735,130.81635-.00946.66369-.01381,5.33048-.01324,11.43422a33.74778,33.74778,0,0,0,33.74387,33.746h.00007a33.76855,33.76855,0,0,0,33.76114-33.79775c-.00343-4.15211-.00551-7.02584-.00551-7.20227a64.00037,64.00037,0,1,1,98.52027,53.8794l.01171.01422s-48.02832,30.91956-62.67089,73.33545l.01245.003a94.00389,94.00389,0,0,0-3.87354,26.76794c0,3.72538.21916,36.32138.64261,62.77767a34.78649,34.78649,0,0,0,34.79009,34.22233h.00007a34.79588,34.79588,0,0,0,34.79384-35.01061c-.14706-24.22912-.22661-52.44168-.22661-54.48939,0-26.04473,25.12525-51.99475,45.76367-68.91741,23.76587-19.48694,40.86792-46.04291,47.73706-75.99909a86.7618,86.7618,0,0,0,2.49927-18.8335A132.75,132.75,0,0,0,604.12763,220.37264Z"
            transform="translate(-177.66231 -152.36922)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M1021.147,747.63078H178.853a1.19069,1.19069,0,0,1,0-2.38137h842.294a1.19068,1.19068,0,0,1,0,2.38137Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#3f3d56"
        />
        <circle cx="628.44885" cy="242.9959" r="30" fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'} />
        <polygon
            points="573.012 582.129 560.753 582.129 554.92 534.841 573.015 534.841 573.012 582.129"
            fill="#a0616a"
        />
        <path
            d="M551.99554,578.62562h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H537.10868a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,551.99554,578.62562Z"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <polygon
            points="668.012 582.129 655.753 582.129 649.92 534.841 668.015 534.841 668.012 582.129"
            fill="#a0616a"
        />
        <path
            d="M646.99554,578.62562h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H632.10868a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,646.99554,578.62562Z"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <circle cx="623.88979" cy="248.61007" r="24.56103" fill="#a0616a" />
        <path
            d="M816.19123,504.7751l10.98975-25.25a31.38253,31.38253,0,0,0-6.94971-35.6,31.87322,31.87322,0,0,0-3.07031-2.67,30.93522,30.93522,0,0,0-18.98975-6.57,32.179,32.179,0,0,0-13.3999,2.98c-.36035.16-.71.33-1.07031.5-.68994.33-1.36963.69-2.02979,1.06a31.67823,31.67823,0,0,0-15.70019,23.88l-4.8501,40.64c-1.21973,3.19-44.73975,118.39-29.51953,206.34a4.46692,4.46692,0,0,0,3.81982,3.67l15.43018,2.1a4.49661,4.49661,0,0,0,5.00976-3.53l25.89014-123.41a3.50323,3.50323,0,0,1,6.79981-.23l36.58007,129.78a4.47129,4.47129,0,0,0,4.31006,3.28,5.12184,5.12184,0,0,0,.87012-.08l18.84961-3.63a4.471,4.471,0,0,0,3.63037-4.81C850.02131,682.3351,835.3011,527.60512,816.19123,504.7751Z"
            transform="translate(-177.66231 -152.36922)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M706.10166,421.41909A10.05576,10.05576,0,0,0,716.696,432.6225l13.72894,32.99236,10.385-15.3943-14.62937-28.97a10.11027,10.11027,0,0,0-20.07892.16852Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#a0616a"
        />
        <path
            d="M800.19025,537.99553a10.05577,10.05577,0,0,0,8.42651-12.91316l28.88533-21.03846-17.39036-6.51224-24.76387,20.97687a10.11028,10.11028,0,0,0,4.84239,19.487Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#a0616a"
        />
        <path
            d="M753.10188,487.61024a17.05692,17.05692,0,0,1-3.29834-.32519,16.30539,16.30539,0,0,1-11.94751-9.61621l-19.23438-23.45313a4.50075,4.50075,0,0,1,1.11109-6.68066l13.68432-8.4707a4.50007,4.50007,0,0,1,6.21533,1.49023l13.5564,22.334L779.15022,443.702A9.72146,9.72146,0,0,1,790.46,459.26356l-25.91186,23.63672A16.25271,16.25271,0,0,1,753.10188,487.61024Z"
            transform="translate(-177.66231 -152.36922)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M823.252,522.8827c-.03515,0-.07055,0-.10571-.001a4.50783,4.50783,0,0,1-3.31079-1.57031l-12.16626-14.19336a4.49979,4.49979,0,0,1,.92041-6.67286l22.78149-15.1875-20.63842-24.8125a9.721,9.721,0,0,1,14.8872-12.18261l25.0835,24.51269a16.52481,16.52481,0,0,1-3.67529,26.94043l-20.50122,21.75391A4.50742,4.50742,0,0,1,823.252,522.8827Z"
            transform="translate(-177.66231 -152.36922)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M795.30707,470.58358a4.63212,4.63212,0,0,1-.584-.03711,4.46111,4.46111,0,0,1-3.71045-3.06885l-9.14234-28.02929a3.08255,3.08255,0,0,1,1.594-3.72461l.29663-.14014c.269-.12793.5354-.25439.80737-.37549a32.57412,32.57412,0,0,1,13.603-3.023,31.327,31.327,0,0,1,17.16138,5.15674,3.13007,3.13007,0,0,1,.90136,4.29443L799.08393,468.504A4.45513,4.45513,0,0,1,795.30707,470.58358Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#e6e6e6"
        />
        <circle cx="652.1011" cy="219.78616" r="9.81668" fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'} />
        <path
            d="M796.11115,361.36513h0a26,26,0,0,0-26,25.99994v11.00006h13.5293l6.4707-11,1.94141,11h41.05859l-11-11.00006A26,26,0,0,0,796.11115,361.36513Z"
            transform="translate(-177.66231 -152.36922)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M834.80883,365.43121a15.15,15.15,0,0,1,16.48081-10.39558c6.256,1.04586,11.20228,6.07455,14.14944,11.69107s4.30806,11.90252,6.28935,17.92793,4.79124,12.08362,9.79306,15.984,12.67721,4.9584,17.58966.94607a20.11809,20.11809,0,0,1-37.47706,7.18124c-2.59206-4.61172-3.26121-10.01684-4.02988-15.251s-1.7674-10.6498-4.86211-14.94043-8.88772-7.09293-13.80374-5.13859Z"
            transform="translate(-177.66231 -152.36922)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M515.60883,380.40755h0a33.748,33.748,0,0,1-33.74414-33.746c-.00049-6.10376.0039-10.77051.01318-11.4342a131.50724,131.50724,0,0,1,15.35889-59.90875,131.80321,131.80321,0,0,0-25.35889,75.90875c-.00928.66369-.01367,5.33044-.01318,11.4342a33.748,33.748,0,0,0,33.74414,33.746h0A33.77281,33.77281,0,0,0,538.09662,371.817,33.62247,33.62247,0,0,1,515.60883,380.40755Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#3f3d56"
        />
        <path
            d="M606.415,291.47848a64.00385,64.00385,0,0,1,55.65918,89.413,63.9972,63.9972,0,1,0-107.42578-66.98523A63.87073,63.87073,0,0,1,606.415,291.47848Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#3f3d56"
        />
        <path
            d="M616.79682,590.40755h0a34.78682,34.78682,0,0,1-34.79-34.22235c-.42334-26.45629-.64258-59.0523-.64258-62.77765a94.00389,94.00389,0,0,1,3.87354-26.76794l-.01221-.003a95.069,95.069,0,0,1,5.49414-12.70087,110.04745,110.04745,0,0,0-15.49414,28.70087l.01221.003a94.00389,94.00389,0,0,0-3.87354,26.76794c0,3.72535.21924,36.32136.64258,62.77765a34.78682,34.78682,0,0,0,34.79,34.22235h0a34.80287,34.80287,0,0,0,33.40185-25.04846A34.66005,34.66005,0,0,1,616.79682,590.40755Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#3f3d56"
        />
        <polygon
            points="126.541 582.585 138.8 582.584 144.633 535.296 126.538 535.297 126.541 582.585"
            fill="#ffb8b8"
        />
        <path
            d="M301.576,731.45065H340.1067a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H316.46283A14.88686,14.88686,0,0,1,301.576,731.45066v0A0,0,0,0,1,301.576,731.45065Z"
            transform="translate(464.05409 1325.40429) rotate(179.99738)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <polygon points="82.541 582.585 94.8 582.584 100.633 535.296 82.538 535.297 82.541 582.585" fill="#ffb8b8" />
        <path
            d="M257.576,731.45065H296.1067a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H272.46283A14.88686,14.88686,0,0,1,257.576,731.45066v0A0,0,0,0,1,257.576,731.45065Z"
            transform="translate(376.05409 1325.4063) rotate(179.99738)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M270.91659,720.41068l-11.975-.62988a4.6735,4.6735,0,0,1-4.41851-4.967l14.31268-158.46594,65.911,17.78562,6.35023-1.73241L321.23868,712.68583a4.69622,4.69622,0,0,1-4.35816,3.94458l-12.9089.60147a4.67413,4.67413,0,0,1-4.93149-4.79557l2.339-84.19641a1.55813,1.55813,0,0,0-3.0832-.36007L275.739,716.69228a4.64568,4.64568,0,0,1-4.56913,3.7255C271.086,720.41778,271.00154,720.41575,270.91659,720.41068Z"
            transform="translate(-177.66231 -152.36922)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <circle cx="128.74202" cy="249.75879" r="24.56103" fill="#ffb8b8" />
        <path
            d="M265.51193,474.28693l2.70056,58.26748.97625,21.19852a4.64221,4.64221,0,0,0,3.07432,4.17534l63.336,22.94342a4.47742,4.47742,0,0,0,1.59954.28045,4.64358,4.64358,0,0,0,4.66371-4.7881L339.2657,471.5969A36.93044,36.93044,0,0,0,308.522,435.91974c-.61263-.09345-1.23592-.18695-1.8592-.27006a36.24947,36.24947,0,0,0-29.165,9.44122,37.23612,37.23612,0,0,0-11.9859,29.196Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#ccc"
        />
        <path
            d="M365.85452,569.24512a10.06355,10.06355,0,0,1-5.36877-15.22659l-21.478-28.56,18.53424-1.14707,17.55439,27.29693a10.111,10.111,0,0,1-9.24184,17.63673Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#ffb8b8"
        />
        <path
            d="M350.75332,548.85022a4.64437,4.64437,0,0,1-2.54106-2.51848L315.854,469.2374a12.4634,12.4634,0,1,1,22.98438-9.64693l32.3582,77.09534a4.679,4.679,0,0,1-2.50048,6.11822l-14.36542,6.029a4.64165,4.64165,0,0,1-3.57741.01724Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#ccc"
        />
        <path
            d="M298.50776,546.13086,329.587,486.62205a4.87826,4.87826,0,0,1,6.57494-2.06344l45.11152,23.5601a4.87826,4.87826,0,0,1,2.06343,6.57494l-31.07927,59.50881a4.87827,4.87827,0,0,1-6.57494,2.06344L300.5712,552.7058A4.87826,4.87826,0,0,1,298.50776,546.13086Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#3f3d56"
        />
        <path
            d="M319.35062,518.94278a10.06358,10.06358,0,0,0-15.517-4.46026l-29.77845-19.75406-.05061,18.56963L302.2904,529.21a10.111,10.111,0,0,0,17.06022-10.26718Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#ffb8b8"
        />
        <path
            d="M281.7006,523.11883l-24.33677-19.27776a17.16326,17.16326,0,0,1-7.82343-27.13518l22.09715-28.95951a10.096,10.096,0,0,1,17.1296,10.28435l-17.48384,28.6,25.694,12.18686a4.67363,4.67363,0,0,1,1.94814,6.71958l-10.37175,16.41406a4.682,4.682,0,0,1-3.16671,2.1111c-.02565.00448-.05149.00846-.0773.0123A4.69555,4.69555,0,0,1,281.7006,523.11883Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#ccc"
        />
        <path
            d="M287.84537,418.57447a2.13479,2.13479,0,0,1,1.85636-2.81905,4.93046,4.93046,0,0,1,3.4761,1.71495,13.8334,13.8334,0,0,0,3.07115,2.63711c1.18812.59889,2.79953.51354,3.47685-.62824.63605-1.07221.20023-2.508-.18482-3.75347a36.90711,36.90711,0,0,1-1.62991-9.77c-.11092-3.70032.41115-7.562,2.45972-10.44807,2.64387-3.72475,7.37142-5.13883,11.84544-5.0363s8.87547,1.48362,13.30713,2.35665c1.52992.30139,3.32826.4555,4.35153-.73025,1.08805-1.26082.68844-3.3014.22563-5.00376-1.20094-4.41743-2.475-8.98461-5.26525-12.55224a18.89839,18.89839,0,0,0-12.06081-6.79014,28.93848,28.93848,0,0,0-13.46236,1.52838,36.09628,36.09628,0,0,0-17.68285,12.3186,29.23592,29.23592,0,0,0-5.57809,21.60019,26.66712,26.66712,0,0,0,9.88579,16.85462Z"
            transform="translate(-177.66231 -152.36922)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M598.92043,735.14922a45.99375,45.99375,0,0,1-17.07033-71.4888,45.99715,45.99715,0,1,0,62.56892,66.464A45.96919,45.96919,0,0,1,598.92043,735.14922Z"
            transform="translate(-177.66231 -152.36922)"
            fill="#3f3d56"
        />
    </svg>
);

export const ContactUsSketch = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        dataname="Layer 1"
        width={props.width || '894.24907'}
        height={props.height || '448.2822'}
        viewBox="0 0 894.24907 448.2822">
        <path
            d="M447.36954,674.1411q-40.47485,0-80.82885-1.44922c-38.44043-1.38086-78.18993-2.80762-115.13556-23.29883-25.84506-14.333-48.73487-37.3291-66.19418-66.50391a223.77042,223.77042,0,0,1-25.36927-63.60449,261.47594,261.47594,0,0,1,.95286-123.77929,219.83406,219.83406,0,0,1,14.7411-40.40039c26.94295-55.79346,76.08491-93.2461,134.82585-102.75391a6.80653,6.80653,0,0,1,1.463-.03125c.26419.01416.52753.0293.796.01807l.3456-.10987a16.88152,16.88152,0,0,1,2.72076-.69824c90.59405-13.48682,186.365,13.80176,276.95228,78.91357,70.04208,50.35108,162.86753,77.46436,283.78131,82.88916l1.71659.08985c33.6596,1.93359,66.21835,15.81054,94.16038,40.13281,27.57946,24.00586,48.28706,56.03418,59.88378,92.624,1.42568,4.46094,2.73262,9.1045,3.88437,13.80079a26.0388,26.0388,0,0,1-6.941,24.69042v.00879l-.30109.30957c-.72471.72071-1.48759,1.41211-2.26743,2.05567l-.91682.75586c-7.72718,6.36523-13.83023,11.39355-21.13462,15.29883a64.98321,64.98321,0,0,1-15.41875,5.82128c-29.46525,7.1836-59.38763,13.84375-88.936,19.79688-57.3848,11.57031-116.28137,21.11523-175.05411,28.36816A2269.14089,2269.14089,0,0,1,447.36954,674.1411Zm-136.232-419.84522a3.50685,3.50685,0,0,0-.5394.03662c-58.19178,9.41895-106.86855,46.50391-133.54434,101.74512a217.62434,217.62434,0,0,0-14.59523,40,259.18846,259.18846,0,0,0-.941,122.68067,221.62191,221.62191,0,0,0,25.12332,62.99609c17.28842,28.88867,39.94414,51.6543,65.51823,65.83594,36.614,20.30761,76.17609,21.72851,114.43587,23.10156a2266.31375,2266.31375,0,0,0,358.31544-15.59473c58.73458-7.249,117.593-16.78711,174.94-28.35058,29.52843-5.94825,59.43-12.60352,88.87535-19.78321a63.35819,63.35819,0,0,0,15.04728-5.67871c7.15725-3.82617,13.20219-8.80664,20.85517-15.11133l.91681-.75488c.67044-.55371,1.32858-1.14551,1.9583-1.76074l.18065-.18945c6.2892-6.33887,8.73475-14.70215,6.70987-22.94434v-.001c-1.13944-4.64648-2.4324-9.24023-3.84366-13.65527-23.69-74.74609-84.97359-127.56934-152.49635-131.44727l-1.70726-.08984c-55.23185-2.47851-103.56386-9.34375-147.75156-20.99023-52.74984-13.90235-98.80127-34.83008-136.87574-62.20069-90.24209-64.8623-185.61273-92.04931-275.81114-78.62646a15.47307,15.47307,0,0,0-2.47862.64258l-.62294.17431a9.37442,9.37442,0,0,1-1.06184-.01269C311.53655,254.30663,311.3347,254.29588,311.13751,254.29588Z"
            transform="translate(-152.87546 -225.8589)"
            fill="#f0f0f0"
        />
        <path
            d="M432.2022,371.9146c-2.498-2.39659-5.05306-15.76155-8.24216-17.11834,2.38389,5.2686.65305,6.66348.64035,12.44567a39.12306,39.12306,0,0,1-1.14125,9.74477H369.435V334.82486a28.84672,28.84672,0,0,1,28.84757-28.84758,17.21385,17.21385,0,0,1,4.27584.626A27.42847,27.42847,0,0,1,421.909,326.0071C426.02756,341.06071,432.57759,366.11854,432.2022,371.9146Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M372.605,423.78163l.02663-32.86268L353.314,392.64521l6.81759,20.7264-3.19073,52.09644a8.17282,8.17282,0,1,0,9.88987,6.88859Z"
            transform="translate(-152.87546 -225.8589)"
            fill="#ffb6b6"
        />
        <polygon points="257.746 432.76 265.55 432.759 269.263 402.657 257.744 402.657 257.746 432.76" fill="#ffb6b6" />
        <path
            d="M407.97822,654.76874l12.33707-.73635v5.28573l11.7292,8.10061a3.30167,3.30167,0,0,1-1.87612,6.01864H415.48062L412.949,668.209l-.98849,5.2284h-5.53786Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <polygon points="212.62 432.76 220.425 432.759 224.137 402.657 212.619 402.657 212.62 432.76" fill="#ffb6b6" />
        <path
            d="M362.85281,654.76874l12.33707-.73635v5.28573l11.72919,8.10061a3.30167,3.30167,0,0,1-1.87612,6.01864H370.35521l-2.53166-5.2284-.98848,5.2284H361.2972Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M403.67163,355.43027l-16.16732.317-11.41223,12.04624-9.14932,1.3419a18.2656,18.2656,0,0,0-15.57717,16.89718v0l1.585,8.70644h9.51019l5.50164,32.30284c-2.13925,5.4511-2.28468,9.75391,2.10651,11.444l13.63127,25.67751L423.96,446.09408c2.04173-3.51013,2.696-7.03574.609-10.46423l2.87806-49.45h9.67743v0c0-9.24869-3.12837-17.04569-12.31963-18.07484a108.65383,108.65383,0,0,0-10.98908-.62852Z"
            transform="translate(-152.87546 -225.8589)"
            fill="#e6e6e6"
        />
        <path
            d="M423.96,446.09408s-39.30879,6.97414-53.89108-7.60815c0,0-1.48046,2.51333-3.71127,6.68153-.64153,1.19868-1.88058,2.0107-2.62886,3.46267-.68006,1.31961-2.4292,2.94192-3.17006,4.43857-.596,1.204.36014,2.77744-.26,4.07817-7.46789,15.66368-16.19278,37.75861-14.32228,52.34848,1.20624,9.40867,3.69764,31.30177,6.32152,54.81615.205,1.83719-1.45549,4.19725-1.24942,6.04906.19432,1.74621,2.25519,2.98365,2.44951,4.73391.129,1.16211-1.31017,2.34755-1.18148,3.50826.14118,1.27343,1.8502,2.52186,1.99063,3.79039,3.59444,32.46814,6.88554,62.78094,6.88554,62.78094h18.38637l3.46913-69.2317-2.83512-25.23619,6.65714-51.038,9.19318,48.502,1.18261,27.29716,9.71542,70.9748H423.96v-68.708l1.268-3.56944-1.268-4.57787,1.268-4.93232-1.268-5.37164Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <path
            d="M408.634,346.05478a18.326,18.326,0,1,1,3.17509-15.31446c.05272.21964.09718.43807.14038.66481A18.301,18.301,0,0,1,408.634,346.05478Z"
            transform="translate(-152.87546 -225.8589)"
            fill="#ffb6b6"
        />
        <path
            d="M404.81288,335.59833a9.633,9.633,0,0,0-2.815-5.10383,13.1421,13.1421,0,0,1-.76086,5.50961,25.3951,25.3951,0,0,1-13.95455-2.76428c-3.23345-2.19366-7.34819-2.00351-12.14136,0a17.75012,17.75012,0,0,1,17.75236-17.75236h3.17006a17.75559,17.75559,0,0,1,17.75235,17.75236A52.85225,52.85225,0,0,1,404.81288,335.59833Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#2f2e41' : '#b3b3b3'}
        />
        <circle cx="113.24907" cy="285" r="51" fill="#f0f0f0" />
        <circle cx="438.24907" cy="51" r="51" fill="#f0f0f0" />
        <circle cx="843.24907" cy="293" r="51" fill="#f0f0f0" />
        <path
            d="M683.12454,282.42068V398.06673A9.11863,9.11863,0,0,1,674.101,407.186a.80182.80182,0,0,1-.09986.00416H660.54129a40.6065,40.6065,0,0,1-40.6065-40.6065v-84.163a9.12338,9.12338,0,0,1,9.12338-9.12338l5.454,0c-2.52672,7.37064,31.7654,10.47377,33.648,0l5.841,0A9.12341,9.12341,0,0,1,683.12454,282.42068Z"
            transform="translate(-152.87546 -225.8589)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M643.18162,264.64967a1.19706,1.19706,0,0,1,1.19565-1.19566h8.13043a1.19566,1.19566,0,0,1,0,2.39131h-8.13043A1.19706,1.19706,0,0,1,643.18162,264.64967Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#3f3d56' : '#615e84'}
        />
        <path
            d="M676.79446,421.8589h-51.416a15.06329,15.06329,0,0,1-15.04639-15.0459V325.9717a2.18651,2.18651,0,0,1-.91113-1.77881v-8.13037a2.18557,2.18557,0,0,1,.91113-1.77832v-2.18213a2.1856,2.1856,0,0,1-.91113-1.77832v-8.13086a2.18557,2.18557,0,0,1,.91113-1.77832v-3.94385a2.18353,2.18353,0,0,1-1.15039-1.92969v-8.13037a2.1843,2.1843,0,0,1,1.15039-1.93018V273.67384A15.06329,15.06329,0,0,1,625.37844,258.628h51.416a15.06288,15.06288,0,0,1,15.0459,15.04589V297.23a1.8859,1.8859,0,0,1,.88574,1.59814v15.50293a1.88674,1.88674,0,0,1-.88574,1.59863V406.813A15.06288,15.06288,0,0,1,676.79446,421.8589ZM625.37844,260.628a13.061,13.061,0,0,0-13.04639,13.04589v12.50782l-.96191.03711a.19547.19547,0,0,0-.18848.19189V294.541a.19617.19617,0,0,0,.18848.1919l.96191.03662v7.04931l-.76074.1875a.19651.19651,0,0,0-.15039.18653v8.13086a.19651.19651,0,0,0,.15039.18652l.76074.1875v4.99072l-.76074.1875a.19651.19651,0,0,0-.15039.18653v8.13037a.19664.19664,0,0,0,.15039.187l.76074.1875V406.813a13.061,13.061,0,0,0,13.04639,13.0459h51.416a13.0609,13.0609,0,0,0,13.0459-13.0459V314.2173h.88574V298.9424h-.88574V273.67384a13.06089,13.06089,0,0,0-13.0459-13.04589Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#3f3d56' : '#615e84'}
        />
        <circle cx="504.1757" cy="38.79076" r="1.19565" fill={!props.darkTheme ? '#3f3d56' : '#615e84'} />
        <path
            d="M396.95559,496.26173H263.16848a7.18838,7.18838,0,0,1-7.16992-7.16894v-65.189a7.1884,7.1884,0,0,1,7.16894-7.16992H396.95461a7.18841,7.18841,0,0,1,7.16993,7.16895v65.189A7.1884,7.1884,0,0,1,396.95559,496.26173Z"
            transform="translate(-152.87546 -225.8589)"
            fill="#fff"
        />
        <path
            d="M396.95559,496.26173H263.16848a7.18838,7.18838,0,0,1-7.16992-7.16894v-65.189a7.1884,7.1884,0,0,1,7.16894-7.16992H396.95461a7.18841,7.18841,0,0,1,7.16993,7.16895v65.189A7.1884,7.1884,0,0,1,396.95559,496.26173ZM263.16848,418.7339a5.18526,5.18526,0,0,0-5.16992,5.1709v65.187a5.18494,5.18494,0,0,0,5.1709,5.16992H396.95364a5.18515,5.18515,0,0,0,5.1709-5.17089v-65.187a5.18527,5.18527,0,0,0-5.1709-5.16992Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#3f3d56' : '#615e84'}
        />
        <path
            d="M337.23235,486.62784c-26.38574,0-53.89882-.25214-64.16427-.41561a5.17627,5.17627,0,0,1-5.06954-5.15521V427.09538a1.82954,1.82954,0,0,1,1.823-1.82756H390.29728a1.82942,1.82942,0,0,1,1.82726,1.8227v36.612a22.84157,22.84157,0,0,1-22.45691,22.75218C360.10027,486.57927,348.7713,486.62784,337.23235,486.62784Z"
            transform="translate(-152.87546 -225.8589)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M383.146,460.33888H274.28664a4.43849,4.43849,0,0,1-4.16406-2.93554l-12.32129-34.56641a4.4228,4.4228,0,0,1,4.15772-5.90674l136.07226-.18945a4.42312,4.42312,0,0,1,4.35938,5.19775l.105.04444-.39063.91162-.0039.00927-14.895,34.75538A4.40962,4.40962,0,0,1,383.146,460.33888Zm14.8916-41.59814-136.07471.18945a2.42256,2.42256,0,0,0-2.27783,3.23535l12.3208,34.56494a2.43347,2.43347,0,0,0,2.28223,1.6084H383.146a2.4131,2.4131,0,0,0,2.22168-1.46679l14.89551-34.75635.73242.314-.73242-.314a2.42117,2.42117,0,0,0-2.22559-3.375Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#3f3d56' : '#615e84'}
        />
        <circle cx="176.98309" cy="233.4802" r="8.52402" fill="#fff" />
        <circle cx="498.98309" cy="159.4802" r="8.52402" fill="#fff" />
        <path
            d="M974.25454,508.9789l-22.77-22.48a11.884,11.884,0,0,0-8.43-3.46h-.08a11.9143,11.9143,0,0,0-8.46,3.56,27.99135,27.99135,0,0,0-.49,38.84c.24.26.49.51.74.76a27.248,27.248,0,0,0,4.56,3.65,27.67639,27.67639,0,0,0,15.11,4.43h.17a27.82649,27.82649,0,0,0,19.75-8.32,12.023,12.023,0,0,0-.1-16.98Zm-1.32,15.57a26.09171,26.09171,0,0,1-32.76,3.48,26.78641,26.78641,0,0,1-4.01-3.25,26.00168,26.00168,0,0,1-.23-36.77,9.91308,9.91308,0,0,1,7.06-2.97h.06a9.911,9.911,0,0,1,7.02,2.88l22.77,22.49a10.00707,10.00707,0,0,1,.09,14.14Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#3f3d56' : '#615e84'}
        />
        <path
            d="M899.54452,435.19887l-22.77-22.49a11.92636,11.92636,0,0,0-8.43-3.46h-.07a11.947,11.947,0,0,0-8.47,3.56994,28.07691,28.07691,0,0,0-4.72,33l.01.01a27.562,27.562,0,0,0,4.33,5.93c.19.22.41.44.63.66a27.83532,27.83532,0,0,0,19.67,8.08h.18a27.854,27.854,0,0,0,19.75-8.33,11.99892,11.99892,0,0,0-.11-16.97Zm-1.32,15.57a25.85541,25.85541,0,0,1-18.33,7.73h-.17a26.00049,26.00049,0,0,1-18.49-44.27,10.00761,10.00761,0,0,1,14.14-.09l22.77,22.48A10.01911,10.01911,0,0,1,898.22451,450.76888Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#3f3d56' : '#615e84'}
        />
        <path
            d="M975.70994,516.04649l-25.1032-24.79357a8.72678,8.72678,0,0,0-12.32743.0765,22,22,0,1,0,31.30516,30.919Z"
            transform="translate(-152.87546 -225.8589)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M901.00443,442.26243l-25.1032-24.79356a8.72676,8.72676,0,0,0-12.32743.0765,22,22,0,1,0,31.30516,30.919Z"
            transform="translate(-152.87546 -225.8589)"
            fill={props.color || '#0070ce'}
        />
        <path
            d="M948.12454,531.48891l-.6,1.57995q-4.23-1.60491-8.2-3.22c-46.88-19.13-69.26-41.52-84.23-84.02l-.01-.01q-1.065-3-2.07-6.13995l1.58-.51a25.54187,25.54187,0,0,0,2.3,5.78q1.23,3.495,2.53,6.81c14.07,35.87,34.82,56.37,74.6,73.68q3,1.30507,6.15,2.59A26.08663,26.08663,0,0,0,948.12454,531.48891Z"
            transform="translate(-152.87546 -225.8589)"
            fill={!props.darkTheme ? '#3f3d56' : '#615e84'}
        />
        <rect
            x="900.62305"
            y="448.539"
            width="2.00052"
            height="73.00017"
            transform="translate(-229.92517 559.82386) rotate(-45.35527)"
            fill={!props.darkTheme ? '#3f3d56' : '#615e84'}
        />
        <path
            d="M436.64029,416.17348l.02662-32.86269-19.31762,1.72627,6.81759,20.7264-24.74716,37.51415a8.17278,8.17278,0,1,0,9.88987,6.88859Z"
            transform="translate(-152.87546 -225.8589)"
            fill="#ffb6b6"
        />
    </svg>
);

export const OrderFobsSketch = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 816.22 621"
        width={props.width || 200}
        height={props.height || 200}>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                    fill={'#3f3d56'}
                    d="M326.61,128.78h-3V47.21A47.21,47.21,0,0,0,276.42,0H103.6A47.21,47.21,0,0,0,56.39,47.21v447.5a47.21,47.21,0,0,0,47.21,47.21H276.42a47.21,47.21,0,0,0,47.21-47.21V186.84h3Z"
                />
                <path
                    fill={'#fff'}
                    d="M278.33,12.28H255.77a16.76,16.76,0,0,1-15.51,23.08h-99A16.75,16.75,0,0,1,124.5,18.61a17,17,0,0,1,1.24-6.33H104.67A35.26,35.26,0,0,0,69.42,47.54h0V494.38a35.25,35.25,0,0,0,35.25,35.26H278.33a35.25,35.25,0,0,0,35.25-35.26h0V47.54a35.26,35.26,0,0,0-35.25-35.26Z"
                />
                <path fill={'#cbcbcb'} d="M382,542H1a1,1,0,0,1,0-2H382a1,1,0,0,1,0,2Z" />
                <path
                    fill={'#f1f1f1'}
                    d="M694.24,550.3a26.71,26.71,0,0,1,3.61-4.6c.57-.58,1.16-1.13,1.77-1.67A28.14,28.14,0,0,1,746,560c4.12-15.25-6.62-30.28-17.41-41.82s-23.14-24.19-23.08-40c0-8.79,4.33-16.64,10.83-22.46l.6-.52a41.11,41.11,0,0,1,28.29-9.86c19.2,1,36,13.94,47.61,29.24,18.74,24.63,27,59.2,13.83,87.23-11.54,24.66-36.15,39.3-61.27,51.07q-5.25,2.48-10.5,4.78l-.07,0-.49.23-2.16.95.33.21,1,.67-1.07-.64c-.1-.07-.22-.13-.32-.19-12.34-7.41-24.84-15.24-33.37-26.79C690,580.17,686.42,563,694.24,550.3Z"
                />
                <path
                    fill={'#fff'}
                    d="M776.55,522.44A69.7,69.7,0,0,1,781.92,542a60.47,60.47,0,0,1-.73,18,77.65,77.65,0,0,1-15.58,33.32,111.25,111.25,0,0,1-20.18,19.62q-5.25,2.48-10.5,4.78l-.07,0-.49.23-2.16.95.33.21,1,.67-1.07-.64c-.1-.07-.22-.13-.32-.19a61.25,61.25,0,0,0-34.33-73.25c.57-.59,1.16-1.14,1.77-1.68a64,64,0,0,1,33.87,37.4,64.67,64.67,0,0,1,1.4,36.18c.62-.4,1.24-.82,1.85-1.23,11.49-7.75,22.08-17.06,30.06-28.47a72.33,72.33,0,0,0,12.82-32.58c1.53-12.84-1.68-25.46-7.41-36.91a151.25,151.25,0,0,0-23.7-33.67,171.56,171.56,0,0,0-31.78-27.32,1.25,1.25,0,0,1-.36-1.67,1.06,1.06,0,0,1,.6-.52.91.91,0,0,1,.78.16c1.44,1,2.87,1.93,4.28,2.93a174,174,0,0,1,31.77,29C762.83,497.9,771.05,509.63,776.55,522.44Z"
                />
                <circle
                    id="ae2e9f9a-ed63-4994-961d-af4fbb6f5199"
                    fill={'#f1f1f1'}
                    cx="525.04"
                    cy="21.28"
                    r="17.93"
                    transform="translate(392.55 529.77) rotate(-77.72)"
                />
                <circle id="b777be60-18da-4893-88a8-55a275d98bc2" fill={'#f1f1f1'} cx="748.04" cy="268.28" r="10.93" />
                <circle id="a703acd2-aa23-4bff-9a86-75b7d9a928c1" fill={'#f1f1f1'} cx="428.04" cy="298.28" r="10.93" />
                <path fill={'#cbcbcb'} d="M434.22,621h381a1,1,0,0,0,0-2h-381a1,1,0,0,0,0,2Z" />
                <path
                    fill={'#ffb7b7'}
                    d="M773.17,96.63A14.65,14.65,0,0,0,745,89.21l-30.91,35.44L723.19,150l31.09-41.42a14.55,14.55,0,0,0,18.32-9.43A13.42,13.42,0,0,0,773.17,96.63Z"
                />
                <polygon
                    fill={'#3f3d56'}
                    points="645.01 234.55 747.64 125.02 733.8 103.01 605.08 211.88 645.01 234.55"
                />
                <circle fill={'#2f2e41'} cx="622.11" cy="132" r="36" />
                <path
                    fill={'#2f2e41'}
                    d="M625,111.66A75.7,75.7,0,0,1,652.46,93.9c6.64-2.46,13.87-4,20.81-2.58s13.5,6.2,15.44,13c1.58,5.57-.05,11.56-2.51,16.81s-5.74,10.1-7.72,15.53a35.48,35.48,0,0,0,35.69,47.57c-6.82.91-13.11,4.12-19.78,5.82s-14.53,1.59-19.48-3.18c-5.24-5.06-5.35-13.27-5.09-20.55q.55-16.22,1.13-32.44c.19-5.52.35-11.21-1.64-16.36s-6.71-9.65-12.23-9.6c-4.18,0-7.89,2.56-11.24,5.06s-6.9,5.17-11.07,5.54-8.92-2.71-8.61-6.88Z"
                />
                <path
                    fill={'#ffb7b7'}
                    d="M485.38,373.72a14.65,14.65,0,0,1-11-26.92l31.1-35.29,26.3,5.69-37,36.24a14.57,14.57,0,0,1-7,19.39,14,14,0,0,1-2.41.89Z"
                />
                <polygon fill={'#3f3d56'} points="587.7 247.41 510.18 344.7 486.56 333.86 577.66 192.01 587.7 247.41" />
                <polygon
                    fill={'#ffb7b7'}
                    points="525.85 541.21 507.37 540.92 509.6 603.89 525.85 603.89 525.85 541.21"
                />
                <path fill={'#2f2e41'} d="M530,598.58H498A20.39,20.39,0,0,0,477.59,619v.67H530Z" />
                <polygon
                    fill={'#ffb7b7'}
                    points="648.16 524.51 627.98 537.47 668.35 586.03 682.03 577.25 648.16 524.51"
                />
                <path
                    fill={'#2f2e41'}
                    d="M682.65,570.55l-26.93,17.29h0A20.4,20.4,0,0,0,649.57,616l.36.56L694,588.27Z"
                />
                <path
                    fill={'#3f3d56'}
                    d="M655.35,332.24S610.52,183.31,596.1,181.3s-37.62,38.21-37.62,38.21c-30.11,38.41-61.15,162.82-61.15,162.82s51.75,3.24,89.58,23.37,82.46-1,82.46-1Z"
                />
                <path
                    isolation={'isolate'}
                    opacity={0.1}
                    d="M655.35,332.24S610.52,183.31,596.1,181.3s-31.73,38.62-31.73,38.62c-15,62-67,162.41-67,162.41s51.75,3.24,89.58,23.37,82.46-1,82.46-1Z"
                />
                <polygon
                    fill={'#2f2e41'}
                    points="618.57 287.68 618.57 362.52 627.37 470.92 671.37 552.92 650.37 567.92 590.37 489.92 566.64 412.47 529.37 583.92 501.37 581.92 520.82 344.21 557.72 277.3 618.57 287.68"
                />
                <path
                    fill={'#0070ce'}
                    d="M573.36,215.3c-14,14-1,29-1,29l-16,36,63,17,22-98.38-15-16c-30-1-30-1.62-30-1.62C591.1,186.44,573.36,215.3,573.36,215.3Z"
                />
                <path
                    fill={'#3f3d56'}
                    d="M643.91,188.73a26.88,26.88,0,0,0-37.59,5.66l-.19.25c-15.83,22.05-30.48,57.66-10.3,102.07,32.4,71.31,60.59,107.82,72,107.81a4.4,4.4,0,0,0,1.48-.23c7-2.39,17.25-14.33,19.1-24.85.66-3.76.5-9-4-12.61-12.94-10.35-36.16-42.56-43.4-85-4-23.42,3.76-44.77,11-58.55A26.87,26.87,0,0,0,644.26,189h0Z"
                />
                <circle fill={'#ffb7b7'} cx="611.25" cy="141.21" r="26.5" />
                <path
                    fill={'#2f2e41'}
                    d="M574,139.21h38.27l.39-5.5,2,5.5h5.89l.78-10.89,3.89,10.89h11.4v-.54A28.62,28.62,0,0,0,608,110.08h-5.4A28.62,28.62,0,0,0,574,138.67Z"
                />
                <path
                    fill={'#2f2e41'}
                    d="M630.78,159l16.33-5.29V114H616.26l.77.76C627.65,125.37,639.47,163,630.78,159Z"
                />
                <path
                    fill={props.color || '#0070ce'}
                    d="M179.41,193v10.54l-6.92,2a71.94,71.94,0,0,0-32,18.6c-10.21,10.38-16.3,21.74-19.92,37.55-10.38,45.94,34.74,91.89,82,83.65,31.62-5.43,55.17-29,60.93-60.93,3.63-20.41-4.44-44.13-20.58-60.27A71.94,71.94,0,0,0,211,205.52l-6.91-2V182.3h-24.7Zm19.76,71v12.51l9.05-7.74c5.11-4.28,9.72-7.41,10.21-6.75.66.49-1.64,3.46-4.94,6.26l-6.09,5.43,6.59,8.56c6.91,8.9,7.57,10.38,5.1,10.38-.82,0-4.28-3.62-7.57-8.24-5.11-7.08-6.43-7.9-9.23-6.58-2.14,1.15-3.12,3.46-3.12,7.41,0,3-.66,6.09-1.65,6.58-1,.66-1.65-6.25-1.65-19.59,0-12.68.66-20.75,1.65-20.75S199.17,256.73,199.17,264ZM242,256.4c0,.82-4.12,1.65-9.06,1.65s-9-.83-9-1.65c0-1,4.11-1.65,9-1.65S242,255.41,242,256.4Zm-83.16,7.25c2.47,1.81,3.3,4.94,3.79,14.16.49,7.41,0,12.51-1.15,13.67-1.32,1.31-1.81-1.16-1.81-9.39,0-13.67-1.82-17.46-8.24-17.46-6.75,0-9.88,5.27-9.88,16.8,0,5.27-.66,9.55-1.65,9.55s-1.64-5.76-1.64-14,.66-14,1.64-14a1.75,1.75,0,0,1,1.65,2c0,1.32,1,1,2.8-.82C147.79,260.68,154.54,260.52,158.82,263.65Zm29.64,2c5.6,6.09,5.6,16.63,0,22.73-5.1,5.43-12.18,5.6-18.44.33-3.79-3.3-4.61-5.27-4.61-11.7s.82-8.39,4.61-11.69C176.28,260,183.36,260.19,188.46,265.62Zm51.71-1.48a17.47,17.47,0,0,1,4.45,8.23l1.15,5.44H233.91c-9.88,0-11.69.49-11.69,2.8,0,8.4,12.68,11.85,17.46,4.61,1.48-2.31,3.29-4.12,4.11-4.12,2.64,0,1.48,3.46-2.63,7.41-9.06,9.22-22.23,2.47-22.23-11.53,0-5.76,1-8.56,4.11-11.52A12.57,12.57,0,0,1,240.17,264.14Z"
                />
                <path
                    fill={props.color || '#0070ce'}
                    d="M172.16,267.27c-8.07,7.9-3.29,22.06,7.25,22.06,5.76,0,9.88-5.1,9.88-12.35C189.29,266.45,178.75,260.52,172.16,267.27Z"
                />
                <path
                    fill={props.color || '#0070ce'}
                    d="M225,267.6c-4.94,5.43-3.46,6.91,7.08,6.91,5.43,0,9.88-.49,9.88-1.31,0-.66-1.15-3-2.63-4.94C236.22,263.81,228.81,263.48,225,267.6Z"
                />
            </g>
        </g>
    </svg>
);

export const AddScheduleSketch = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        width={props.width || '866.33071'}
        height={props.width || '605.73993'}
        viewBox="0 0 866.33071 605.73993">
        <path
            d="M898.30315,567.7887a9.14581,9.14581,0,0,1,1.93088-13.89051l-7.25159-31.682,15.8187,5.91773,4.46105,29.1785a9.19542,9.19542,0,0,1-14.959,10.47626Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#ffb8b8"
        />
        <path
            d="M897.20867,542.64389l-13.906-26.88477,1.88062-67.69726.89355,1.88281c1.041,2.19336,25.44019,53.84619,23.7,71.13819l2.78882,15.80224Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#3f3d56"
        />
        <polygon
            points="721.307 594.201 732.458 594.201 737.762 551.192 721.305 551.193 721.307 594.201"
            fill="#ffb8b8"
        />
        <path
            d="M885.29761,737.691l21.95908-.00089h.00155a13.99379,13.99379,0,0,1,13.99352,13.99352v.45476l-35.95371.00177Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#2f2e41"
        />
        <polygon
            points="611.134 585.727 621.877 588.714 638.511 548.699 622.655 544.29 611.134 585.727"
            fill="#ffb8b8"
        />
        <path
            d="M776.20352,728.58778,797.36,734.47044l.00149.00042a13.99378,13.99378,0,0,1,9.7326,17.23118l-.12184.43813-34.63966-9.63139Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#2f2e41"
        />
        <path
            d="M877.02434,724.5643l-22.50366-161.126L805.91619,723.65317l-38.21692-13.04981,54.77454-214.53271.36035-.02539,57.38061-3.99121,41.45679,219.48779Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#2f2e41"
        />
        <path
            d="M871.07293,420.14509s-20.91878-10.91415-49.11366-6.36659c0,0-15.007,36.205,0,50.61758l4.0928,36.24085s38.19952,22.7378,50.93269-3.63805l-1.819-30.01391s9.09512-14.39464,1.819-24.93281A34.82081,34.82081,0,0,1,871.07293,420.14509Z"
            transform="translate(-166.83465 -147.13004)"
            fill={props.fill || '#0070ce'}
        />
        <path
            d="M873.72307,584.98666l3.67163-76.188-10.39135-90.63379.47705-.07227c13.63086-2.05517,18.00268,21.42774,18.18213,22.42822l23.72583,134.14209Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#3f3d56"
        />
        <path
            d="M827.46624,585.78061l-41.94336-4.66016.011-.45849c.14869-6.20948,3.75879-152.2041,13.87452-162.54395,10.17553-10.40137,29.37719-5.90088,30.18969-5.70312l.40479.09765-3.45142,61.77637Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#3f3d56"
        />
        <path
            d="M835.19144,498.52321a9.14584,9.14584,0,0,1-11.90719-7.409l-31.89489-6.24893,11.83539-12.04883,28.47343,7.7813a9.19542,9.19542,0,0,1,3.49326,17.92547Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#ffb8b8"
        />
        <path
            d="M818.17132,491.20932,807.77874,488.975c-15.34229,4.61425-42.12219-11.62989-52.94593-18.84522-2.03662-1.35742-2.69726-4.04736-1.9635-7.99365a23.30978,23.30978,0,0,1,8.567-13.915l38.11975-30.2251,9.62158-1.60889,2.85791,16.19483L787.74822,458.6683l35.75244,19.46Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#3f3d56"
        />
        <path
            d="M814.06094,400.06826v-21a33.5,33.5,0,1,1,67,0v21a4.50508,4.50508,0,0,1-4.5,4.5h-58A4.50507,4.50507,0,0,1,814.06094,400.06826Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#2f2e41"
        />
        <circle cx="679.37983" cy="232.67051" r="24.56103" fill="#ffb8b8" />
        <path
            d="M820.97939,379.706a2.50023,2.50023,0,0,1-.5852-1.99317l2.90942-20.25976a2.50362,2.50362,0,0,1,1.41455-1.91895c14.85034-6.95019,29.90967-6.959,44.76-.02637a2.51921,2.51921,0,0,1,1.42871,2.03614L872.849,377.83a2.49954,2.49954,0,0,1-2.48877,2.73828h-4.92553a2.50966,2.50966,0,0,1-2.26539-1.44238l-2.12573-4.55469a1.49989,1.49989,0,0,0-2.84765.44824l-.41993,3.3584a2.50359,2.50359,0,0,1-2.48071,2.19043H822.8688A2.50013,2.50013,0,0,1,820.97939,379.706Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#2f2e41"
        />
        <rect y="40.3663" width="551" height="343.11356" fill="#e6e6e6" />
        <rect x="36.94894" y="106.46612" width="100.91574" height="65.59524" fill="#fff" />
        <rect x="162.34439" y="106.46612" width="100.91574" height="65.59524" fill="#fff" />
        <rect x="287.73987" y="106.46612" width="100.91577" height="65.59524" fill="#fff" />
        <rect x="413.13531" y="106.46612" width="100.91577" height="65.59524" fill="#fff" />
        <rect x="36.94894" y="199.30861" width="100.91574" height="65.59523" fill="#fff" />
        <rect x="162.34439" y="199.30861" width="100.91574" height="65.59523" fill="#fff" />
        <rect x="287.73987" y="199.30861" width="100.91577" height="65.59523" fill="#fff" />
        <rect x="413.13531" y="199.30861" width="100.91577" height="65.59523" fill="#fff" />
        <rect x="36.94894" y="292.15109" width="100.91574" height="65.59525" fill="#fff" />
        <rect x="162.34439" y="292.15109" width="100.91574" height="65.59525" fill="#fff" />
        <rect x="287.73987" y="292.15109" width="100.91577" height="65.59525" fill="#fff" />
        <rect x="413.13531" y="292.15109" width="100.91577" height="65.59525" fill="#fff" />
        <circle cx="144.30951" cy="65.59524" r="15.13736" fill="#fff" />
        <circle cx="394.58057" cy="65.59524" r="15.13734" fill="#fff" />
        <rect x="138.25458" width="12.10989" height="69.63187" fill="#e6e6e6" />
        <rect x="388.52563" width="12.10986" height="69.63187" fill="#e6e6e6" />
        <path
            d="M653.24859,286.39377a22.75657,22.75657,0,1,1-3.52686-12.19043A22.7566,22.7566,0,0,1,653.24859,286.39377Z"
            transform="translate(-166.83465 -147.13004)"
            fill={props.fill || '#0070ce'}
        />
        <path
            d="M649.72173,274.20337l-22.46387,22.45975c-1.41186-2.18579-9.27765-12.34394-9.27765-12.34394A31.82748,31.82748,0,0,1,621.2,281.477l6.52259,8.69678,19.36853-19.36856A22.72652,22.72652,0,0,1,649.72173,274.20337Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#fff"
        />
        <path
            d="M402.45763,379.23627a22.75655,22.75655,0,1,1-3.52685-12.19043A22.7566,22.7566,0,0,1,402.45763,379.23627Z"
            transform="translate(-166.83465 -147.13004)"
            fill={props.fill || '#0070ce'}
        />
        <path
            d="M398.93078,367.04584l-22.46387,22.45974c-1.41187-2.18579-9.27765-12.34393-9.27765-12.34393a31.82748,31.82748,0,0,1,3.21979-2.84222l6.52258,8.69677,19.36859-19.36856A22.72613,22.72613,0,0,1,398.93078,367.04584Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#fff"
        />
        <path
            d="M277.06218,379.23627a22.75667,22.75667,0,1,1-3.52685-12.19043A22.75667,22.75667,0,0,1,277.06218,379.23627Z"
            transform="translate(-166.83465 -147.13004)"
            fill={props.fill || '#0070ce'}
        />
        <path
            d="M273.53533,367.04584l-22.46387,22.45974c-1.41186-2.18579-9.27765-12.34393-9.27765-12.34393a31.82748,31.82748,0,0,1,3.21979-2.84222l6.52258,8.69677,19.3686-19.36856A22.72673,22.72673,0,0,1,273.53533,367.04584Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#fff"
        />
        <path
            d="M1032.16535,752.87h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z"
            transform="translate(-166.83465 -147.13004)"
            fill="#3f3d56"
        />
    </svg>
);

export const DigitalAuditIcon = (props) => (
    <svg
        width={props.width || 26}
        height={props.height || 26}
        viewBox="0 0 75 60"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="digital_audit_icon" fill="#000000">
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M52.2608976,17.2027972 C58.4044057,17.2027972 63.3847031,22.1808898 63.3847031,28.3216783 C63.3847031,34.4624668 58.4044057,39.4405594 52.2608976,39.4405594 C46.1173895,39.4405594 41.1370921,34.4624668 41.1370921,28.3216783 C41.1370921,22.1808898 46.1173895,17.2027972 52.2608976,17.2027972 Z M52.2608976,18.8811189 C47.0447114,18.8811189 42.8161571,23.1078013 42.8161571,28.3216783 C42.8161571,33.5355553 47.0447114,37.7622378 52.2608976,37.7622378 C57.4770838,37.7622378 61.7056381,33.5355553 61.7056381,28.3216783 C61.7056381,23.1078013 57.4770838,18.8811189 52.2608976,18.8811189 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M15.9511173,8.81118881 L15.9511173,35.2447552 L8.39532492,35.2447552 L8.39532492,8.81118881 L15.9511173,8.81118881 Z M14.2720524,10.4895105 L10.0743899,10.4895105 L10.0743899,33.1468531 L14.2720524,33.1468531 L14.2720524,10.4895105 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M25.605741,20.979021 L25.605741,35.2447552 L18.0499486,35.2447552 L18.0499486,20.979021 L25.605741,20.979021 Z M23.926676,22.6573427 L19.7290136,22.6573427 L19.7290136,33.5664336 L23.926676,33.5664336 L23.926676,22.6573427 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M35.2603646,15.5244755 L35.2603646,35.2447552 L27.7045722,35.2447552 L27.7045722,15.5244755 L35.2603646,15.5244755 Z M33.5812997,17.2027972 L29.3836372,17.2027972 L29.3836372,33.5664336 L33.5812997,33.5664336 L33.5812997,17.2027972 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M44.9149883,10.4895105 L44.9143443,16.1015524 C44.3241769,16.4770754 43.7630486,16.8941389 43.2350803,17.3486236 L43.2359233,12.1678322 L39.0382609,12.1678322 L39.0379783,23.4537322 C38.4946278,24.9750159 38.1987284,26.6138069 38.1987284,28.3216783 C38.1987284,30.0294615 38.4945972,31.6681714 39.0378941,33.1893886 L39.0382609,33.5664336 L39.1785272,33.5664004 C39.4036631,34.1450687 39.6649582,34.7056843 39.959639,35.2454747 L37.3591959,35.2447552 L37.3591959,10.4895105 L44.9149883,10.4895105 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M62.5451706,3.77622378 C63.9361536,3.77622378 65.0637681,4.90383827 65.0637681,6.29482125 L65.0636392,21.5497176 C64.5848946,20.6473025 64.0134501,19.8015526 63.361991,19.0251476 L63.3613828,5.45454545 L5.48028154,5.45454545 L5.48028154,36.9230769 L40.6118914,36.9233346 C40.9370443,37.3625625 41.2864685,37.7827525 41.6581832,38.1819247 L3.77789621,38.1818182 L3.77789621,6.29482125 C3.77789621,4.90383827 4.90551071,3.77622378 6.29649369,3.77622378 L62.5451706,3.77622378 Z M65.0636392,35.093639 L65.0637681,38.1818182 L62.863612,38.1819247 C63.7248154,37.2571068 64.4663686,36.2194711 65.0636392,35.093639 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M65.9033006,0 C67.7579446,-3.4069257e-16 69.2614306,1.503486 69.2614306,3.35812997 L69.261,42.377 L67.582,40.699 L67.5823656,4.44896473 C67.5823656,2.68705296 66.1540539,1.25874126 64.3921421,1.25874126 L4.86928845,1.25874126 C3.16813226,1.25874126 1.77796591,2.59024705 1.68411515,4.26793289 L1.67906498,4.44896473 L1.67906498,43.3832031 C1.67906498,45.0843593 3.01057078,46.4745256 4.68825661,46.5683764 L4.86928845,46.5734266 L64.3921421,46.5734266 C64.4856647,46.5734266 64.5782474,46.5694023 64.6697265,46.5615175 L65.723,47.832 L3.35812997,47.8321678 C1.503486,47.8321678 2.2712838e-16,46.3286818 0,44.4740379 L0,3.35812997 C-2.2712838e-16,1.503486 1.503486,3.4069257e-16 3.35812997,0 L65.9033006,0 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M52.2608976,13.8461538 C60.2590497,13.8461538 66.7428331,20.3270669 66.7428331,28.3216783 C66.7428331,32.0019793 65.3687897,35.3614973 63.1055035,37.9156464 L61.9730339,36.6602663 C63.8994628,34.4205572 65.0637681,31.5070266 65.0637681,28.3216783 C65.0637681,21.2539784 59.3317277,15.5244755 52.2608976,15.5244755 C45.1900675,15.5244755 39.4580271,21.2539784 39.4580271,28.3216783 C39.4580271,35.3893783 45.1900675,41.1188811 52.2608976,41.1188811 C55.0865564,41.1188811 57.6984135,40.2038928 59.8160975,38.6541635 L60.9450985,39.9068806 C58.5255526,41.721854 55.5188613,42.7972028 52.2608976,42.7972028 C44.2627455,42.7972028 37.7789621,36.3162897 37.7789621,28.3216783 C37.7789621,20.3270669 44.2627455,13.8461538 52.2608976,13.8461538 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M64.8241936,37.9423497 L74.1378765,47.2519096 C75.2856329,48.3991579 75.2860448,50.2596268 74.1387965,51.4073833 C74.0809145,51.4652909 74.0206374,51.520754 73.9581231,51.5736273 L73.2063372,52.2094722 C71.9672748,53.2574455 70.1132661,53.1025371 69.0652929,51.8634748 L69.0466182,51.841172 L60.4823026,41.5095047 C59.8577001,40.7560078 59.7224275,39.7584316 60.0404115,38.9024631 L60.7028098,39.6399129 C60.7378532,39.7953209 60.8002477,39.9465321 60.8907969,40.0862049 L60.9738541,40.201099 L69.471812,50.7878317 C69.4790285,50.796822 69.4863111,50.8057591 69.4936591,50.8146423 C70.2835291,51.7695347 71.6695504,51.9406352 72.6639773,51.2345212 L72.8032678,51.1276702 L72.9088535,51.0403316 C72.9691748,50.9904349 73.0268802,50.9374575 73.0817393,50.8816111 C73.9202037,50.0280557 73.9484795,48.6810741 73.1750713,47.7942137 L73.0530485,47.6647548 L63.6247238,38.4031239 C63.5359771,38.3159462 63.4403229,38.2392297 63.3394163,38.1731308 L62.3765627,37.1054186 C63.2509667,36.9948908 64.160611,37.2790609 64.8241936,37.9423497 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M28.5441047,47.8321678 C28.9260105,50.9850533 28.5062443,53.2228155 27.284806,54.5454545 C26.2071731,55.7123733 22.6399972,56.6169221 18.8894811,57.9020979 C18.5558209,58.016432 18.4158988,58.2961523 18.4697148,58.7412587 L18.4697148,58.7412587 L34.0010659,58.7412587 L34.0010659,60 L16.7906498,60 C16.5280481,58.4168308 16.6679701,57.4378098 17.2104161,57.0629371 C19.2878237,55.6272852 21.8278448,55.8041958 23.926676,54.5454545 C25.7248921,53.4670025 26.7043466,51.2292403 26.8650397,47.8321678 Z"
                    id="Combined-Shape"></path>
                <path
                    stroke={props.color || 'none'}
                    strokeWidth="1.2"
                    fill={props.fill || 'none'}
                    d="M45.7545208,47.8321678 C46.1364266,50.9850533 45.7166604,53.2228155 44.4952221,54.5454545 C43.4175892,55.7123733 39.8504132,56.6169221 36.0998971,57.9020979 C35.766237,58.016432 35.6263149,58.2961523 35.6801309,58.7412587 L35.6801309,58.7412587 L51.211482,58.7412587 L51.211482,60 L34.0010659,60 C33.7384641,58.4168308 33.8783862,57.4378098 34.4208322,57.0629371 C36.4982398,55.6272852 39.0382609,55.8041958 41.1370921,54.5454545 C42.9353081,53.4670025 43.9147627,51.2292403 44.0754558,47.8321678 Z"
                    id="Combined-Shape"
                    transform="translate(42.542030, 53.916084) scale(-1, 1) translate(-42.542030, -53.916084) "></path>
            </g>
        </g>
    </svg>
);

export const HelpIconCircle = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 20}
        height={props.height || 20}
        viewBox="0 0 14.882 14.882">
        <path
            id="information-circle"
            d="M63.441,56a7.441,7.441,0,1,0,7.441,7.441A7.449,7.449,0,0,0,63.441,56Zm0,3.051a.967.967,0,1,1-.967.967A.967.967,0,0,1,63.441,59.051Zm1.786,8.408H61.953a.6.6,0,0,1,0-1.191h1.042V62.994h-.6a.6.6,0,1,1,0-1.191H63.59a.6.6,0,0,1,.6.6v3.869h1.042a.6.6,0,1,1,0,1.191Z"
            transform="translate(-56 -56)"
            fill={props.fill || '#0070CE'}
        />
    </svg>
);

export const DeviceDetailsIcon = (props) => (
    <svg 
        version="1.0" 
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 35}
        height={props.height || 35}
        viewBox="0 0 200.000000 200.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path                     
            stroke={props.color || 'none'}
            strokeWidth="1.4"
            fill={props.fill || 'none'}
            d="M653 1843 c-12 -2 -36 -20 -53 -39 l-30 -35 0 -769 0 -770 34 -38 34
        -37 344 -3 c312 -2 346 -1 378 15 68 35 70 46 70 429 0 372 3 354 -56 354
        l-24 0 0 -267 c0 -148 -4 -274 -8 -281 -7 -9 -83 -12 -348 -10 l-339 3 -3 674
        c-1 489 1 678 9 687 16 19 658 21 677 2 7 -7 12 -32 12 -56 0 -44 0 -44 31
        -38 17 3 35 6 40 6 16 0 10 74 -9 110 -33 68 -47 70 -412 69 -179 -1 -335 -4
        -347 -6z m387 -1533 c27 -27 25 -46 -5 -76 -27 -27 -59 -26 -82 4 -45 57 36
        123 87 72z"/>
        <path                     
            stroke={props.color || 'none'}
            strokeWidth="1.4"
            fill={props.fill || 'none'}
            d="M1347 1596 c-82 -30 -152 -99 -188 -186 -22 -55 -18 -165 10 -228 33
        -73 115 -147 189 -168 154 -45 327 39 376 183 25 74 21 179 -10 241 -32 64
        -109 135 -171 156 -56 19 -154 20 -206 2z m185 -48 c51 -15 121 -77 147 -131
        15 -30 21 -63 21 -109 0 -104 -39 -173 -129 -226 -39 -23 -57 -27 -121 -27
        -85 0 -133 20 -186 77 -53 55 -68 95 -68 173 0 79 21 130 76 185 64 65 164 87
        260 58z"/>
        <path 
            stroke={props.color || 'none'}
            strokeWidth="1.4"
            fill={props.fill || 'none'}
            d="M1408 1509 c-21 -12 -24 -69 -6 -87 17 -17 74 -15 92 4 50 50 -23
        120 -86 83z"/>
        <path 
            stroke={props.color || 'none'}
            strokeWidth="1.4"
            fill={props.fill || 'none'}
            d="M1400 1225 l0 -145 50 0 50 0 0 145 0 145 -50 0 -50 0 0 -145z"/>
        </g>
    </svg>
)

export const CloseIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 20}
        height={props.height || 20}
        viewBox="0 0 8.249 8.249">
        <path
            id="Path_3"
            data-name="Path 3"
            d="M13.249,5.831,12.418,5,9.125,8.294,5.831,5,5,5.831,8.294,9.125,5,12.418l.831.831L9.125,9.955l3.294,3.294.831-.831L9.955,9.125Z"
            transform="translate(-5 -5)"
            fill={props.fill || '#0070CE'}
        />
    </svg>
);

export const WarningIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '20'}
        height={props.height || '20'}
        viewBox="0 0 15.003 14.101">
        <path
            id="warning"
            d="M62.907,78.1,56.591,66.374a1.186,1.186,0,0,0-2.088,0L48.187,78.1a1.186,1.186,0,0,0,1.042,1.748H61.863A1.186,1.186,0,0,0,62.907,78.1Zm-7.36-.068a.741.741,0,1,1,.741-.741A.741.741,0,0,1,55.547,78.035Zm.8-7.454L56.139,75.1a.593.593,0,1,1-1.186,0l-.213-4.519a.805.805,0,0,1,.8-.841h.008a.806.806,0,0,1,.805.841Z"
            transform="translate(-48.046 -65.75)"
            fill={props.fill || '#0070CE'}
        />
    </svg>
);

export const CheckmarkIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '20'}
        height={props.height || '20'}
        viewBox="0 0 9.478 6.792">
        <g transform="translate(0.705 0.707)">
            <path
                id="checkmark-outline"
                d="M104.066,128l-5.646,5.584L96,131.49"
                transform="translate(-96 -128)"
                fill="none"
                stroke={props.stroke || '#0070CE'}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={props.strokeWidth || 1}
            />
        </g>
    </svg>
);

export const GridIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '20'}
        height={props.height || '20'}
        viewBox="0 0 16 16">
        <g id="Group_32" data-name="Group 32" transform="translate(-685 -152)">
            <line
                id="Line_50"
                data-name="Line 50"
                y2="15"
                transform="translate(688 152.5)"
                fill="none"
                stroke={props.stroke || '#0070CE'}
                strokeLinecap="round"
                strokeWidth="1"
            />
            <line
                id="Line_53"
                data-name="Line 53"
                x1="15"
                transform="translate(685.5 155)"
                fill="none"
                stroke={props.stroke || '#0070CE'}
                strokeLinecap="round"
                strokeWidth="1"
            />
            <line
                id="Line_54"
                data-name="Line 54"
                x1="15"
                transform="translate(685.5 160)"
                fill="none"
                stroke={props.stroke || '#0070CE'}
                strokeLinecap="round"
                strokeWidth="1"
            />
            <line
                id="Line_55"
                data-name="Line 55"
                x1="15"
                transform="translate(685.5 165)"
                fill="none"
                stroke={props.stroke || '#0070CE'}
                strokeLinecap="round"
                strokeWidth="1"
            />
            <line
                id="Line_51"
                data-name="Line 51"
                y2="15"
                transform="translate(693 152.5)"
                fill="none"
                stroke={props.stroke || '#0070CE'}
                strokeLinecap="round"
                strokeWidth="1"
            />
            <line
                id="Line_52"
                data-name="Line 52"
                y2="15"
                transform="translate(698 152.5)"
                fill="none"
                stroke={props.stroke || '#0070CE'}
                strokeLinecap="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const CardViewIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '20'}
        height={props.height || '20'}
        viewBox="0 0 16 13">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g id="Group_33" data-name="Group 33">
                    <path
                        id="Path_215"
                        data-name="Path 215"
                        fill={props.fill || '#0070CE'}
                        d="M12,0H4A4,4,0,0,0,0,4V9a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4m-.5,6A1.5,1.5,0,1,1,13,4.5,1.5,1.5,0,0,1,11.5,6"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const ViewIcon= (props) => (
 
    <svg xmlns="http://www.w3.org/2000/svg"  width={props.width || 20}
    height={props.height || 20} fill={props.color ||'none'} stroke={props.color || '#3D5F7B'}  viewBox="0 0 512 512" version="1.1">

       
        <g id="Layer_1"  />
        <g id="Layer_2"  >
        <g stroke={props.color || '#3D5F7B'}>

        <path d="M319.63,191.33l-5.34-19.8c-1.88-6.98-8.22-11.83-15.45-11.83h-88.12c-7.23,0-13.56,4.85-15.45,11.83    l-5.34,19.8h-38.06c-8.84,0-16,7.16-16,16V336.3c0,8.84,7.16,16,16,16h205.81c8.84,0,16-7.16,16-16V207.33c0-8.84-7.16-16-16-16    H319.63z M341.68,320.3H167.88v-96.97h34.31c7.23,0,13.56-4.85,15.45-11.83l5.34-19.8h63.61l5.34,19.8    c1.88,6.98,8.22,11.83,15.45,11.83h34.31V320.3z"/>
        <path d="M254.78,217.5c-25.61,0-46.45,20.84-46.45,46.45s20.84,46.45,46.45,46.45s46.45-20.84,46.45-46.45    S280.39,217.5,254.78,217.5z M254.78,278.4c-7.97,0-14.45-6.48-14.45-14.45s6.48-14.45,14.45-14.45s14.45,6.48,14.45,14.45    S262.75,278.4,254.78,278.4z"/>

        <path d="M46.29,265.58c4.7,4.58,8.76,8.54,15.63,8.65c0.08,0,0.16,0,0.23,0c4.24,0,8.36-1.7,11.36-4.7l29.43-29.43    l-21.56-21.56c17.24-79.88,88.43-139.92,173.39-139.92c67.45,0,128.2,37.45,158.54,97.74c3.97,7.89,13.59,11.07,21.49,7.1    c7.89-3.97,11.07-13.59,7.1-21.49c-17.18-34.13-43.38-62.94-75.77-83.32c-33.31-20.96-71.82-32.03-111.35-32.03    c-103.76,0-190.11,75.87-206.55,175.03c-0.18-0.19-0.37-0.39-0.55-0.58c-6.06-6.43-16.19-6.73-22.62-0.67    c-6.43,6.06-6.73,16.19-0.67,22.62c0.25,0.27,6.32,6.7,12.67,13.25C40.85,260.18,43.96,263.31,46.29,265.58z"/>

        <path d="M457.84,217.49c-3.06-3.06-7.29-4.77-11.6-4.7c-2.58,0.04-4.77,0.62-6.74,1.58    c-0.29,0.13-0.56,0.29-0.84,0.44c-0.04,0.02-0.09,0.05-0.13,0.07c-0.65,0.36-1.28,0.76-1.87,1.2c-2.08,1.49-4,3.36-6.05,5.36    c-2.33,2.27-5.43,5.41-9.22,9.31c-6.35,6.55-12.42,12.98-12.67,13.25c-6.06,6.43-5.76,16.56,0.67,22.62    c6.38,6.02,16.41,5.76,22.48-0.54c-5.24,93.14-82.66,167.31-177.09,167.31c-78.34,0-146.47-50.24-169.53-125.02    c-2.6-8.44-11.56-13.18-20.01-10.57c-8.44,2.6-13.18,11.56-10.57,20.01c12.91,41.85,39.42,79.44,74.63,105.84    c36.43,27.31,79.82,41.75,125.48,41.75c111.2,0,202.42-87.14,208.99-196.72l0.88,0.88c3.12,3.12,7.22,4.69,11.31,4.69    s8.19-1.56,11.31-4.69c6.25-6.25,6.25-16.38,0-22.63L457.84,217.49z"/>

        </g>

        </g>

</svg>
);

export const ArrowDropUp = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 5" width={props.width || '10'} height={props.height || '5'}>
        <path d="M0,5L5,0l5,5H0Z" fill={props.fill || '#ced4da'} style={props.pathStyle} />
    </svg>
);

export const ArrowDropDown = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 5" width={props.width || '10'} height={props.height || '5'}>
        <path d="M0,0L5,5,10,0H0Z" fill={props.fill || '#ced4da'} style={props.pathStyle} />
    </svg>
);

export const SmsIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23.39 23.39"
        width={props.width || 20}
        height={props.height || 20}>
        <path
            fill={props.fill || '#0070ce'}
            d="M21.05,0H2.34C1.05,0,0,1.05,0,2.34V23.39l4.68-4.68H21.05c1.29,0,2.34-1.05,2.34-2.34V2.34c0-1.29-1.05-2.34-2.34-2.34Zm0,16.37H3.71l-1.37,1.37V2.34H21.05v14.03ZM5.85,8.19h2.34v2.34h-2.34v-2.34Zm9.36,0h2.34v2.34h-2.35v-2.34Zm-4.67,0h2.34v2.34h-2.34v-2.34Z"
        />
    </svg>
);

export const MaterialEmailIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24.27 19.42"
        width={props.width || 20}
        height={props.height || 20}>
        <path
            fill={props.fill || '#0070ce'}
            d="M24.27,2.43c0-1.34-1.09-2.42-2.43-2.43H2.43C1.09,0,0,1.09,0,2.43v14.56c0,1.34,1.09,2.42,2.43,2.43H21.84c1.34,0,2.42-1.09,2.43-2.43V2.43Zm-2.43,0l-9.71,6.07L2.43,2.43H21.84Zm0,14.56H2.43V4.85l9.71,6.07,9.71-6.07v12.14Z"
        />
    </svg>
);

export const MobilePhoneIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14.88 25.18"
        width={props.width || 20}
        height={props.height || 20}>
        <path
            fill={props.fill || '#0070ce'}
            d="M12.02,0H2.86C1.28,0,0,1.28,0,2.86V22.32c0,1.58,1.28,2.86,2.86,2.86H12.02c1.58,0,2.86-1.28,2.86-2.86V2.86c0-1.58-1.28-2.86-2.86-2.86ZM7.44,24.03c-.95,0-1.72-.77-1.72-1.72s.77-1.72,1.72-1.72,1.72,.77,1.72,1.72c0,.95-.76,1.72-1.71,1.72h0Zm5.15-4.58H2.29V3.43H12.59V19.45Z"
        />
    </svg>
);

export const BugIcon = (props) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 448 384"
        width={props.width || 25}
        height={props.height || 25}>
            <path style={{fill: 'none', stroke: props.stroke || '#0070CE', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: props.strokeWidth || 32}} d="M338,282c28.89,23.52,46,46.07,46,86M110,282c-28.89,23.52-46,46.06-46,86M352,112c28.89-23.52,32-56.07,32-96M96,110c-28.89-23.52-32-54.06-32-94M432,192.13h-80m-256,0H16M224,96V352"/>
            <path style={{fill: 'none', stroke: props.stroke || '#0070CE', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: props.strokeWidth || 32}} d="M224,352h0c-70.4,0-128-57.6-128-128V127.93c0-65.07,57.6-96,128-96h0c70.4,0,128,25.6,128,96v96.07c0,70.4-57.6,128-128,128Z"/>
    </svg>
)

export const EmojiFlags = (props) => (
    <svg
        width={props.height || 20}
        height={props.height || 20}
        viewBox="0 0 16 20"
        style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: 1.5 }}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve">
        <g transform="matrix(1,0,0,1,-4.65988,-2.5006)">
            <g>
                <g transform="matrix(1,0,0,1,0.0574852,0.0574852)">
                    <path
                        d="M5.953,20.953L5.953,3.966"
                        style={{ fill: 'none', stroke: props.color || '#006DF0', strokeWidth: 1 }}
                    />
                </g>
                <g transform="matrix(1,0,0,1,0.0862273,-0.172455)">
                    <circle cx="5.925" cy="4.024" r="1.351" style={{ fill: props.color || '#006DF0' }} />
                </g>
                <g transform="matrix(1,0,0,1,0,0.201198)">
                    <path
                        d="M6.011,7.818L12.478,7.818L13.455,9.801L18.859,9.801L18.859,11.123L18.887,16.153L18.859,17.849L13.455,17.849L12.478,15.866L6.011,15.866"
                        style={{
                            fill: 'none',
                            stroke: props.color || '#006DF0',
                            strokeWidth: 1,
                            strokeLinejoin: 'miter'
                        }}
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const ImageUploadIllustration = props => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 665.21 580.49"
        width={props.height || 100}
        height={props.height || 100}>
        <rect style={{fill: !props.darkTheme ? '#e6e6e6' : '#ffffffcc'}} x="-15.56" y="246.54" width="758.58" height="4.8" transform="translate(-75.39 286.92) rotate(-39.33)"/>
        <rect style={{fill: !props.darkTheme ? '#e6e6e6' : '#ffffffcc'}} x="361.33" y="-129.91" width="4.8" height="760.1" transform="translate(-60.63 371.76) rotate(-50.51)"/>
        <path style={{fill: !props.darkTheme ? '#3f3d56' : '#fff'}} d="M60.73,479.75V16.79c.01-9.27,7.52-16.78,16.79-16.79H648.42c9.27,.01,16.78,7.52,16.79,16.79V479.75c-.01,9.27-7.52,16.78-16.79,16.79H77.52c-9.27-.01-16.78-7.52-16.79-16.79ZM77.52,4.8c-6.62,0-11.99,5.37-11.99,11.99V479.75c0,6.62,5.37,11.99,11.99,11.99H648.42c6.62,0,11.99-5.37,11.99-11.99V16.79c0-6.62-5.37-11.99-11.99-11.99H77.52Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M0,563.7V100.75c.01-9.27,7.52-16.78,16.79-16.79H587.69c9.27,.01,16.78,7.52,16.79,16.79v462.96c-.01,9.27-7.52,16.78-16.79,16.79H16.79c-9.27-.01-16.78-7.52-16.79-16.79Z"/>
        <path style={{fill: '#fff'}} d="M237.11,466.55h291.46c.36,0,.73-.02,1.09-.09l-137.85-238.77c-2.62-4.64-8.51-6.27-13.15-3.65-1.52,.86-2.79,2.12-3.65,3.65l-92.51,160.23-4.43,7.67-40.96,70.96Z"/>
        <polygon style={{isolation: 'isolate', opacity: .2}} points="237.11 466.55 336.62 466.55 287.77 395.6 284.25 390.49 282.49 387.93 278.06 395.6 237.11 466.55"/>
        <path style={{fill: '#fff'}} d="M74.82,466.55h252.09l-48.85-70.96-3.52-5.11-63.66-92.47c-4.43-5.56-12.54-6.48-18.1-2.05-.36,.28-.7,.58-1.02,.9-.33,.36-.64,.74-.92,1.14l-116.03,168.54Z"/>
        <circle style={{fill: '#fff'}} cx="264.82" cy="241.07" r="43.18"/>
        <rect style={{fill: '#3f3d56'}} x="520.52" y="117.54" width="52.77" height="52.77"/>
    </svg>
);

export const FacilityIllustration = props => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 904.73 1204.83"
        width={props.width || 900}
        height={props.height || 1200}>
        <path style={{fill: props.fill || '#0070ce'}} d="M902.67,1054.37l-.03,19.19c0,4.68-2.53,8.95-5.64,9.55l-513.49,98.6c-7.27,1.4-13.2-3.32-13.19-10.54l.05-29.63c.01-7.22,5.97-14,13.24-15.12l513.45-79.64c3.11-.48,5.62,2.92,5.61,7.59Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M902.95,1008.08l-.03,19.19c0,4.68-2.52,8.83-5.64,9.28l-513.18,74.29c-7.26,1.05-13.19-3.94-13.18-11.16l.05-29.63c.01-7.22,5.96-13.71,13.23-14.49l513.15-55.34c3.11-.34,5.61,3.18,5.61,7.86Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M903.23,961.82l-.03,19.19c0,4.67-2.52,8.71-5.63,9.01l-512.88,50c-7.26,.71-13.18-4.56-13.17-11.78l.05-29.62c.01-7.22,5.96-13.42,13.22-13.86l512.84-31.06c3.11-.19,5.61,3.45,5.6,8.12Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M903.5,915.57l-.03,19.18c0,4.67-2.52,8.59-5.63,8.74l-512.58,25.73c-7.25,.36-13.18-5.19-13.16-12.4l.05-29.61c.01-7.21,5.96-13.14,13.21-13.24l512.54-6.8c3.11-.04,5.61,3.71,5.6,8.39Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M903.78,869.35l-.03,19.18c0,4.67-2.52,8.47-5.63,8.48l-512.28,1.49c-7.25,.02-13.17-5.81-13.15-13.02l.05-29.6c.01-7.21,5.95-12.86,13.2-12.61l512.24,17.42c3.11,.11,5.61,3.98,5.6,8.65Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.05,823.14l-.03,19.17c0,4.67-2.52,8.35-5.63,8.21l-511.97-22.72c-7.24-.32-13.16-6.43-13.14-13.64l.05-29.59c.01-7.21,5.95-12.57,13.19-11.98l511.94,41.63c3.11,.25,5.6,4.24,5.59,8.91Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.14,776.49l-.03,19.17c0,4.67-2.52,8.23-5.63,7.94l-511.93-47.16c-7.24-.67-13.16-7.06-13.14-14.27l.05-29.59c.01-7.21,5.95-12.29,13.19-11.35l511.89,66.07c3.11,.4,5.6,4.51,5.59,9.18Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.22,729.83l-.03,19.17c0,4.67-2.52,8.11-5.62,7.67l-511.88-71.61c-7.24-1.01-13.15-7.69-13.14-14.89l.05-29.59c.01-7.21,5.95-12,13.19-10.72l511.84,90.52c3.11,.55,5.6,4.78,5.59,9.45Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.31,683.18l-.03,19.17c0,4.67-2.52,7.99-5.62,7.41l-511.83-96.05c-7.24-1.36-13.15-8.31-13.14-15.52l.05-29.59c.01-7.21,5.95-11.72,13.19-10.1l511.8,114.96c3.11,.7,5.6,5.05,5.59,9.72Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.39,636.53l-.03,19.17c0,4.67-2.52,7.87-5.62,7.14l-511.79-120.49c-7.24-1.7-13.15-8.94-13.14-16.15l.05-29.59c.01-7.21,5.95-11.44,13.19-9.47l511.75,139.4c3.11,.85,5.6,5.31,5.59,9.99Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.48,589.88l-.03,19.17c0,4.67-2.52,7.75-5.62,6.87l-511.74-144.93c-7.24-2.05-13.15-9.57-13.14-16.78l.05-29.59c.01-7.21,5.94-11.16,13.18-8.84l511.7,163.84c3.1,.99,5.6,5.58,5.59,10.25Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.56,543.23l-.03,19.17c0,4.67-2.52,7.63-5.62,6.6l-511.69-169.38c-7.24-2.4-13.15-10.2-13.14-17.41l.05-29.59c.01-7.21,5.94-10.87,13.18-8.21l511.65,188.28c3.1,1.14,5.6,5.85,5.59,10.52Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.65,496.57l-.03,19.17c0,4.67-2.52,7.51-5.62,6.33l-511.64-193.82c-7.24-2.74-13.15-10.83-13.14-18.04l.05-29.59c.01-7.21,5.94-10.59,13.18-7.58l511.61,212.72c3.1,1.29,5.6,6.12,5.59,10.79Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M904.73,449.92l-.03,19.17c0,4.67-2.52,7.39-5.62,6.07l-511.6-218.26c-7.24-3.09-13.15-11.46-13.13-18.67l.05-29.59c.01-7.21,5.94-10.31,13.18-6.95l511.56,237.16c3.1,1.44,5.6,6.39,5.59,11.06Z"/>
        <path style={{fill: props.fill || '#0070ce'}} d="M0,1204.4c.35-13.18,.99-26.35,.99-39.53,.1-334.71,.01-669.43-.26-1004.13-.03-17.16,4.88-26.05,20.45-33.62,54.41-26.47,108.01-54.6,161.87-82.2,5.37-2.75-2.34,.92,27.66-15.08,41-20,29.49-14.08,50-25,9.86-6.2,22.58-6.37,32.83-.83,197.19,94.52,394.52,188.73,592,282.64,1.45,.55,2.88,1.18,4.26,1.88,5.52,3.45,16.61,4.53,13.11,13.08-4.03,9.85-12.21,1.4-17.58-1.04-37.4-16.99-74.64-34.32-111.73-51.99C616.62,174.08,459.67,99.52,302.75,24.9c-25.95-12.32-26.07-12.24-26.07,16.54-.02,374.46-.03,748.93-.03,1123.39,0,39.97-.11,40.04-38.95,39.99-79.23-.09-158.46-.23-237.7-.42"/>
    </svg>
);

export const CompanyIllustrationWizard = props => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 392 409"
        width={props.width || 392}
        height={props.height || 409}
        style={{opacity: props.opacity || 1}}>
        <polygon style={{opacity: .1}} points=".21 409.85 .21 0 392.21 204.93 392.21 409.03 .21 409.85"/>
        <path style={{opacity: .11}} d="M360.32,247.71l9.83,3.71v-26.64l-9.83-4.36v27.29Z"/>
        <path style={{opacity: .11}} d="M325.93,236.24l11.47,4.3v-28.86l-11.46-5.03v29.59Z"/>
        <path style={{opacity: .11}} d="M288.26,221.5l13.1,4.93v-31.14l-13.1-5.77v31.98Z"/>
        <path style={{opacity: .11}} d="M242.39,203.48l16.38,6.18v-32.39l-16.38-7.19v33.39Z"/>
        <path style={{opacity: .11}} d="M186.71,182.19l19.65,7.43v-35.26l-19.65-8.62v36.46Z"/>
        <path style={{opacity: .11}} d="M119.57,157.62l22.93,8.63v-39.75l-22.93-10.05v41.17Z"/>
        <path style={{opacity: .11}} d="M360.32,301.75l9.83,2.47v-27.05l-9.83-3.11v27.69Z"/>
        <path style={{opacity: .11}} d="M325.93,293.56l11.47,2.87v-29.08l-11.47-3.62v29.82Z"/>
        <path style={{opacity: .11}} d="M288.26,283.74l13.1,3.29v-31.14l-13.1-4.13v31.98Z"/>
        <path style={{opacity: .11}} d="M242.39,272.27l16.38,4.11v-33.59l-16.38-5.15v34.63Z"/>
        <path style={{opacity: .11}} d="M186.71,257.53l19.65,4.96v-36.08l-19.65-6.18v37.3Z"/>
        <path style={{opacity: .11}} d="M119.57,241.15l24.57,6.18v-40.57l-24.57-7.73v42.13Z"/>
        <path style={{opacity: .11}} d="M34.38,219.86l29.48,7.41v-45.09l-29.48-9.25v46.92Z"/>
        <path style={{opacity: .11}} d="M34.38,313.22l29.48,3.75v-44.7l-29.48-5.57v46.52Z"/>
        <path style={{opacity: .11}} d="M360.32,354.17l9.83,1.26v-25.85l-9.83-1.87v26.45Z"/>
        <path style={{opacity: .11}} d="M325.93,350.89l11.47,1.45v-27.65l-11.46-2.15v28.36Z"/>
        <path style={{opacity: .11}} d="M288.26,345.98l13.1,1.66v-31.14l-13.1-2.49v31.97Z"/>
        <path style={{opacity: .11}} d="M242.39,339.43l16.38,2.09v-33.21l-16.38-3.11v34.23Z"/>
        <path style={{opacity: .11}} d="M186.71,332.87l19.65,2.49v-36.89l-19.65-3.74v38.13Z"/>
        <path style={{opacity: .11}} d="M119.57,324.69l24.57,3.11v-40.79l-24.57-4.67v42.35Z"/>
        <path style={{opacity: .11}} d="M62.24,136.33l-29.48-11.12v-46.21l29.48,12.93v44.4Z"/>
        <path style={{opacity: .11}} d="M204.73,409.75l31.93,.05,31.94,.05v-49.46l-31.94-3.11-31.93-3.11v55.59Z"/>
    </svg>
)


export const CompanyIllustration = (props) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 257 131.76"
        width={props.width || 629}
        height={props.height || 329}
        style={{opacity: props.opacity || 1}}>
            <path style={{fill: '#f2f2f2'}} d="M254.8,65.75v65.75H2.32V65.75L128.56,0l.26,.14,125.98,65.61Z"/>
            <path style={{isolation: 'isolate', opacity: 0.1}} d="M254.8,65.75v65.75h-125.98V.14l125.98,65.61Z"/>
            <path style={{fill: '#3f3d56'}} d="M117.78,40.24l-9.47,3.58v-14.09l9.47-4.15v14.67Z"/>
            <path style={{fill: '#3f3d56'}} d="M13.11,79.69l-3.16,1.19v-8.56l3.16-1.4v8.76Z"/>
            <path style={{fill: '#3f3d56'}} d="M24.15,76.01l-3.68,1.38v-9.27l3.68-1.62v9.5Z"/>
            <path style={{fill: '#3f3d56'}} d="M36.25,71.27l-4.21,1.58v-10l4.21-1.85v10.27Z"/>
            <path style={{fill: '#3f3d56'}} d="M50.98,65.49l-5.26,1.98v-10.4l5.26-2.31v10.72Z"/>
            <path style={{fill: '#3f3d56'}} d="M68.86,58.65l-6.31,2.39v-11.33l6.31-2.77v11.71Z"/>
            <path style={{fill: '#3f3d56'}} d="M90.43,50.76l-7.36,2.77v-12.77l7.36-3.23v13.22Z"/>
            <path style={{fill: '#3f3d56'}} d="M13.11,97.05l-3.16,.79v-8.69l3.16-1v8.89Z"/>
            <path style={{fill: '#3f3d56'}} d="M24.15,94.42l-3.68,.92v-9.34l3.68-1.16v9.58Z"/>
            <path style={{fill: '#3f3d56'}} d="M36.25,91.26l-4.21,1.06v-10l4.21-1.33v10.27Z"/>
            <path style={{fill: '#3f3d56'}} d="M50.98,87.58l-5.26,1.32v-10.79l5.26-1.66v11.12Z"/>
            <path style={{fill: '#3f3d56'}} d="M68.86,82.84l-6.31,1.59v-11.59l6.31-1.98v11.98Z"/>
            <path style={{fill: '#3f3d56'}} d="M90.43,77.58l-7.89,1.98v-13.03l7.89-2.48v13.53Z"/>
            <path style={{fill: '#3f3d56'}} d="M117.78,70.75l-9.47,2.38v-14.48l9.47-2.97v15.07Z"/>
            <path style={{fill: '#3f3d56'}} d="M117.78,100.73l-9.47,1.21v-14.36l9.47-1.79v14.94Z"/>
            <path style={{fill: '#3f3d56'}} d="M13.11,113.88l-3.16,.41v-8.3l3.16-.6v8.49Z"/>
            <path style={{fill: '#3f3d56'}} d="M24.15,112.83l-3.68,.46v-8.88l3.68-.69v9.11Z"/>
            <path style={{fill: '#3f3d56'}} d="M36.25,111.25l-4.21,.53v-10l4.21-.8v10.27Z"/>
            <path style={{fill: '#3f3d56'}} d="M50.98,109.14l-5.26,.67v-10.66l5.26-1v10.99Z"/>
            <path style={{fill: '#3f3d56'}} d="M68.86,107.04l-6.31,.8v-11.85l6.31-1.2v12.25Z"/>
            <path style={{fill: '#3f3d56'}} d="M90.43,104.41l-7.89,1v-13.1l7.89-1.5v13.6Z"/>
            <path style={{fill: '#3f3d56'}} d="M244.55,79.69l3.16,1.19v-8.56l-3.16-1.4v8.76Z"/>
            <path style={{fill: '#3f3d56'}} d="M233.5,76.01l3.68,1.38v-9.27l-3.68-1.62v9.5Z"/>
            <path style={{fill: '#3f3d56'}} d="M221.4,71.27l4.21,1.58v-10l-4.21-1.85v10.27Z"/>
            <path style={{fill: '#3f3d56'}} d="M206.67,65.49l5.26,1.98v-10.4l-5.26-2.31v10.72Z"/>
            <path style={{fill: '#3f3d56'}} d="M188.79,58.65l6.31,2.39v-11.33l-6.31-2.77v11.71Z"/>
            <path style={{fill: '#3f3d56'}} d="M167.22,50.76l7.36,2.77v-12.77l-7.36-3.23v13.22Z"/>
            <path style={{fill: '#3f3d56'}} d="M244.55,97.05l3.16,.79v-8.69l-3.16-1v8.89Z"/>
            <path style={{fill: '#3f3d56'}} d="M233.5,94.42l3.68,.92v-9.34l-3.68-1.16v9.58Z"/>
            <path style={{fill: '#3f3d56'}} d="M221.4,91.26l4.21,1.06v-10l-4.21-1.33v10.27Z"/>
            <path style={{fill: '#3f3d56'}} d="M206.67,87.58l5.26,1.32v-10.79l-5.26-1.66v11.12Z"/>
            <path style={{fill: '#3f3d56'}} d="M188.79,82.84l6.31,1.59v-11.59l-6.31-1.98v11.98Z"/>
            <path style={{fill: '#3f3d56'}} d="M167.22,77.58l7.89,1.98v-13.03l-7.89-2.48v13.53Z"/>
            <path style={{fill: '#3f3d56'}} d="M139.87,70.75l9.47,2.38v-14.48l-9.47-2.97v15.07Z"/>
            <path style={{fill: '#3f3d56'}} d="M139.87,100.73l9.47,1.21v-14.36l-9.47-1.79v14.94Z"/>
            <path style={{fill: '#3f3d56'}} d="M244.55,113.88l3.16,.41v-8.3l-3.16-.6v8.49Z"/>
            <path style={{fill: '#3f3d56'}} d="M233.5,112.83l3.68,.46v-8.88l-3.68-.69v9.11Z"/>
            <path style={{fill: '#3f3d56'}} d="M221.4,111.25l4.21,.53v-10l-4.21-.8v10.27Z"/>
            <path style={{fill: '#3f3d56'}} d="M206.67,109.14l5.26,.67v-10.66l-5.26-1v10.99Z"/>
            <path style={{fill: '#3f3d56'}} d="M188.79,107.04l6.31,.8v-11.85l-6.31-1.2v12.25Z"/>
            <path style={{fill: '#3f3d56'}} d="M167.22,104.41l7.89,1v-13.1l-7.89-1.5v13.6Z"/>
            <path style={{fill: '#3f3d56'}} d="M148.81,43.92l-9.47-3.57v-14.84l9.47,4.15v14.26Z"/>
            <rect style={{fill: '#2f2e41'}} x="236.94" y="119.79" width=".77" height="12.35"/>
            <rect style={{fill: '#2f2e41'}} x="246.26" y="123.15" width=".55" height="8.75"/>
            <rect style={{fill: '#2f2e41'}} x="254.41" y="124.22" width=".48" height="7.69"/>
            <path style={{fill: '#3f3d56'}} d="M215.09,115.88v15.89l-10.26-.02-10.26-.02v-17.85l10.26,1,10.26,1Z"/>
            <path style={{fill: '#3f3d56'}} d="M42.56,131.76l20.51-.03v-17.85l-20.51,2v15.88Z"/>
            <path id="Path_436" style={{isolation: 'isolate', opacity: 0.1}} d="M215.09,115.88v15.89l-10.26-.02v-16.87l10.26,1Z"/>
            <rect style={{fill: '#2f2e41'}} x="126.46" y="117.3" width="1.05" height="14.73"/>
            <path style={{fill: props.fill || '#0070ce'}} d="M133.06,112.05c0,5.16-2.76,9.47-6.07,9.62-3.22,.14-5.77-3.72-5.77-8.62s6.29-18.37,6.29-18.37c0,0,5.54,12.21,5.54,17.37Z"/>
            <rect style={{fill: '#2f2e41'}} x="3.12" y="122.02" width=".63" height="8.78"/>
            <path style={{fill: props.fill || '#0070ce'}} d="M7.06,118.89c0,3.08-1.64,5.65-3.62,5.73-1.92,.09-3.44-2.22-3.44-5.14s3.76-10.96,3.76-10.96c0,0,3.31,7.29,3.31,10.36Z"/>
            <path style={{fill: props.fill || '#0070ce'}} d="M241.58,120.28c0,2.93-1.84,5.22-4.24,5.1-2.55-.12-4.73-2.87-4.73-6.13s4.73-11.42,4.73-11.42c0,0,4.24,9.53,4.24,12.45Z"/>
            <path style={{fill: props.fill || '#0070ce'}} d="M249.54,123.5c0,2.07-1.31,3.7-3.01,3.61-1.8-.09-3.35-2.03-3.35-4.34s3.35-8.09,3.35-8.09c0,0,3.01,6.75,3.01,8.82Z"/>
            <path style={{fill: props.fill || '#0070ce'}} d="M257.29,124.52c0,1.82-1.15,3.25-2.64,3.18-1.59-.07-2.95-1.79-2.95-3.82s2.95-7.11,2.95-7.11c0,0,2.64,5.93,2.64,7.75Z"/>
    </svg>
);

export const ImageIcon = (props) => 
<svg 
    width={props.width || 24}
    height={props.height || 20}
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 20">
    <path style={{fillRule: 'evenodd', fill: props.color || '#0070ce'}} d="M24,20H0V0H24V20ZM23,1H1V19H23V1Zm-1,16H3l4-7.49,3,3.05,5.01-7.56,6.99,12Zm-11.85-2.86l-2.91-2.96-2.57,4.82h15.59L14.96,6.89s-4.81,7.24-4.81,7.24ZM5.5,3c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5-2.5-1.12-2.5-2.5,1.12-2.5,2.5-2.5Zm0,1c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5-1.5-.67-1.5-1.5,.67-1.5,1.5-1.5Z"/>
</svg>

export const SwitchIcon = (props) => 
<svg 
    width={props.width || 24}
    height={props.height || 24}
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 58.15 45.23">
    <path style={{fill: props.color || '#0070ce'}} d="M12.89,19.38L0,32.31l12.89,12.92v-9.69h22.65v-6.46H12.89v-9.69Zm45.26-6.46L45.26,0V9.69H22.61v6.46h22.65v9.69l12.89-12.92Z"/>
</svg>

export const QuestionMarkLogo = (props) => 
<svg xmlns="http://www.w3.org/2000/svg" height={props.height || 24} viewBox="0 0 20 20" width={props.height || 24} fill={props.fill || '#0070ce'}>
    <path d="m9,16h2v-2h-2v2ZM10,0C4.48,0,0,4.48,0,10s4.48,10,10,10,10-4.48,10-10S15.52,0,10,0Zm0,18c-4.41,0-8-3.59-8-8S5.59,2,10,2s8,3.59,8,8-3.59,8-8,8Zm0-14c-2.21,0-4,1.79-4,4h2c0-1.1.9-2,2-2s2,.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5,0-2.21-1.79-4-4-4Z"/>
</svg>
